(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-archive-post"]) return;
  try {
    
  (() => {
    const registry = window.__archivePostRegistry || new Map();
    const cache = window.__archivePostCache || new Map();
    window.__archivePostRegistry = registry;
    window.__archivePostCache = cache;

    const normalizeUrl = (url) => {
      const normalized = new URL(url, window.location.origin);
      normalized.hash = '';
      return `${normalized.pathname}${normalized.search}`;
    };

    const preloadImage = (src) => {
      if (!src) return Promise.resolve();

      return new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = src;

        if (image.complete) resolve();
      });
    };

    const parseArchivePayload = async (html, requestUrl) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const app = doc.querySelector('[data-archive-post-app]');
      const canvas = app ? app.querySelector('[data-archive-post-canvas]') : null;

      if (!app || !canvas) {
        throw new Error('Archive post canvas not found in response.');
      }

      const image = canvas.querySelector('.archive-post__image');
      const imageSrc = image ? image.getAttribute('src') : '';
      await preloadImage(imageSrc);

      return {
        url: normalizeUrl(requestUrl),
        title: doc.title,
        canvasHTML: canvas.innerHTML,
      };
    };

    const fetchArchivePayload = (url) => {
      const normalizedUrl = normalizeUrl(url);

      if (!cache.has(normalizedUrl)) {
        const request = window
          .fetch(normalizedUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load ${normalizedUrl}`);
            return response.text();
          })
          .then((html) => parseArchivePayload(html, normalizedUrl));

        cache.set(normalizedUrl, request);
      }

      return cache.get(normalizedUrl);
    };

    const fitHeadline = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const parent = heading.parentElement;
      if (!parent) return;

      const parentStyles = window.getComputedStyle(parent);
      const horizontalSafety = isMobile ? 24 : 56;
      const availableWidth =
        parent.clientWidth -
        parseFloat(parentStyles.paddingLeft || '0') -
        parseFloat(parentStyles.paddingRight || '0') -
        horizontalSafety;
      const section = heading.closest('.archive-post');
      const scene = heading.closest('.archive-post__scene');
      const sceneStyles = scene ? window.getComputedStyle(scene) : null;
      const verticalPadding =
        sceneStyles
          ? parseFloat(sceneStyles.paddingTop || '0') + parseFloat(sceneStyles.paddingBottom || '0')
          : 0;
      const sceneHeight = scene?.clientHeight || section?.clientHeight || window.innerHeight;
      const usableHeight = Math.max(0, sceneHeight - verticalPadding);
      const rootStyles = section ? window.getComputedStyle(section) : null;
      const desktopSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-desktop') || '220') : 220;
      const mobileSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-mobile') || '112') : 112;

      if (availableWidth <= 0) return;

      const lines = Array.from(heading.querySelectorAll('.archive-post__background-line'));
      const lineCount = Math.max(lines.length, 1);
      const letterSpacing = isMobile
        ? (lineCount <= 1 ? '0.02rem' : '0rem')
        : (lineCount <= 1 ? '1rem' : lineCount == 2 ? '0.28rem' : lineCount == 3 ? '0.14rem' : '0.08rem');
      heading.style.setProperty('--archive-post-background-letter-spacing', letterSpacing);
      const measureWidth = () => {
        if (!lines.length) return heading.scrollWidth;

        let widest = 0;
        lines.forEach((line) => {
          widest = Math.max(widest, Math.ceil(line.getBoundingClientRect().width));
        });
        return widest;
      };
      const measureHeight = () => Math.ceil(heading.getBoundingClientRect().height);
      const min = isMobile ? 12 : 10;

      if (!isMobile) {
        const max = Math.min(900, (usableHeight / lineCount) * 0.7, desktopSettingMax);
        const availableHeight = usableHeight * 0.82;
        const fits = () => measureWidth() <= availableWidth && measureHeight() <= availableHeight;
        let finalSize;

        if (lineCount <= 1) {
          let low = min;
          let high = max;
          let best = min;

          heading.style.fontSize = `${max}px`;

          while (high - low > 0.5) {
            const mid = (low + high) / 2;
            heading.style.fontSize = `${mid}px`;

            if (fits()) {
              best = mid;
              low = mid;
            } else {
              high = mid;
            }
          }

          finalSize = Math.max(min, Math.min(max, best));
        } else {
          const longestLineCharacters = lines.reduce((widest, line) => {
            const text = (line.textContent || '').trim();
            return Math.max(widest, text.length);
          }, 1);
          const sizeByHeight = availableHeight / (lineCount * 1.08);
          const sizeByWidth = availableWidth / Math.max(longestLineCharacters * 0.92, 1);
          finalSize = Math.max(min, Math.min(max, sizeByHeight, sizeByWidth));
        }

        finalSize *= 0.96;
        heading.style.fontSize = `${finalSize}px`;

        while (!fits() && finalSize > min) {
          finalSize -= 1;
          heading.style.fontSize = `${finalSize}px`;
        }

        return;
      }

      const baseSize = mobileSettingMax;
      const availableHeight = Math.max(72, Math.min(usableHeight * 0.22, 150));
      heading.style.fontSize = `${baseSize}px`;

      const widthAtBase = measureWidth();
      const heightAtBase = measureHeight();
      const widthScale = widthAtBase > 0 ? availableWidth / widthAtBase : 1;
      const heightScale = heightAtBase > 0 ? availableHeight / heightAtBase : 1;
      const fitScale = Math.min(1, widthScale, heightScale);
      let finalSize = Math.max(min, Math.floor(baseSize * fitScale * (lineCount > 1 ? 0.9 : 0.94)));
      heading.style.fontSize = `${finalSize}px`;

      while ((measureWidth() > availableWidth || measureHeight() > availableHeight) && finalSize > min) {
        finalSize -= 1;
        heading.style.fontSize = `${finalSize}px`;
      }
    };

    const fitAllHeadlines = (scope = document) => {
      scope.querySelectorAll('[data-archive-fit-text]').forEach((heading) => fitHeadline(heading));
    };

    const scheduleFitPasses = (scope = document, frames = 8) => {
      let remaining = frames;

      const tick = () => {
        fitAllHeadlines(scope);
        remaining -= 1;
        if (remaining > 0) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    let fitResizeRaf = null;
    const onFitResize = () => {
      if (fitResizeRaf) cancelAnimationFrame(fitResizeRaf);
      fitResizeRaf = requestAnimationFrame(() => scheduleFitPasses(document, 10));
    };

    const getSceneParts = (section) => ({
      bgTitle: section.querySelector('[data-archive-bg-title]'),
      imageShell: section.querySelector('[data-archive-image-shell]'),
      captionLines: section.querySelectorAll('[data-archive-caption-line]'),
      navButtons: section.querySelectorAll('[data-archive-nav]'),
    });

    const runIntro = (section, immediate = false) => {
      section.classList.remove('archive-post--pending');
      if (!window.gsap) return;

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const introTargets = [bgTitle, imageShell, ...captionLines, ...navButtons].filter(Boolean);
      if (!introTargets.length) return;

      const durationScale = immediate ? 0.001 : 1;

      window.gsap.set(bgTitle, { autoAlpha: 0, y: 64 });
      window.gsap.set(imageShell, { autoAlpha: 0, y: 40, scale: 0.9, transformOrigin: '50% 50%' });
      window.gsap.set([...captionLines, ...navButtons], { autoAlpha: 0, y: 20 });

      const timeline = window.gsap.timeline({ defaults: { overwrite: 'auto' } });
      timeline
        .to(bgTitle, {
          autoAlpha: 1,
          y: 0,
          duration: 1.75 * durationScale,
          ease: 'power4.out',
        })
        .to(
          imageShell,
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.2 * durationScale,
            ease: 'power3.out',
          },
          immediate ? 0 : 1.25
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9 * durationScale,
            ease: 'power2.out',
            stagger: 0.1,
          },
          immediate ? 0 : 1.35
        );
    };

    const runOutro = (section) => {
      if (!window.gsap) return Promise.resolve();

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const timeline = window.gsap.timeline({
        defaults: { overwrite: 'auto' },
      });

      timeline
        .to(
          imageShell,
          {
            autoAlpha: 0,
            scale: 0.92,
            duration: 0.78,
            ease: 'power2.inOut',
          },
          0.2
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 0,
            y: 14,
            duration: 0.56,
            ease: 'power2.inOut',
            stagger: 0.04,
          },
          0
        )
        .to(
          bgTitle,
          {
            autoAlpha: 0,
            y: -42,
            duration: 0.86,
            ease: 'power2.inOut',
          },
          0
        );

      return timeline.then ? timeline.then(() => {}) : new Promise((resolve) => timeline.eventCallback('onComplete', resolve));
    };

    const navigateToArticle = async (instance, targetUrl, shouldPushState = true) => {
      if (!instance || !targetUrl || instance.isTransitioning) return;

      instance.isTransitioning = true;

      try {
        await runOutro(instance.section);
        const payload = await fetchArchivePayload(targetUrl);

        instance.canvas.innerHTML = payload.canvasHTML;
        instance.section.dataset.currentUrl = payload.url;
        instance.section.classList.add('archive-post--pending');
        document.title = payload.title;

        if (shouldPushState) {
          window.history.pushState({ archivePostUrl: payload.url }, '', payload.url);
        }

        bindInstance(instance);
        scheduleFitPasses(instance.section, 10);
        runIntro(instance.section);

        if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
          window.ScrollTrigger.refresh();
        }
      } catch (error) {
        window.location.href = targetUrl;
      } finally {
        instance.isTransitioning = false;
      }
    };

    const bindInstance = (instance) => {
      const navLinks = instance.section.querySelectorAll('[data-archive-nav]');
      instance.navLinks = Array.from(navLinks);
        const imageTrigger = instance.section.querySelector('[data-archive-image-trigger]');
        const imageModal = instance.section.querySelector('[data-archive-image-modal]');
        const imageModalCloseButton = imageModal ? imageModal.querySelector('[data-archive-image-modal-close]') : null;
        let imageModalLastFocusedElement = null;

      if (instance.fitObserver) {
        instance.fitObserver.disconnect();
      }

      if ('ResizeObserver' in window) {
        const fitTarget = instance.section.querySelector('.archive-post__background-wrap');
        const scene = instance.section.querySelector('.archive-post__scene');
        instance.fitObserver = new ResizeObserver(() => {
          scheduleFitPasses(instance.section, 6);
        });

        if (fitTarget) instance.fitObserver.observe(fitTarget);
        if (scene && scene !== fitTarget) instance.fitObserver.observe(scene);
      }

      instance.navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        const prefetch = () => {
          fetchArchivePayload(href).catch(() => {});
        };

        link.addEventListener('mouseenter', prefetch);
        link.addEventListener('focus', prefetch);

        link.addEventListener('click', async (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          navigateToArticle(instance, href, true);
        });
      });

      if (imageTrigger && imageModal) {
        const openImageModal = () => {
          imageModalLastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          document.documentElement.classList.add('theme-archive-image-modal-open');
          document.body.classList.add('theme-archive-image-modal-open');

          if (typeof imageModal.showModal === 'function') {
            if (!imageModal.open) imageModal.showModal();
          } else {
            imageModal.setAttribute('open', 'open');
          }

          if (imageModalCloseButton) {
            requestAnimationFrame(() => imageModalCloseButton.focus());
          }
        };

        const closeImageModal = () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');

          if (imageModal.open && typeof imageModal.close === 'function') {
            imageModal.close();
            return;
          }

          imageModal.removeAttribute('open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        };

        imageTrigger.addEventListener('click', openImageModal);
        imageTrigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openImageModal();
        });

        if (imageModalCloseButton) {
          imageModalCloseButton.addEventListener('click', closeImageModal);
        }

        imageModal.addEventListener('click', (event) => {
          if (event.target === imageModal) closeImageModal();
        });

        imageModal.addEventListener('close', () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        });
      }

      const swipeTarget = instance.section.querySelector('[data-archive-image-shell]');
      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (swipeTarget) {
        let startX = 0;
        let startY = 0;
        let tracking = false;

        swipeTarget.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1 || instance.isTransitioning) return;
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            tracking = true;
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchend',
          (event) => {
            if (!tracking || event.changedTouches.length !== 1 || instance.isTransitioning) return;
            tracking = false;

            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            if (absX < 48 || absX <= absY * 1.2) return;

            if (deltaX < 0 && nextLink) {
              navigateToArticle(instance, nextLink.getAttribute('href'), true);
            } else if (deltaX > 0 && previousLink) {
              navigateToArticle(instance, previousLink.getAttribute('href'), true);
            }
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchcancel',
          () => {
            tracking = false;
          },
          { passive: true }
        );
      }
    };

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-archive-post-app]');

      sections.forEach((section) => {
        if (registry.has(section)) return;

        const canvas = section.querySelector('[data-archive-post-canvas]');
        if (!canvas) return;

        const instance = {
          section,
          canvas,
          isTransitioning: false,
          navLinks: [],
        };

        registry.set(section, instance);
        bindInstance(instance);
        scheduleFitPasses(section, 10);
        requestAnimationFrame(() => {
          scheduleFitPasses(section, 8);
          requestAnimationFrame(() => {
            scheduleFitPasses(section, 8);
          });
          runIntro(section);
        });
      });
    };

    const handlePopState = async () => {
      const instance = Array.from(registry.values())[0];
      if (!instance) return;

      const targetUrl = normalizeUrl(window.location.href);
      if (targetUrl === normalizeUrl(instance.section.dataset.currentUrl || '')) return;
      if (instance.isTransitioning) return;

      try {
        await navigateToArticle(instance, targetUrl, false);
      } catch (error) {
        window.location.reload();
        return;
      }
    };

    initialize(document);
    window.addEventListener('resize', onFitResize);
    window.addEventListener('orientationchange', onFitResize);

    const isTypingTarget = (target) => {
      if (!(target instanceof HTMLElement)) return false;
      if (target.isContentEditable) return true;
      return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
    };

    const isImageModalOpen = (instance) => {
      if (!instance?.section) return false;
      const modal = instance.section.querySelector('[data-archive-image-modal]');
      return Boolean(modal && modal.open);
    };

    const handleArrowNavigation = (event) => {
      if (event.defaultPrevented) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (isTypingTarget(event.target)) return;

      const instance = Array.from(registry.values())[0];
      if (!instance || instance.isTransitioning || isImageModalOpen(instance)) return;

      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (event.key === 'ArrowLeft' && previousLink) {
        event.preventDefault();
        navigateToArticle(instance, previousLink.getAttribute('href'), true);
      }

      if (event.key === 'ArrowRight' && nextLink) {
        event.preventDefault();
        navigateToArticle(instance, nextLink.getAttribute('href'), true);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleFitPasses(document, 12)).catch(() => {});
      if (typeof document.fonts.addEventListener === 'function') {
        document.fonts.addEventListener('loadingdone', () => scheduleFitPasses(document, 12));
      }
    }

    window.addEventListener('load', () => {
      scheduleFitPasses(document, 14);
      setTimeout(() => scheduleFitPasses(document, 10), 150);
      setTimeout(() => scheduleFitPasses(document, 10), 450);
    });

    if (!window.__archivePostPopstateBound) {
      window.addEventListener('popstate', handlePopState);
      window.__archivePostPopstateBound = true;
    }

    if (!window.__archivePostArrowNavBound) {
      document.addEventListener('keydown', handleArrowNavigation);
      window.__archivePostArrowNavBound = true;
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      fitAllHeadlines(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-archive-post-app]') || event.target;
      if (registry.has(section)) {
        const instance = registry.get(section);
        if (instance?.fitObserver) instance.fitObserver.disconnect();
        registry.delete(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-bronze-works-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry = window.__archivePostRegistry || new Map();
    const cache = window.__archivePostCache || new Map();
    window.__archivePostRegistry = registry;
    window.__archivePostCache = cache;

    const normalizeUrl = (url) => {
      const normalized = new URL(url, window.location.origin);
      normalized.hash = '';
      return `${normalized.pathname}${normalized.search}`;
    };

    const preloadImage = (src) => {
      if (!src) return Promise.resolve();

      return new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = src;

        if (image.complete) resolve();
      });
    };

    const parseArchivePayload = async (html, requestUrl) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const app = doc.querySelector('[data-archive-post-app]');
      const canvas = app ? app.querySelector('[data-archive-post-canvas]') : null;

      if (!app || !canvas) {
        throw new Error('Archive post canvas not found in response.');
      }

      const image = canvas.querySelector('.archive-post__image');
      const imageSrc = image ? image.getAttribute('src') : '';
      await preloadImage(imageSrc);

      return {
        url: normalizeUrl(requestUrl),
        title: doc.title,
        canvasHTML: canvas.innerHTML,
      };
    };

    const fetchArchivePayload = (url) => {
      const normalizedUrl = normalizeUrl(url);

      if (!cache.has(normalizedUrl)) {
        const request = window
          .fetch(normalizedUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load ${normalizedUrl}`);
            return response.text();
          })
          .then((html) => parseArchivePayload(html, normalizedUrl));

        cache.set(normalizedUrl, request);
      }

      return cache.get(normalizedUrl);
    };

    const fitHeadline = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const parent = heading.parentElement;
      if (!parent) return;

      const parentStyles = window.getComputedStyle(parent);
      const horizontalSafety = isMobile ? 24 : 56;
      const availableWidth =
        parent.clientWidth -
        parseFloat(parentStyles.paddingLeft || '0') -
        parseFloat(parentStyles.paddingRight || '0') -
        horizontalSafety;
      const section = heading.closest('.archive-post');
      const scene = heading.closest('.archive-post__scene');
      const sceneStyles = scene ? window.getComputedStyle(scene) : null;
      const verticalPadding =
        sceneStyles
          ? parseFloat(sceneStyles.paddingTop || '0') + parseFloat(sceneStyles.paddingBottom || '0')
          : 0;
      const sceneHeight = scene?.clientHeight || section?.clientHeight || window.innerHeight;
      const usableHeight = Math.max(0, sceneHeight - verticalPadding);
      const rootStyles = section ? window.getComputedStyle(section) : null;
      const desktopSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-desktop') || '220') : 220;
      const mobileSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-mobile') || '112') : 112;

      if (availableWidth <= 0) return;

      const lines = Array.from(heading.querySelectorAll('.archive-post__background-line'));
      const lineCount = Math.max(lines.length, 1);
      const letterSpacing = isMobile
        ? (lineCount <= 1 ? '0.02rem' : '0rem')
        : (lineCount <= 1 ? '1rem' : lineCount == 2 ? '0.28rem' : lineCount == 3 ? '0.14rem' : '0.08rem');
      heading.style.setProperty('--archive-post-background-letter-spacing', letterSpacing);
      const measureWidth = () => {
        if (!lines.length) return heading.scrollWidth;

        let widest = 0;
        lines.forEach((line) => {
          widest = Math.max(widest, Math.ceil(line.getBoundingClientRect().width));
        });
        return widest;
      };
      const measureHeight = () => Math.ceil(heading.getBoundingClientRect().height);
      const min = isMobile ? 12 : 10;

      if (!isMobile) {
        const max = Math.min(900, (usableHeight / lineCount) * 0.7, desktopSettingMax);
        const availableHeight = usableHeight * 0.82;
        const fits = () => measureWidth() <= availableWidth && measureHeight() <= availableHeight;
        let finalSize;

        if (lineCount <= 1) {
          let low = min;
          let high = max;
          let best = min;

          heading.style.fontSize = `${max}px`;

          while (high - low > 0.5) {
            const mid = (low + high) / 2;
            heading.style.fontSize = `${mid}px`;

            if (fits()) {
              best = mid;
              low = mid;
            } else {
              high = mid;
            }
          }

          finalSize = Math.max(min, Math.min(max, best));
        } else {
          const longestLineCharacters = lines.reduce((widest, line) => {
            const text = (line.textContent || '').trim();
            return Math.max(widest, text.length);
          }, 1);
          const sizeByHeight = availableHeight / (lineCount * 1.08);
          const sizeByWidth = availableWidth / Math.max(longestLineCharacters * 0.92, 1);
          finalSize = Math.max(min, Math.min(max, sizeByHeight, sizeByWidth));
        }

        finalSize *= 0.96;
        heading.style.fontSize = `${finalSize}px`;

        while (!fits() && finalSize > min) {
          finalSize -= 1;
          heading.style.fontSize = `${finalSize}px`;
        }

        return;
      }

      const baseSize = mobileSettingMax;
      const availableHeight = Math.max(72, Math.min(usableHeight * 0.22, 150));
      heading.style.fontSize = `${baseSize}px`;

      const widthAtBase = measureWidth();
      const heightAtBase = measureHeight();
      const widthScale = widthAtBase > 0 ? availableWidth / widthAtBase : 1;
      const heightScale = heightAtBase > 0 ? availableHeight / heightAtBase : 1;
      const fitScale = Math.min(1, widthScale, heightScale);
      let finalSize = Math.max(min, Math.floor(baseSize * fitScale * (lineCount > 1 ? 0.9 : 0.94)));
      heading.style.fontSize = `${finalSize}px`;

      while ((measureWidth() > availableWidth || measureHeight() > availableHeight) && finalSize > min) {
        finalSize -= 1;
        heading.style.fontSize = `${finalSize}px`;
      }
    };

    const fitAllHeadlines = (scope = document) => {
      scope.querySelectorAll('[data-archive-fit-text]').forEach((heading) => fitHeadline(heading));
    };

    const scheduleFitPasses = (scope = document, frames = 8) => {
      let remaining = frames;

      const tick = () => {
        fitAllHeadlines(scope);
        remaining -= 1;
        if (remaining > 0) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    let fitResizeRaf = null;
    const onFitResize = () => {
      if (fitResizeRaf) cancelAnimationFrame(fitResizeRaf);
      fitResizeRaf = requestAnimationFrame(() => scheduleFitPasses(document, 10));
    };

    const getSceneParts = (section) => ({
      bgTitle: section.querySelector('[data-archive-bg-title]'),
      imageShell: section.querySelector('[data-archive-image-shell]'),
      captionLines: section.querySelectorAll('[data-archive-caption-line]'),
      navButtons: section.querySelectorAll('[data-archive-nav]'),
    });

    const runIntro = (section, immediate = false) => {
      section.classList.remove('archive-post--pending');
      if (!window.gsap) return;

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const introTargets = [bgTitle, imageShell, ...captionLines, ...navButtons].filter(Boolean);
      if (!introTargets.length) return;

      const durationScale = immediate ? 0.001 : 1;

      window.gsap.set(bgTitle, { autoAlpha: 0, y: 64 });
      window.gsap.set(imageShell, { autoAlpha: 0, y: 40, scale: 0.9, transformOrigin: '50% 50%' });
      window.gsap.set([...captionLines, ...navButtons], { autoAlpha: 0, y: 20 });

      const timeline = window.gsap.timeline({ defaults: { overwrite: 'auto' } });
      timeline
        .to(bgTitle, {
          autoAlpha: 1,
          y: 0,
          duration: 1.75 * durationScale,
          ease: 'power4.out',
        })
        .to(
          imageShell,
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.2 * durationScale,
            ease: 'power3.out',
          },
          immediate ? 0 : 1.25
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9 * durationScale,
            ease: 'power2.out',
            stagger: 0.1,
          },
          immediate ? 0 : 1.35
        );
    };

    const runOutro = (section) => {
      if (!window.gsap) return Promise.resolve();

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const timeline = window.gsap.timeline({
        defaults: { overwrite: 'auto' },
      });

      timeline
        .to(
          imageShell,
          {
            autoAlpha: 0,
            scale: 0.92,
            duration: 0.78,
            ease: 'power2.inOut',
          },
          0.2
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 0,
            y: 14,
            duration: 0.56,
            ease: 'power2.inOut',
            stagger: 0.04,
          },
          0
        )
        .to(
          bgTitle,
          {
            autoAlpha: 0,
            y: -42,
            duration: 0.86,
            ease: 'power2.inOut',
          },
          0
        );

      return timeline.then ? timeline.then(() => {}) : new Promise((resolve) => timeline.eventCallback('onComplete', resolve));
    };

    const navigateToArticle = async (instance, targetUrl, shouldPushState = true) => {
      if (!instance || !targetUrl || instance.isTransitioning) return;

      instance.isTransitioning = true;

      try {
        await runOutro(instance.section);
        const payload = await fetchArchivePayload(targetUrl);

        instance.canvas.innerHTML = payload.canvasHTML;
        instance.section.dataset.currentUrl = payload.url;
        instance.section.classList.add('archive-post--pending');
        document.title = payload.title;

        if (shouldPushState) {
          window.history.pushState({ archivePostUrl: payload.url }, '', payload.url);
        }

        bindInstance(instance);
        scheduleFitPasses(instance.section, 10);
        runIntro(instance.section);

        if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
          window.ScrollTrigger.refresh();
        }
      } catch (error) {
        window.location.href = targetUrl;
      } finally {
        instance.isTransitioning = false;
      }
    };

    const bindInstance = (instance) => {
      const navLinks = instance.section.querySelectorAll('[data-archive-nav]');
      instance.navLinks = Array.from(navLinks);
        const imageTrigger = instance.section.querySelector('[data-archive-image-trigger]');
        const imageModal = instance.section.querySelector('[data-archive-image-modal]');
        const imageModalCloseButton = imageModal ? imageModal.querySelector('[data-archive-image-modal-close]') : null;
        let imageModalLastFocusedElement = null;

      if (instance.fitObserver) {
        instance.fitObserver.disconnect();
      }

      if ('ResizeObserver' in window) {
        const fitTarget = instance.section.querySelector('.archive-post__background-wrap');
        const scene = instance.section.querySelector('.archive-post__scene');
        instance.fitObserver = new ResizeObserver(() => {
          scheduleFitPasses(instance.section, 6);
        });

        if (fitTarget) instance.fitObserver.observe(fitTarget);
        if (scene && scene !== fitTarget) instance.fitObserver.observe(scene);
      }

      instance.navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        const prefetch = () => {
          fetchArchivePayload(href).catch(() => {});
        };

        link.addEventListener('mouseenter', prefetch);
        link.addEventListener('focus', prefetch);

        link.addEventListener('click', async (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          navigateToArticle(instance, href, true);
        });
      });

      if (imageTrigger && imageModal) {
        const openImageModal = () => {
          imageModalLastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          document.documentElement.classList.add('theme-archive-image-modal-open');
          document.body.classList.add('theme-archive-image-modal-open');

          if (typeof imageModal.showModal === 'function') {
            if (!imageModal.open) imageModal.showModal();
          } else {
            imageModal.setAttribute('open', 'open');
          }

          if (imageModalCloseButton) {
            requestAnimationFrame(() => imageModalCloseButton.focus());
          }
        };

        const closeImageModal = () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');

          if (imageModal.open && typeof imageModal.close === 'function') {
            imageModal.close();
            return;
          }

          imageModal.removeAttribute('open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        };

        imageTrigger.addEventListener('click', openImageModal);
        imageTrigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openImageModal();
        });

        if (imageModalCloseButton) {
          imageModalCloseButton.addEventListener('click', closeImageModal);
        }

        imageModal.addEventListener('click', (event) => {
          if (event.target === imageModal) closeImageModal();
        });

        imageModal.addEventListener('close', () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        });
      }

      const swipeTarget = instance.section.querySelector('[data-archive-image-shell]');
      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (swipeTarget) {
        let startX = 0;
        let startY = 0;
        let tracking = false;

        swipeTarget.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1 || instance.isTransitioning) return;
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            tracking = true;
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchend',
          (event) => {
            if (!tracking || event.changedTouches.length !== 1 || instance.isTransitioning) return;
            tracking = false;

            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            if (absX < 48 || absX <= absY * 1.2) return;

            if (deltaX < 0 && nextLink) {
              navigateToArticle(instance, nextLink.getAttribute('href'), true);
            } else if (deltaX > 0 && previousLink) {
              navigateToArticle(instance, previousLink.getAttribute('href'), true);
            }
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchcancel',
          () => {
            tracking = false;
          },
          { passive: true }
        );
      }
    };

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-archive-post-app]');

      sections.forEach((section) => {
        if (registry.has(section)) return;

        const canvas = section.querySelector('[data-archive-post-canvas]');
        if (!canvas) return;

        const instance = {
          section,
          canvas,
          isTransitioning: false,
          navLinks: [],
        };

        registry.set(section, instance);
        bindInstance(instance);
        scheduleFitPasses(section, 10);
        requestAnimationFrame(() => {
          scheduleFitPasses(section, 8);
          requestAnimationFrame(() => {
            scheduleFitPasses(section, 8);
          });
          runIntro(section);
        });
      });
    };

    const handlePopState = async () => {
      const instance = Array.from(registry.values())[0];
      if (!instance) return;

      const targetUrl = normalizeUrl(window.location.href);
      if (targetUrl === normalizeUrl(instance.section.dataset.currentUrl || '')) return;
      if (instance.isTransitioning) return;

      try {
        await navigateToArticle(instance, targetUrl, false);
      } catch (error) {
        window.location.reload();
        return;
      }
    };

    initialize(document);
    window.addEventListener('resize', onFitResize);
    window.addEventListener('orientationchange', onFitResize);

    const isTypingTarget = (target) => {
      if (!(target instanceof HTMLElement)) return false;
      if (target.isContentEditable) return true;
      return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
    };

    const isImageModalOpen = (instance) => {
      if (!instance?.section) return false;
      const modal = instance.section.querySelector('[data-archive-image-modal]');
      return Boolean(modal && modal.open);
    };

    const handleArrowNavigation = (event) => {
      if (event.defaultPrevented) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (isTypingTarget(event.target)) return;

      const instance = Array.from(registry.values())[0];
      if (!instance || instance.isTransitioning || isImageModalOpen(instance)) return;

      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (event.key === 'ArrowLeft' && previousLink) {
        event.preventDefault();
        navigateToArticle(instance, previousLink.getAttribute('href'), true);
      }

      if (event.key === 'ArrowRight' && nextLink) {
        event.preventDefault();
        navigateToArticle(instance, nextLink.getAttribute('href'), true);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleFitPasses(document, 12)).catch(() => {});
      if (typeof document.fonts.addEventListener === 'function') {
        document.fonts.addEventListener('loadingdone', () => scheduleFitPasses(document, 12));
      }
    }

    window.addEventListener('load', () => {
      scheduleFitPasses(document, 14);
      setTimeout(() => scheduleFitPasses(document, 10), 150);
      setTimeout(() => scheduleFitPasses(document, 10), 450);
    });

    if (!window.__archivePostPopstateBound) {
      window.addEventListener('popstate', handlePopState);
      window.__archivePostPopstateBound = true;
    }

    if (!window.__archivePostArrowNavBound) {
      document.addEventListener('keydown', handleArrowNavigation);
      window.__archivePostArrowNavBound = true;
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      fitAllHeadlines(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-archive-post-app]') || event.target;
      if (registry.has(section)) {
        const instance = registry.get(section);
        if (instance?.fitObserver) instance.fitObserver.disconnect();
        registry.delete(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-featured-work"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry = window.__archivePostRegistry || new Map();
    const cache = window.__archivePostCache || new Map();
    window.__archivePostRegistry = registry;
    window.__archivePostCache = cache;

    const normalizeUrl = (url) => {
      const normalized = new URL(url, window.location.origin);
      normalized.hash = '';
      return `${normalized.pathname}${normalized.search}`;
    };

    const preloadImage = (src) => {
      if (!src) return Promise.resolve();

      return new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = src;

        if (image.complete) resolve();
      });
    };

    const parseArchivePayload = async (html, requestUrl) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const app = doc.querySelector('[data-archive-post-app]');
      const canvas = app ? app.querySelector('[data-archive-post-canvas]') : null;

      if (!app || !canvas) {
        throw new Error('Archive post canvas not found in response.');
      }

      const image = canvas.querySelector('.archive-post__image');
      const imageSrc = image ? image.getAttribute('src') : '';
      await preloadImage(imageSrc);

      return {
        url: normalizeUrl(requestUrl),
        title: doc.title,
        canvasHTML: canvas.innerHTML,
      };
    };

    const fetchArchivePayload = (url) => {
      const normalizedUrl = normalizeUrl(url);

      if (!cache.has(normalizedUrl)) {
        const request = window
          .fetch(normalizedUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load ${normalizedUrl}`);
            return response.text();
          })
          .then((html) => parseArchivePayload(html, normalizedUrl));

        cache.set(normalizedUrl, request);
      }

      return cache.get(normalizedUrl);
    };

    const fitHeadline = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const parent = heading.parentElement;
      if (!parent) return;

      const parentStyles = window.getComputedStyle(parent);
      const horizontalSafety = isMobile ? 24 : 56;
      const availableWidth =
        parent.clientWidth -
        parseFloat(parentStyles.paddingLeft || '0') -
        parseFloat(parentStyles.paddingRight || '0') -
        horizontalSafety;
      const section = heading.closest('.archive-post');
      const scene = heading.closest('.archive-post__scene');
      const sceneStyles = scene ? window.getComputedStyle(scene) : null;
      const verticalPadding =
        sceneStyles
          ? parseFloat(sceneStyles.paddingTop || '0') + parseFloat(sceneStyles.paddingBottom || '0')
          : 0;
      const sceneHeight = scene?.clientHeight || section?.clientHeight || window.innerHeight;
      const usableHeight = Math.max(0, sceneHeight - verticalPadding);
      const rootStyles = section ? window.getComputedStyle(section) : null;
      const desktopSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-desktop') || '220') : 220;
      const mobileSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-mobile') || '112') : 112;

      if (availableWidth <= 0) return;

      const lines = Array.from(heading.querySelectorAll('.archive-post__background-line'));
      const lineCount = Math.max(lines.length, 1);
      const letterSpacing = isMobile
        ? (lineCount <= 1 ? '0.02rem' : '0rem')
        : (lineCount <= 1 ? '1rem' : lineCount == 2 ? '0.28rem' : lineCount == 3 ? '0.14rem' : '0.08rem');
      heading.style.setProperty('--archive-post-background-letter-spacing', letterSpacing);
      const measureWidth = () => {
        if (!lines.length) return heading.scrollWidth;

        let widest = 0;
        lines.forEach((line) => {
          widest = Math.max(widest, Math.ceil(line.getBoundingClientRect().width));
        });
        return widest;
      };
      const measureHeight = () => Math.ceil(heading.getBoundingClientRect().height);
      const min = isMobile ? 12 : 10;

      if (!isMobile) {
        const max = Math.min(900, (usableHeight / lineCount) * 0.7, desktopSettingMax);
        const availableHeight = usableHeight * 0.82;
        const fits = () => measureWidth() <= availableWidth && measureHeight() <= availableHeight;
        let finalSize;

        if (lineCount <= 1) {
          let low = min;
          let high = max;
          let best = min;

          heading.style.fontSize = `${max}px`;

          while (high - low > 0.5) {
            const mid = (low + high) / 2;
            heading.style.fontSize = `${mid}px`;

            if (fits()) {
              best = mid;
              low = mid;
            } else {
              high = mid;
            }
          }

          finalSize = Math.max(min, Math.min(max, best));
        } else {
          const longestLineCharacters = lines.reduce((widest, line) => {
            const text = (line.textContent || '').trim();
            return Math.max(widest, text.length);
          }, 1);
          const sizeByHeight = availableHeight / (lineCount * 1.08);
          const sizeByWidth = availableWidth / Math.max(longestLineCharacters * 0.92, 1);
          finalSize = Math.max(min, Math.min(max, sizeByHeight, sizeByWidth));
        }

        finalSize *= 0.96;
        heading.style.fontSize = `${finalSize}px`;

        while (!fits() && finalSize > min) {
          finalSize -= 1;
          heading.style.fontSize = `${finalSize}px`;
        }

        return;
      }

      const baseSize = mobileSettingMax;
      const availableHeight = Math.max(72, Math.min(usableHeight * 0.22, 150));
      heading.style.fontSize = `${baseSize}px`;

      const widthAtBase = measureWidth();
      const heightAtBase = measureHeight();
      const widthScale = widthAtBase > 0 ? availableWidth / widthAtBase : 1;
      const heightScale = heightAtBase > 0 ? availableHeight / heightAtBase : 1;
      const fitScale = Math.min(1, widthScale, heightScale);
      let finalSize = Math.max(min, Math.floor(baseSize * fitScale * (lineCount > 1 ? 0.9 : 0.94)));
      heading.style.fontSize = `${finalSize}px`;

      while ((measureWidth() > availableWidth || measureHeight() > availableHeight) && finalSize > min) {
        finalSize -= 1;
        heading.style.fontSize = `${finalSize}px`;
      }
    };

    const fitAllHeadlines = (scope = document) => {
      scope.querySelectorAll('[data-archive-fit-text]').forEach((heading) => fitHeadline(heading));
    };

    const scheduleFitPasses = (scope = document, frames = 8) => {
      let remaining = frames;

      const tick = () => {
        fitAllHeadlines(scope);
        remaining -= 1;
        if (remaining > 0) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    let fitResizeRaf = null;
    const onFitResize = () => {
      if (fitResizeRaf) cancelAnimationFrame(fitResizeRaf);
      fitResizeRaf = requestAnimationFrame(() => scheduleFitPasses(document, 10));
    };

    const getSceneParts = (section) => ({
      bgTitle: section.querySelector('[data-archive-bg-title]'),
      imageShell: section.querySelector('[data-archive-image-shell]'),
      captionLines: section.querySelectorAll('[data-archive-caption-line]'),
      navButtons: section.querySelectorAll('[data-archive-nav]'),
    });

    const runIntro = (section, immediate = false) => {
      section.classList.remove('archive-post--pending');
      if (!window.gsap) return;

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const introTargets = [bgTitle, imageShell, ...captionLines, ...navButtons].filter(Boolean);
      if (!introTargets.length) return;

      const durationScale = immediate ? 0.001 : 1;

      window.gsap.set(bgTitle, { autoAlpha: 0, y: 64 });
      window.gsap.set(imageShell, { autoAlpha: 0, y: 40, scale: 0.9, transformOrigin: '50% 50%' });
      window.gsap.set([...captionLines, ...navButtons], { autoAlpha: 0, y: 20 });

      const timeline = window.gsap.timeline({ defaults: { overwrite: 'auto' } });
      timeline
        .to(bgTitle, {
          autoAlpha: 1,
          y: 0,
          duration: 1.75 * durationScale,
          ease: 'power4.out',
        })
        .to(
          imageShell,
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.2 * durationScale,
            ease: 'power3.out',
          },
          immediate ? 0 : 1.25
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9 * durationScale,
            ease: 'power2.out',
            stagger: 0.1,
          },
          immediate ? 0 : 1.35
        );
    };

    const runOutro = (section) => {
      if (!window.gsap) return Promise.resolve();

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const timeline = window.gsap.timeline({
        defaults: { overwrite: 'auto' },
      });

      timeline
        .to(
          imageShell,
          {
            autoAlpha: 0,
            scale: 0.92,
            duration: 0.78,
            ease: 'power2.inOut',
          },
          0.2
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 0,
            y: 14,
            duration: 0.56,
            ease: 'power2.inOut',
            stagger: 0.04,
          },
          0
        )
        .to(
          bgTitle,
          {
            autoAlpha: 0,
            y: -42,
            duration: 0.86,
            ease: 'power2.inOut',
          },
          0
        );

      return timeline.then ? timeline.then(() => {}) : new Promise((resolve) => timeline.eventCallback('onComplete', resolve));
    };

    const navigateToArticle = async (instance, targetUrl, shouldPushState = true) => {
      if (!instance || !targetUrl || instance.isTransitioning) return;

      instance.isTransitioning = true;

      try {
        await runOutro(instance.section);
        const payload = await fetchArchivePayload(targetUrl);

        instance.canvas.innerHTML = payload.canvasHTML;
        instance.section.dataset.currentUrl = payload.url;
        instance.section.classList.add('archive-post--pending');
        document.title = payload.title;

        if (shouldPushState) {
          window.history.pushState({ archivePostUrl: payload.url }, '', payload.url);
        }

        bindInstance(instance);
        scheduleFitPasses(instance.section, 10);
        runIntro(instance.section);

        if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
          window.ScrollTrigger.refresh();
        }
      } catch (error) {
        window.location.href = targetUrl;
      } finally {
        instance.isTransitioning = false;
      }
    };

    const bindInstance = (instance) => {
      const navLinks = instance.section.querySelectorAll('[data-archive-nav]');
      instance.navLinks = Array.from(navLinks);
        const imageTrigger = instance.section.querySelector('[data-archive-image-trigger]');
        const imageModal = instance.section.querySelector('[data-archive-image-modal]');
        const imageModalCloseButton = imageModal ? imageModal.querySelector('[data-archive-image-modal-close]') : null;
        let imageModalLastFocusedElement = null;

      if (instance.fitObserver) {
        instance.fitObserver.disconnect();
      }

      if ('ResizeObserver' in window) {
        const fitTarget = instance.section.querySelector('.archive-post__background-wrap');
        const scene = instance.section.querySelector('.archive-post__scene');
        instance.fitObserver = new ResizeObserver(() => {
          scheduleFitPasses(instance.section, 6);
        });

        if (fitTarget) instance.fitObserver.observe(fitTarget);
        if (scene && scene !== fitTarget) instance.fitObserver.observe(scene);
      }

      instance.navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        const prefetch = () => {
          fetchArchivePayload(href).catch(() => {});
        };

        link.addEventListener('mouseenter', prefetch);
        link.addEventListener('focus', prefetch);

        link.addEventListener('click', async (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          navigateToArticle(instance, href, true);
        });
      });

      if (imageTrigger && imageModal) {
        const openImageModal = () => {
          imageModalLastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          document.documentElement.classList.add('theme-archive-image-modal-open');
          document.body.classList.add('theme-archive-image-modal-open');

          if (typeof imageModal.showModal === 'function') {
            if (!imageModal.open) imageModal.showModal();
          } else {
            imageModal.setAttribute('open', 'open');
          }

          if (imageModalCloseButton) {
            requestAnimationFrame(() => imageModalCloseButton.focus());
          }
        };

        const closeImageModal = () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');

          if (imageModal.open && typeof imageModal.close === 'function') {
            imageModal.close();
            return;
          }

          imageModal.removeAttribute('open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        };

        imageTrigger.addEventListener('click', openImageModal);
        imageTrigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openImageModal();
        });

        if (imageModalCloseButton) {
          imageModalCloseButton.addEventListener('click', closeImageModal);
        }

        imageModal.addEventListener('click', (event) => {
          if (event.target === imageModal) closeImageModal();
        });

        imageModal.addEventListener('close', () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        });
      }

      const swipeTarget = instance.section.querySelector('[data-archive-image-shell]');
      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (swipeTarget) {
        let startX = 0;
        let startY = 0;
        let tracking = false;

        swipeTarget.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1 || instance.isTransitioning) return;
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            tracking = true;
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchend',
          (event) => {
            if (!tracking || event.changedTouches.length !== 1 || instance.isTransitioning) return;
            tracking = false;

            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            if (absX < 48 || absX <= absY * 1.2) return;

            if (deltaX < 0 && nextLink) {
              navigateToArticle(instance, nextLink.getAttribute('href'), true);
            } else if (deltaX > 0 && previousLink) {
              navigateToArticle(instance, previousLink.getAttribute('href'), true);
            }
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchcancel',
          () => {
            tracking = false;
          },
          { passive: true }
        );
      }
    };

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-archive-post-app]');

      sections.forEach((section) => {
        if (registry.has(section)) return;

        const canvas = section.querySelector('[data-archive-post-canvas]');
        if (!canvas) return;

        const instance = {
          section,
          canvas,
          isTransitioning: false,
          navLinks: [],
        };

        registry.set(section, instance);
        bindInstance(instance);
        scheduleFitPasses(section, 10);
        requestAnimationFrame(() => {
          scheduleFitPasses(section, 8);
          requestAnimationFrame(() => {
            scheduleFitPasses(section, 8);
          });
          runIntro(section);
        });
      });
    };

    const handlePopState = async () => {
      const instance = Array.from(registry.values())[0];
      if (!instance) return;

      const targetUrl = normalizeUrl(window.location.href);
      if (targetUrl === normalizeUrl(instance.section.dataset.currentUrl || '')) return;
      if (instance.isTransitioning) return;

      try {
        await navigateToArticle(instance, targetUrl, false);
      } catch (error) {
        window.location.reload();
        return;
      }
    };

    initialize(document);
    window.addEventListener('resize', onFitResize);
    window.addEventListener('orientationchange', onFitResize);

    const isTypingTarget = (target) => {
      if (!(target instanceof HTMLElement)) return false;
      if (target.isContentEditable) return true;
      return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
    };

    const isImageModalOpen = (instance) => {
      if (!instance?.section) return false;
      const modal = instance.section.querySelector('[data-archive-image-modal]');
      return Boolean(modal && modal.open);
    };

    const handleArrowNavigation = (event) => {
      if (event.defaultPrevented) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (isTypingTarget(event.target)) return;

      const instance = Array.from(registry.values())[0];
      if (!instance || instance.isTransitioning || isImageModalOpen(instance)) return;

      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (event.key === 'ArrowLeft' && previousLink) {
        event.preventDefault();
        navigateToArticle(instance, previousLink.getAttribute('href'), true);
      }

      if (event.key === 'ArrowRight' && nextLink) {
        event.preventDefault();
        navigateToArticle(instance, nextLink.getAttribute('href'), true);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleFitPasses(document, 12)).catch(() => {});
      if (typeof document.fonts.addEventListener === 'function') {
        document.fonts.addEventListener('loadingdone', () => scheduleFitPasses(document, 12));
      }
    }

    window.addEventListener('load', () => {
      scheduleFitPasses(document, 14);
      setTimeout(() => scheduleFitPasses(document, 10), 150);
      setTimeout(() => scheduleFitPasses(document, 10), 450);
    });

    if (!window.__archivePostPopstateBound) {
      window.addEventListener('popstate', handlePopState);
      window.__archivePostPopstateBound = true;
    }

    if (!window.__archivePostArrowNavBound) {
      document.addEventListener('keydown', handleArrowNavigation);
      window.__archivePostArrowNavBound = true;
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      fitAllHeadlines(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-archive-post-app]') || event.target;
      if (registry.has(section)) {
        const instance = registry.get(section);
        if (instance?.fitObserver) instance.fitObserver.disconnect();
        registry.delete(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article-oil-works-post"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry = window.__archivePostRegistry || new Map();
    const cache = window.__archivePostCache || new Map();
    window.__archivePostRegistry = registry;
    window.__archivePostCache = cache;

    const normalizeUrl = (url) => {
      const normalized = new URL(url, window.location.origin);
      normalized.hash = '';
      return `${normalized.pathname}${normalized.search}`;
    };

    const preloadImage = (src) => {
      if (!src) return Promise.resolve();

      return new Promise((resolve) => {
        const image = new Image();
        image.decoding = 'async';
        image.onload = () => resolve();
        image.onerror = () => resolve();
        image.src = src;

        if (image.complete) resolve();
      });
    };

    const parseArchivePayload = async (html, requestUrl) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const app = doc.querySelector('[data-archive-post-app]');
      const canvas = app ? app.querySelector('[data-archive-post-canvas]') : null;

      if (!app || !canvas) {
        throw new Error('Archive post canvas not found in response.');
      }

      const image = canvas.querySelector('.archive-post__image');
      const imageSrc = image ? image.getAttribute('src') : '';
      await preloadImage(imageSrc);

      return {
        url: normalizeUrl(requestUrl),
        title: doc.title,
        canvasHTML: canvas.innerHTML,
      };
    };

    const fetchArchivePayload = (url) => {
      const normalizedUrl = normalizeUrl(url);

      if (!cache.has(normalizedUrl)) {
        const request = window
          .fetch(normalizedUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
          })
          .then((response) => {
            if (!response.ok) throw new Error(`Failed to load ${normalizedUrl}`);
            return response.text();
          })
          .then((html) => parseArchivePayload(html, normalizedUrl));

        cache.set(normalizedUrl, request);
      }

      return cache.get(normalizedUrl);
    };

    const fitHeadline = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const parent = heading.parentElement;
      if (!parent) return;

      const parentStyles = window.getComputedStyle(parent);
      const horizontalSafety = isMobile ? 24 : 56;
      const availableWidth =
        parent.clientWidth -
        parseFloat(parentStyles.paddingLeft || '0') -
        parseFloat(parentStyles.paddingRight || '0') -
        horizontalSafety;
      const section = heading.closest('.archive-post');
      const scene = heading.closest('.archive-post__scene');
      const sceneStyles = scene ? window.getComputedStyle(scene) : null;
      const verticalPadding =
        sceneStyles
          ? parseFloat(sceneStyles.paddingTop || '0') + parseFloat(sceneStyles.paddingBottom || '0')
          : 0;
      const sceneHeight = scene?.clientHeight || section?.clientHeight || window.innerHeight;
      const usableHeight = Math.max(0, sceneHeight - verticalPadding);
      const rootStyles = section ? window.getComputedStyle(section) : null;
      const desktopSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-desktop') || '220') : 220;
      const mobileSettingMax = rootStyles ? parseFloat(rootStyles.getPropertyValue('--archive-post-background-size-mobile') || '112') : 112;

      if (availableWidth <= 0) return;

      const lines = Array.from(heading.querySelectorAll('.archive-post__background-line'));
      const lineCount = Math.max(lines.length, 1);
      const letterSpacing = isMobile
        ? (lineCount <= 1 ? '0.02rem' : '0rem')
        : (lineCount <= 1 ? '1rem' : lineCount == 2 ? '0.28rem' : lineCount == 3 ? '0.14rem' : '0.08rem');
      heading.style.setProperty('--archive-post-background-letter-spacing', letterSpacing);
      const measureWidth = () => {
        if (!lines.length) return heading.scrollWidth;

        let widest = 0;
        lines.forEach((line) => {
          widest = Math.max(widest, Math.ceil(line.getBoundingClientRect().width));
        });
        return widest;
      };
      const measureHeight = () => Math.ceil(heading.getBoundingClientRect().height);
      const min = isMobile ? 12 : 10;

      if (!isMobile) {
        const max = Math.min(900, (usableHeight / lineCount) * 0.7, desktopSettingMax);
        const availableHeight = usableHeight * 0.82;
        const fits = () => measureWidth() <= availableWidth && measureHeight() <= availableHeight;
        let finalSize;

        if (lineCount <= 1) {
          let low = min;
          let high = max;
          let best = min;

          heading.style.fontSize = `${max}px`;

          while (high - low > 0.5) {
            const mid = (low + high) / 2;
            heading.style.fontSize = `${mid}px`;

            if (fits()) {
              best = mid;
              low = mid;
            } else {
              high = mid;
            }
          }

          finalSize = Math.max(min, Math.min(max, best));
        } else {
          const longestLineCharacters = lines.reduce((widest, line) => {
            const text = (line.textContent || '').trim();
            return Math.max(widest, text.length);
          }, 1);
          const sizeByHeight = availableHeight / (lineCount * 1.08);
          const sizeByWidth = availableWidth / Math.max(longestLineCharacters * 0.92, 1);
          finalSize = Math.max(min, Math.min(max, sizeByHeight, sizeByWidth));
        }

        finalSize *= 0.96;
        heading.style.fontSize = `${finalSize}px`;

        while (!fits() && finalSize > min) {
          finalSize -= 1;
          heading.style.fontSize = `${finalSize}px`;
        }

        return;
      }

      const baseSize = mobileSettingMax;
      const availableHeight = Math.max(72, Math.min(usableHeight * 0.22, 150));
      heading.style.fontSize = `${baseSize}px`;

      const widthAtBase = measureWidth();
      const heightAtBase = measureHeight();
      const widthScale = widthAtBase > 0 ? availableWidth / widthAtBase : 1;
      const heightScale = heightAtBase > 0 ? availableHeight / heightAtBase : 1;
      const fitScale = Math.min(1, widthScale, heightScale);
      let finalSize = Math.max(min, Math.floor(baseSize * fitScale * (lineCount > 1 ? 0.9 : 0.94)));
      heading.style.fontSize = `${finalSize}px`;

      while ((measureWidth() > availableWidth || measureHeight() > availableHeight) && finalSize > min) {
        finalSize -= 1;
        heading.style.fontSize = `${finalSize}px`;
      }
    };

    const fitAllHeadlines = (scope = document) => {
      scope.querySelectorAll('[data-archive-fit-text]').forEach((heading) => fitHeadline(heading));
    };

    const scheduleFitPasses = (scope = document, frames = 8) => {
      let remaining = frames;

      const tick = () => {
        fitAllHeadlines(scope);
        remaining -= 1;
        if (remaining > 0) requestAnimationFrame(tick);
      };

      requestAnimationFrame(tick);
    };

    let fitResizeRaf = null;
    const onFitResize = () => {
      if (fitResizeRaf) cancelAnimationFrame(fitResizeRaf);
      fitResizeRaf = requestAnimationFrame(() => scheduleFitPasses(document, 10));
    };

    const getSceneParts = (section) => ({
      bgTitle: section.querySelector('[data-archive-bg-title]'),
      imageShell: section.querySelector('[data-archive-image-shell]'),
      captionLines: section.querySelectorAll('[data-archive-caption-line]'),
      navButtons: section.querySelectorAll('[data-archive-nav]'),
    });

    const runIntro = (section, immediate = false) => {
      section.classList.remove('archive-post--pending');
      if (!window.gsap) return;

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const introTargets = [bgTitle, imageShell, ...captionLines, ...navButtons].filter(Boolean);
      if (!introTargets.length) return;

      const durationScale = immediate ? 0.001 : 1;

      window.gsap.set(bgTitle, { autoAlpha: 0, y: 64 });
      window.gsap.set(imageShell, { autoAlpha: 0, y: 40, scale: 0.9, transformOrigin: '50% 50%' });
      window.gsap.set([...captionLines, ...navButtons], { autoAlpha: 0, y: 20 });

      const timeline = window.gsap.timeline({ defaults: { overwrite: 'auto' } });
      timeline
        .to(bgTitle, {
          autoAlpha: 1,
          y: 0,
          duration: 1.75 * durationScale,
          ease: 'power4.out',
        })
        .to(
          imageShell,
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 1.2 * durationScale,
            ease: 'power3.out',
          },
          immediate ? 0 : 1.25
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9 * durationScale,
            ease: 'power2.out',
            stagger: 0.1,
          },
          immediate ? 0 : 1.35
        );
    };

    const runOutro = (section) => {
      if (!window.gsap) return Promise.resolve();

      const { bgTitle, imageShell, captionLines, navButtons } = getSceneParts(section);
      const timeline = window.gsap.timeline({
        defaults: { overwrite: 'auto' },
      });

      timeline
        .to(
          imageShell,
          {
            autoAlpha: 0,
            scale: 0.92,
            duration: 0.78,
            ease: 'power2.inOut',
          },
          0.2
        )
        .to(
          [...captionLines, ...navButtons],
          {
            autoAlpha: 0,
            y: 14,
            duration: 0.56,
            ease: 'power2.inOut',
            stagger: 0.04,
          },
          0
        )
        .to(
          bgTitle,
          {
            autoAlpha: 0,
            y: -42,
            duration: 0.86,
            ease: 'power2.inOut',
          },
          0
        );

      return timeline.then ? timeline.then(() => {}) : new Promise((resolve) => timeline.eventCallback('onComplete', resolve));
    };

    const navigateToArticle = async (instance, targetUrl, shouldPushState = true) => {
      if (!instance || !targetUrl || instance.isTransitioning) return;

      instance.isTransitioning = true;

      try {
        await runOutro(instance.section);
        const payload = await fetchArchivePayload(targetUrl);

        instance.canvas.innerHTML = payload.canvasHTML;
        instance.section.dataset.currentUrl = payload.url;
        instance.section.classList.add('archive-post--pending');
        document.title = payload.title;

        if (shouldPushState) {
          window.history.pushState({ archivePostUrl: payload.url }, '', payload.url);
        }

        bindInstance(instance);
        scheduleFitPasses(instance.section, 10);
        runIntro(instance.section);

        if (window.ScrollTrigger && typeof window.ScrollTrigger.refresh === 'function') {
          window.ScrollTrigger.refresh();
        }
      } catch (error) {
        window.location.href = targetUrl;
      } finally {
        instance.isTransitioning = false;
      }
    };

    const bindInstance = (instance) => {
      const navLinks = instance.section.querySelectorAll('[data-archive-nav]');
      instance.navLinks = Array.from(navLinks);
        const imageTrigger = instance.section.querySelector('[data-archive-image-trigger]');
        const imageModal = instance.section.querySelector('[data-archive-image-modal]');
        const imageModalCloseButton = imageModal ? imageModal.querySelector('[data-archive-image-modal-close]') : null;
        let imageModalLastFocusedElement = null;

      if (instance.fitObserver) {
        instance.fitObserver.disconnect();
      }

      if ('ResizeObserver' in window) {
        const fitTarget = instance.section.querySelector('.archive-post__background-wrap');
        const scene = instance.section.querySelector('.archive-post__scene');
        instance.fitObserver = new ResizeObserver(() => {
          scheduleFitPasses(instance.section, 6);
        });

        if (fitTarget) instance.fitObserver.observe(fitTarget);
        if (scene && scene !== fitTarget) instance.fitObserver.observe(scene);
      }

      instance.navLinks.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        const prefetch = () => {
          fetchArchivePayload(href).catch(() => {});
        };

        link.addEventListener('mouseenter', prefetch);
        link.addEventListener('focus', prefetch);

        link.addEventListener('click', async (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          navigateToArticle(instance, href, true);
        });
      });

      if (imageTrigger && imageModal) {
        const openImageModal = () => {
          imageModalLastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          document.documentElement.classList.add('theme-archive-image-modal-open');
          document.body.classList.add('theme-archive-image-modal-open');

          if (typeof imageModal.showModal === 'function') {
            if (!imageModal.open) imageModal.showModal();
          } else {
            imageModal.setAttribute('open', 'open');
          }

          if (imageModalCloseButton) {
            requestAnimationFrame(() => imageModalCloseButton.focus());
          }
        };

        const closeImageModal = () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');

          if (imageModal.open && typeof imageModal.close === 'function') {
            imageModal.close();
            return;
          }

          imageModal.removeAttribute('open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        };

        imageTrigger.addEventListener('click', openImageModal);
        imageTrigger.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          openImageModal();
        });

        if (imageModalCloseButton) {
          imageModalCloseButton.addEventListener('click', closeImageModal);
        }

        imageModal.addEventListener('click', (event) => {
          if (event.target === imageModal) closeImageModal();
        });

        imageModal.addEventListener('close', () => {
          document.documentElement.classList.remove('theme-archive-image-modal-open');
          document.body.classList.remove('theme-archive-image-modal-open');
          if (imageModalLastFocusedElement && typeof imageModalLastFocusedElement.focus === 'function') {
            imageModalLastFocusedElement.focus();
          }
        });
      }

      const swipeTarget = instance.section.querySelector('[data-archive-image-shell]');
      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (swipeTarget) {
        let startX = 0;
        let startY = 0;
        let tracking = false;

        swipeTarget.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length !== 1 || instance.isTransitioning) return;
            const touch = event.touches[0];
            startX = touch.clientX;
            startY = touch.clientY;
            tracking = true;
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchend',
          (event) => {
            if (!tracking || event.changedTouches.length !== 1 || instance.isTransitioning) return;
            tracking = false;

            const touch = event.changedTouches[0];
            const deltaX = touch.clientX - startX;
            const deltaY = touch.clientY - startY;
            const absX = Math.abs(deltaX);
            const absY = Math.abs(deltaY);

            if (absX < 48 || absX <= absY * 1.2) return;

            if (deltaX < 0 && nextLink) {
              navigateToArticle(instance, nextLink.getAttribute('href'), true);
            } else if (deltaX > 0 && previousLink) {
              navigateToArticle(instance, previousLink.getAttribute('href'), true);
            }
          },
          { passive: true }
        );

        swipeTarget.addEventListener(
          'touchcancel',
          () => {
            tracking = false;
          },
          { passive: true }
        );
      }
    };

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-archive-post-app]');

      sections.forEach((section) => {
        if (registry.has(section)) return;

        const canvas = section.querySelector('[data-archive-post-canvas]');
        if (!canvas) return;

        const instance = {
          section,
          canvas,
          isTransitioning: false,
          navLinks: [],
        };

        registry.set(section, instance);
        bindInstance(instance);
        scheduleFitPasses(section, 10);
        requestAnimationFrame(() => {
          scheduleFitPasses(section, 8);
          requestAnimationFrame(() => {
            scheduleFitPasses(section, 8);
          });
          runIntro(section);
        });
      });
    };

    const handlePopState = async () => {
      const instance = Array.from(registry.values())[0];
      if (!instance) return;

      const targetUrl = normalizeUrl(window.location.href);
      if (targetUrl === normalizeUrl(instance.section.dataset.currentUrl || '')) return;
      if (instance.isTransitioning) return;

      try {
        await navigateToArticle(instance, targetUrl, false);
      } catch (error) {
        window.location.reload();
        return;
      }
    };

    initialize(document);
    window.addEventListener('resize', onFitResize);
    window.addEventListener('orientationchange', onFitResize);

    const isTypingTarget = (target) => {
      if (!(target instanceof HTMLElement)) return false;
      if (target.isContentEditable) return true;
      return Boolean(target.closest('input, textarea, select, [contenteditable="true"]'));
    };

    const isImageModalOpen = (instance) => {
      if (!instance?.section) return false;
      const modal = instance.section.querySelector('[data-archive-image-modal]');
      return Boolean(modal && modal.open);
    };

    const handleArrowNavigation = (event) => {
      if (event.defaultPrevented) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (isTypingTarget(event.target)) return;

      const instance = Array.from(registry.values())[0];
      if (!instance || instance.isTransitioning || isImageModalOpen(instance)) return;

      const previousLink = instance.section.querySelector('.archive-post__nav--prev[href]');
      const nextLink = instance.section.querySelector('.archive-post__nav--next[href]');

      if (event.key === 'ArrowLeft' && previousLink) {
        event.preventDefault();
        navigateToArticle(instance, previousLink.getAttribute('href'), true);
      }

      if (event.key === 'ArrowRight' && nextLink) {
        event.preventDefault();
        navigateToArticle(instance, nextLink.getAttribute('href'), true);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => scheduleFitPasses(document, 12)).catch(() => {});
      if (typeof document.fonts.addEventListener === 'function') {
        document.fonts.addEventListener('loadingdone', () => scheduleFitPasses(document, 12));
      }
    }

    window.addEventListener('load', () => {
      scheduleFitPasses(document, 14);
      setTimeout(() => scheduleFitPasses(document, 10), 150);
      setTimeout(() => scheduleFitPasses(document, 10), 450);
    });

    if (!window.__archivePostPopstateBound) {
      window.addEventListener('popstate', handlePopState);
      window.__archivePostPopstateBound = true;
    }

    if (!window.__archivePostArrowNavBound) {
      document.addEventListener('keydown', handleArrowNavigation);
      window.__archivePostArrowNavBound = true;
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
      fitAllHeadlines(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-archive-post-app]') || event.target;
      if (registry.has(section)) {
        const instance = registry.get(section);
        if (instance?.fitObserver) instance.fitObserver.disconnect();
        registry.delete(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["basic-content"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__basicContentHeadingFitInitialized) {
      return;
    }
    window.__basicContentHeadingFitInitialized = true;

    const fitHeading = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const fitEnabled = isMobile
        ? heading.dataset.fitEnabledMobile === 'true'
        : heading.dataset.fitEnabledDesktop === 'true';
      const min = Number(heading.dataset.fitMin) || 40;
      const max = Number(heading.dataset.fitMax) || 220;
      const nowrap = heading.dataset.fitNowrap === 'true';
      const availableWidth = heading.clientWidth;

      if (!availableWidth) return;

      if (!fitEnabled) {
        heading.style.removeProperty('font-size');
        heading.style.removeProperty('letter-spacing');
        return;
      }

      const getLineMetrics = () => {
        const range = document.createRange();
        range.selectNodeContents(heading);

        const rawRects = Array.from(range.getClientRects()).filter((rect) => rect.width > 1 && rect.height > 1);
        const lines = [];

        rawRects.forEach((rect) => {
          const existingLine = lines.find((line) => Math.abs(line.top - rect.top) < 2);

          if (existingLine) {
            existingLine.left = Math.min(existingLine.left, rect.left);
            existingLine.right = Math.max(existingLine.right, rect.right);
            existingLine.top = Math.min(existingLine.top, rect.top);
            existingLine.bottom = Math.max(existingLine.bottom, rect.bottom);
            return;
          }

          lines.push({
            top: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            right: rect.right,
          });
        });

        if (typeof range.detach === 'function') {
          range.detach();
        }

        if (!lines.length) {
          return {
            lineCount: 1,
            widestLine: Math.ceil(heading.getBoundingClientRect().width),
          };
        }

        return {
          lineCount: lines.length,
          widestLine: Math.ceil(
            lines.reduce((widest, line) => Math.max(widest, line.right - line.left), 0)
          ),
        };
      };

      const setWrappedLetterSpacing = (lineCount) => {
        if (!isMobile) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount <= 1) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount === 2) {
          heading.style.letterSpacing = '0.22rem';
          return;
        }

        if (lineCount === 3) {
          heading.style.letterSpacing = '0.12rem';
          return;
        }

        heading.style.letterSpacing = '0.06rem';
      };

      const setNoWrapLetterSpacing = (fontSize) => {
        const safeMax = Math.max(max, 1);
        const minSpacing = 0.12;
        const scaledSpacing = Math.max(minSpacing, Math.min(1, fontSize / safeMax));
        heading.style.letterSpacing = `${scaledSpacing.toFixed(3)}rem`;
      };

      if (!nowrap) {
        heading.style.fontSize = `${max}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);

        if (!isMobile) {
          heading.style.fontSize = `clamp(${min}px, 10vw, ${max}px)`;
          return;
        }

        const wordCount = (heading.textContent || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean).length;
        const preferredLineCount = wordCount > 1 ? 2 : 1;
        heading.style.fontSize = `${min}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        const minimumLineCount = getLineMetrics().lineCount;
        const targetLineCount = Math.max(preferredLineCount, minimumLineCount);

        let low = min;
        let high = max;
        let best = min;

        while (high - low > 0.5) {
          const mid = (low + high) / 2;
          heading.style.fontSize = `${mid}px`;
          setWrappedLetterSpacing(getLineMetrics().lineCount);

          const { lineCount, widestLine } = getLineMetrics();

          if (lineCount <= targetLineCount && widestLine <= availableWidth) {
            best = mid;
            low = mid;
          } else {
            high = mid;
          }
        }

        heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        return;
      }

      let low = min;
      let high = max;
      let best = min;

      heading.style.fontSize = `${max}px`;
      setNoWrapLetterSpacing(max);

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        heading.style.fontSize = `${mid}px`;
        setNoWrapLetterSpacing(mid);

        if (heading.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
      setNoWrapLetterSpacing(Math.max(min, Math.min(max, best)));
    };

    const fitAll = (scope = document) => {
      scope.querySelectorAll('.basic-content__full-width-heading[data-fit-text]').forEach((heading) => fitHeading(heading));
    };

    let resizeRaf = null;
    const onResize = () => {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => fitAll(document));
    };

    fitAll(document);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => fitAll(document)).catch(() => {});
    }

    document.addEventListener('shopify:section:load', (event) => {
      fitAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["center-headline-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = window.__centerHeadlineCollageCleanups || new Map();
    window.__centerHeadlineCollageCleanups = cleanups;

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-center-headline-collage]');

      sections.forEach((section) => {
        if (section.dataset.centerHeadlineCollageInitialized === 'true') return;

        const desktopItems = Array.from(section.querySelectorAll('[data-collage-item]'));
        const textTargets = Array.from(section.querySelectorAll('[data-collage-text]'));

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let trigger = null;
        let progressTween = null;
        let revealTrigger = null;
        let fallbackHandler = null;
        let resizeHandler = null;
        let revealObserver = null;

        const revealText = () => {
          section.classList.remove('is-pending');
          section.classList.add('is-revealed');
        };

        const applyProgress = (progress) => {
          if (!desktopItems.length) return;

          const baseDriftDistance = parseFloat(window.getComputedStyle(section).getPropertyValue('--center-collage-drift-distance')) || 0;
          const driftDistance = window.matchMedia('(max-width: 749px)').matches ? baseDriftDistance * 0.55 : baseDriftDistance;
          const directionMap = {
            up: [0, -1],
            down: [0, 1],
            left: [-1, 0],
            right: [1, 0],
            'up-left': [-1, -1],
            'up-right': [1, -1],
            'down-left': [-1, 1],
            'down-right': [1, 1],
          };

          desktopItems.forEach((item) => {
            const directionKey = item.dataset.driftDirection || 'down';
            const vector = directionMap[directionKey] || directionMap.down;
            const driftProgress = Math.min(1, progress * 1.35);
            const currentX = vector[0] * driftDistance * driftProgress;
            const currentY = vector[1] * driftDistance * driftProgress;

            item.style.setProperty('--item-drift-x', `${currentX}px`);
            item.style.setProperty('--item-drift-y', `${currentY}px`);
          });
        };

        const applyFallbackProgress = () => {
          const rect = section.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
          const total = rect.height + viewportHeight;
          const travelled = viewportHeight - rect.top;
          const progress = Math.max(0, Math.min(1, travelled / total));
          applyProgress(progress);
        };

        const createScrollAnimation = () => {
          if (trigger) {
            trigger.kill();
            trigger = null;
          }

          if (progressTween) {
            progressTween.kill();
            progressTween = null;
          }

          if (revealTrigger) {
            revealTrigger.kill();
            revealTrigger = null;
          }

          if (fallbackHandler) {
            window.removeEventListener('scroll', fallbackHandler);
            fallbackHandler = null;
          }

          if (revealObserver) {
            revealObserver.disconnect();
            revealObserver = null;
          }

          if (prefersReducedMotion) {
            revealText();
            if (desktopItems.length) applyProgress(0.5);
            return;
          }

          if (textTargets.length) {
            section.classList.add('is-pending');
          }

          if (window.gsap && window.ScrollTrigger && typeof window.gsap.registerPlugin === 'function') {
            window.gsap.registerPlugin(window.ScrollTrigger);

            if (desktopItems.length) {
              const progressProxy = { value: 0 };
              progressTween = window.gsap.to(progressProxy, {
                value: 1,
                ease: 'none',
                paused: true,
                onUpdate: () => {
                  applyProgress(progressProxy.value);
                },
              });

              trigger = window.ScrollTrigger.create({
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                animation: progressTween,
                scrub: 1,
                onRefresh: (self) => {
                  if (progressTween) {
                    progressTween.progress(self.progress || 0).pause();
                  }
                  applyProgress(self.progress || 0);
                },
              });
            }

            if (textTargets.length) {
              revealTrigger = window.ScrollTrigger.create({
                trigger: section,
                start: 'top 78%',
                once: true,
                onEnter: () => {
                  revealText();
                },
              });
            }
          } else {
            if (desktopItems.length) {
              fallbackHandler = () => {
                window.requestAnimationFrame(applyFallbackProgress);
              };
              window.addEventListener('scroll', fallbackHandler, { passive: true });
              applyFallbackProgress();
            }

            if (textTargets.length) {
              revealObserver = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      revealText();
                      if (revealObserver) revealObserver.disconnect();
                      revealObserver = null;
                    }
                  });
                },
                {
                  threshold: 0.15,
                }
              );

              revealObserver.observe(section);
            }
          }
        };

        resizeHandler = () => {
          createScrollAnimation();
        };

        createScrollAnimation();
        window.addEventListener('resize', resizeHandler);

        cleanups.set(section, () => {
          if (trigger) trigger.kill();
          if (revealTrigger) revealTrigger.kill();
          if (fallbackHandler) window.removeEventListener('scroll', fallbackHandler);
          if (revealObserver) revealObserver.disconnect();
          if (resizeHandler) window.removeEventListener('resize', resizeHandler);
        });

        section.dataset.centerHeadlineCollageInitialized = 'true';
      });
    };

    initialize(document);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-center-headline-collage]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["center-video-modal-collage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = window.__centerVideoModalCollageCleanups || new Map();
    window.__centerVideoModalCollageCleanups = cleanups;

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-center-video-modal-collage]');

      sections.forEach((section) => {
        if (section.dataset.centerVideoModalCollageInitialized === 'true') return;

        const desktopItems = Array.from(section.querySelectorAll('[data-video-collage-item]'));
        const revealTargets = Array.from(section.querySelectorAll('[data-video-collage-reveal]'));
        const videoTrigger = section.querySelector('[data-video-collage-trigger]');
        const videoDialog = section.querySelector('[data-video-collage-dialog]');
        const dialogCloseButton = videoDialog ? videoDialog.querySelector('[data-video-collage-close]') : null;
        const dialogIframe = videoDialog ? videoDialog.querySelector('[data-video-collage-iframe]') : null;
        const dialogVideo = videoDialog ? videoDialog.querySelector('video.center-video-modal-collage__dialog-media--video') : null;

        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let trigger = null;
        let progressTween = null;
        let revealTrigger = null;
        let fallbackHandler = null;
        let resizeHandler = null;
        let revealObserver = null;
        let dialogOpenHandler = null;
        let dialogCloseHandler = null;
        let dialogBackdropHandler = null;
        let closeButtonHandler = null;
        let lastFocusedElement = null;

        const revealContent = () => {
          section.classList.remove('is-pending');
          section.classList.add('is-revealed');
        };

        const applyProgress = (progress) => {
          if (!desktopItems.length) return;

          const baseDriftDistance = parseFloat(window.getComputedStyle(section).getPropertyValue('--center-video-collage-drift-distance')) || 0;
          const driftDistance = window.matchMedia('(max-width: 749px)').matches ? baseDriftDistance * 0.55 : baseDriftDistance;
          const directionMap = {
            up: [0, -1],
            down: [0, 1],
            left: [-1, 0],
            right: [1, 0],
            'up-left': [-1, -1],
            'up-right': [1, -1],
            'down-left': [-1, 1],
            'down-right': [1, 1],
          };

          desktopItems.forEach((item) => {
            const directionKey = item.dataset.driftDirection || 'down';
            const vector = directionMap[directionKey] || directionMap.down;
            const driftProgress = Math.min(1, progress * 1.35);
            const currentX = vector[0] * driftDistance * driftProgress;
            const currentY = vector[1] * driftDistance * driftProgress;

            item.style.setProperty('--item-drift-x', `${currentX}px`);
            item.style.setProperty('--item-drift-y', `${currentY}px`);
          });
        };

        const applyFallbackProgress = () => {
          const rect = section.getBoundingClientRect();
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
          const total = rect.height + viewportHeight;
          const travelled = viewportHeight - rect.top;
          const progress = Math.max(0, Math.min(1, travelled / total));
          applyProgress(progress);
        };

        const stopDialogPlayback = () => {
          if (dialogIframe) {
            dialogIframe.removeAttribute('src');
          }

          if (dialogVideo) {
            dialogVideo.pause();
            dialogVideo.currentTime = 0;
          }
        };

        const openVideoDialog = () => {
          if (!videoDialog) return;

          lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

          if (typeof videoDialog.showModal === 'function') {
            if (!videoDialog.open) videoDialog.showModal();
          } else {
            videoDialog.setAttribute('open', 'open');
          }

          if (dialogIframe && dialogIframe.dataset.src) {
            dialogIframe.src = dialogIframe.dataset.src;
          }

          if (dialogVideo) {
            dialogVideo.currentTime = 0;
            const playPromise = dialogVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }

          if (dialogCloseButton) {
            window.requestAnimationFrame(() => dialogCloseButton.focus());
          }
        };

        const closeVideoDialog = () => {
          if (!videoDialog) return;

          if (videoDialog.open && typeof videoDialog.close === 'function') {
            videoDialog.close();
            return;
          }

          videoDialog.removeAttribute('open');
          stopDialogPlayback();
          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
          }
        };

        const createScrollAnimation = () => {
          if (trigger) {
            trigger.kill();
            trigger = null;
          }

          if (progressTween) {
            progressTween.kill();
            progressTween = null;
          }

          if (revealTrigger) {
            revealTrigger.kill();
            revealTrigger = null;
          }

          if (fallbackHandler) {
            window.removeEventListener('scroll', fallbackHandler);
            fallbackHandler = null;
          }

          if (revealObserver) {
            revealObserver.disconnect();
            revealObserver = null;
          }

          if (prefersReducedMotion) {
            revealContent();
            if (desktopItems.length) applyProgress(0.5);
            return;
          }

          if (revealTargets.length) {
            section.classList.add('is-pending');
          }

          if (window.gsap && window.ScrollTrigger && typeof window.gsap.registerPlugin === 'function') {
            window.gsap.registerPlugin(window.ScrollTrigger);

            if (desktopItems.length) {
              const progressProxy = { value: 0 };
              progressTween = window.gsap.to(progressProxy, {
                value: 1,
                ease: 'none',
                paused: true,
                onUpdate: () => {
                  applyProgress(progressProxy.value);
                },
              });

              trigger = window.ScrollTrigger.create({
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                animation: progressTween,
                scrub: 1,
                onRefresh: (self) => {
                  if (progressTween) {
                    progressTween.progress(self.progress || 0).pause();
                  }
                  applyProgress(self.progress || 0);
                },
              });
            }

            if (revealTargets.length) {
              revealTrigger = window.ScrollTrigger.create({
                trigger: section,
                start: 'top 78%',
                once: true,
                onEnter: () => {
                  revealContent();
                },
              });
            }
          } else {
            if (desktopItems.length) {
              fallbackHandler = () => {
                window.requestAnimationFrame(applyFallbackProgress);
              };
              window.addEventListener('scroll', fallbackHandler, { passive: true });
              applyFallbackProgress();
            }

            if (revealTargets.length) {
              revealObserver = new IntersectionObserver(
                (entries) => {
                  entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                      revealContent();
                      if (revealObserver) revealObserver.disconnect();
                      revealObserver = null;
                    }
                  });
                },
                {
                  threshold: 0.15,
                }
              );

              revealObserver.observe(section);
            }
          }
        };

        resizeHandler = () => {
          createScrollAnimation();
        };

        createScrollAnimation();
        window.addEventListener('resize', resizeHandler);

        if (videoTrigger && videoDialog && !videoTrigger.disabled) {
          dialogOpenHandler = () => openVideoDialog();
          dialogCloseHandler = () => {
            stopDialogPlayback();
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
              lastFocusedElement.focus();
            }
          };
          dialogBackdropHandler = (event) => {
            if (event.target === videoDialog) closeVideoDialog();
          };
          closeButtonHandler = () => closeVideoDialog();

          videoTrigger.addEventListener('click', dialogOpenHandler);
          videoDialog.addEventListener('close', dialogCloseHandler);
          videoDialog.addEventListener('click', dialogBackdropHandler);

          if (dialogCloseButton) {
            dialogCloseButton.addEventListener('click', closeButtonHandler);
          }
        }

        cleanups.set(section, () => {
          if (trigger) trigger.kill();
          if (revealTrigger) revealTrigger.kill();
          if (fallbackHandler) window.removeEventListener('scroll', fallbackHandler);
          if (revealObserver) revealObserver.disconnect();
          if (resizeHandler) window.removeEventListener('resize', resizeHandler);
          if (videoTrigger && dialogOpenHandler) videoTrigger.removeEventListener('click', dialogOpenHandler);
          if (videoDialog && dialogCloseHandler) videoDialog.removeEventListener('close', dialogCloseHandler);
          if (videoDialog && dialogBackdropHandler) videoDialog.removeEventListener('click', dialogBackdropHandler);
          if (dialogCloseButton && closeButtonHandler) dialogCloseButton.removeEventListener('click', closeButtonHandler);
          stopDialogPlayback();
          if (videoDialog) {
            if (videoDialog.open && typeof videoDialog.close === 'function') {
              videoDialog.close();
            } else {
              videoDialog.removeAttribute('open');
            }
          }
        });

        section.dataset.centerVideoModalCollageInitialized = 'true';
      });
    };

    initialize(document);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-center-video-modal-collage]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dream-section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();

    const initializeDreamSections = (scope = document) => {
      scope.querySelectorAll('[data-dream-section]').forEach((section) => {
        if (section.dataset.dreamInitialized === 'true') return;

        const floatItems = Array.from(section.querySelectorAll('[data-dream-float-item]'));
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let reducedMotion = prefersReducedMotion.matches;
        let floatFrameId = null;
        let resizeFrameId = null;
        let resizeObserver = null;
        let intersectionObserver = null;
        let runtimeColorObserver = null;
        let runtimeColorFrameId = null;
        let runtimeColorScrollHandler = null;
        let activationTrigger = null;
        let scrollProxyTween = null;
        let loadHandler = null;
        let floatAnimationStartTime = null;
        let hasActivated = false;
        let scrubProgress = 0;
        let lastViewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        let lastViewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const stickyStage = section.querySelector('.dream-section__sticky-stage');
        let contentInner = section.querySelector('.dream-section__content-inner');
        let headline = section.querySelector('.dream-section__headline');
        let revealWords = [];
        const runtimeColorScheme = section.dataset.runtimeColorScheme || '';
        const enableRuntimeColorTransition = section.dataset.runtimeColorTransition === 'true' && runtimeColorScheme !== '';
        const hasBackgroundImage = !!section.querySelector('.dream-section__background-media');
        const runtimeColorSourceId = `${section.id || 'dream-section'}::scroll-lock`;
        const animationMode = section.dataset.animationMode === 'scroll' ? 'scroll' : 'autoplay';
        const isTouchLikeViewport = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;
        const mobileAutoplayFallbackEnabled = section.dataset.mobileAutoplayFallback === 'true';
        // Respect the merchant toggle: only use the mobile autoplay path when it is explicitly enabled.
        const useMobileAutoplayFallback =
          animationMode === 'scroll' && isMobileViewport && mobileAutoplayFallbackEnabled;
        const isScrollMode = animationMode === 'scroll' && !useMobileAutoplayFallback;

        if (useMobileAutoplayFallback) {
          section.classList.add('dream-section--mobile-autoplay');
        }

        if (!reducedMotion && !isScrollMode) {
          section.classList.add('is-pending');
        }
        const getResponsiveNumber = (desktopAttr, mobileAttr) => {
          const desktopValue = Number(section.dataset[desktopAttr]) || 0;
          const mobileValue = Number(section.dataset[mobileAttr]) || desktopValue;
          return window.matchMedia('(max-width: 749px)').matches ? mobileValue : desktopValue;
        };
        const getFloatDuration = () => {
          const desktopValue = Math.max(6, Number(section.dataset.floatDuration) || 28);
          const mobileValue = Math.max(6, Number(section.dataset.floatDurationMobile) || desktopValue);
          return window.matchMedia('(max-width: 749px)').matches || isTouchLikeViewport ? mobileValue : desktopValue;
        };

        const getLaneMultiplier = (itemIndex) => {
          const laneIndex = ((itemIndex % 4) + 4) % 4;

          if (laneIndex === 0) return -1;
          if (laneIndex === 2) return 1;
          return 0;
        };

        const getActivationTriggerElement = () => contentInner || section;
        const getFloatBounds = () => stickyStage || section;
        const hasActiveSmoothScroll = () => {
          if (!document.documentElement.classList.contains('smooth-scroll-active')) return false;
          if (!window.ScrollSmoother || typeof window.ScrollSmoother.get !== 'function') return false;
          return !!window.ScrollSmoother.get();
        };
        const getHeaderOffset = () => {
          const rootStyles = window.getComputedStyle(document.documentElement);
          return Math.max(0, parseFloat(rootStyles.getPropertyValue('--header-runtime-height')) || 0);
        };
        const getScrollDistance = () => {
          const baseDistance = Math.max(600, getResponsiveNumber('scrollDistanceDesktop', 'scrollDistanceMobile'));
          return isTouchLikeViewport ? Math.round(baseDistance * 1.75) : baseDistance;
        };
        const getScrollScrubValue = () => (hasActiveSmoothScroll() ? 0.2 : 1);
        const shouldIgnoreViewportChromeResize = () => {
          const nextWidth = window.innerWidth || document.documentElement.clientWidth || lastViewportWidth;
          const nextHeight = window.innerHeight || document.documentElement.clientHeight || lastViewportHeight;
          const widthChanged = Math.abs(nextWidth - lastViewportWidth) > 2;
          const heightChanged = Math.abs(nextHeight - lastViewportHeight) > 2;

          lastViewportWidth = nextWidth;
          lastViewportHeight = nextHeight;

          return isTouchLikeViewport && !widthChanged && heightChanged;
        };
        const setRuntimeColorActive = (isActive) => {
          if (hasBackgroundImage) {
            section.classList.toggle('is-background-shifted', !!isActive);
          }

          if (!enableRuntimeColorTransition || !window.ThemeRuntimeColorTransition) return;

          if (isActive) {
            window.ThemeRuntimeColorTransition.activate(runtimeColorSourceId, runtimeColorScheme, 10);
          } else {
            window.ThemeRuntimeColorTransition.deactivate(runtimeColorSourceId);
          }
        };

        const wrapTextNodeWords = (textNode) => {
          const text = textNode.textContent;
          if (!text || !text.trim()) return;

          const fragment = document.createDocumentFragment();
          const parts = text.split(/(\s+)/);

          parts.forEach((part) => {
            if (!part) return;

            if (/^\s+$/.test(part)) {
              fragment.appendChild(document.createTextNode(part));
              return;
            }

            const word = document.createElement('span');
            word.className = 'dream-section__reveal-word';
            word.dataset.dreamRevealWord = '';
            word.textContent = part;
            fragment.appendChild(word);
          });

          textNode.parentNode.replaceChild(fragment, textNode);
        };

        const buildRevealWords = () => {
          if (!headline || headline.dataset.dreamRevealPrepared === 'true') {
            revealWords = headline ? Array.from(headline.querySelectorAll('[data-dream-reveal-word]')) : [];
            return;
          }

          const parts = Array.from(headline.querySelectorAll('.dream-section__headline-part'));
          parts.forEach((part) => {
            Array.from(part.childNodes).forEach((node) => {
              if (node.nodeType === Node.TEXT_NODE) {
                wrapTextNodeWords(node);
              }
            });
          });

          headline.dataset.dreamRevealPrepared = 'true';
          revealWords = Array.from(headline.querySelectorAll('[data-dream-reveal-word]'));
        };

        const applyStaticFloatLayout = () => {
          const bounds = getFloatBounds();
          const sectionWidth = bounds.clientWidth;
          const sectionHeight = bounds.clientHeight;
          const floatSize = getResponsiveNumber('floatSizeDesktop', 'floatSizeMobile');
          const baseScale = Math.max(0.2, (Number(section.dataset.floatBaseScale) || 100) / 100);
          const floatSpacing = getResponsiveNumber('floatSpacingDesktop', 'floatSpacingMobile');
          const floatDirection = section.dataset.floatDirection === 'rtl' ? 'rtl' : 'ltr';
          const entryBuffer = Math.max(16, Math.round(floatSize * 0.18));

          floatItems.forEach((item, index) => {
            const baseYPercent = window.matchMedia('(max-width: 749px)').matches
              ? Number(item.dataset.verticalMobile) || 68
              : Number(item.dataset.verticalDesktop) || 68;
            const x =
              floatDirection === 'rtl'
                ? sectionWidth + entryBuffer - index * floatSpacing
                : -floatSize - entryBuffer + index * floatSpacing;
            const y = (sectionHeight * baseYPercent) / 100 - floatSize / 2;
            item.style.setProperty('--dream-float-size', `${floatSize}px`);
            item.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${baseScale})`;
          });
        };

        const renderAnimatedFloats = (elapsedSeconds) => {
          const bounds = getFloatBounds();
          const sectionWidth = bounds.clientWidth;
          const sectionHeight = bounds.clientHeight;
          const floatSize = getResponsiveNumber('floatSizeDesktop', 'floatSizeMobile');
          const baseScale = Math.max(0.2, (Number(section.dataset.floatBaseScale) || 100) / 100);
          const floatSpacing = getResponsiveNumber('floatSpacingDesktop', 'floatSpacingMobile');
          const hillHeight = getResponsiveNumber('hillHeightDesktop', 'hillHeightMobile');
          const duration = getFloatDuration();
          const crestScaleBoost = Math.max(0, (Number(section.dataset.crestScale) || 110) / 100 - 1);
          const troughScaleFactor = Math.max(0.45, 1 - crestScaleBoost * 0.45);
          const floatDirection = section.dataset.floatDirection === 'rtl' ? 'rtl' : 'ltr';
          const entryBuffer = Math.max(16, Math.round(floatSize * 0.18));
          const startX = -floatSize - entryBuffer;
          const endX = sectionWidth + entryBuffer;
          const pathRange = Math.max(1, endX - startX);
          const pixelsPerSecond = pathRange / duration;
          const loopLength = Math.max(floatSpacing * Math.max(floatItems.length, 1), floatSpacing);
          const travelDistance = elapsedSeconds * pixelsPerSecond;

          floatItems.forEach((item) => {
            const itemIndex = Number(item.dataset.index) || 0;
            const baseYPercent = window.matchMedia('(max-width: 749px)').matches
              ? Number(item.dataset.verticalMobile) || 68
              : Number(item.dataset.verticalDesktop) || 68;
            const laneMultiplier = getLaneMultiplier(itemIndex);
            let x =
              floatDirection === 'rtl'
                ? endX + itemIndex * floatSpacing - travelDistance
                : startX - itemIndex * floatSpacing + travelDistance;

            if (floatDirection === 'rtl') {
              while (x < startX) x += loopLength;
            } else {
              while (x > endX) x -= loopLength;
            }

            const pathProgress =
              floatDirection === 'rtl'
                ? Math.min(Math.max((endX - x) / pathRange, 0), 1)
                : Math.min(Math.max((x - startX) / pathRange, 0), 1);
            const arcProgress = Math.sin(pathProgress * Math.PI);
            const scaleProgress = Math.pow(arcProgress, 2.2);
            const y =
              (sectionHeight * baseYPercent) / 100 -
              floatSize / 2 +
              laneMultiplier * hillHeight * arcProgress;
            const scale = baseScale * (troughScaleFactor + (1 + crestScaleBoost - troughScaleFactor) * scaleProgress);

            item.style.setProperty('--dream-float-size', `${floatSize}px`);
            item.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
          });
        };

        const renderScrollFloats = (progress) => {
          const bounds = getFloatBounds();
          const sectionWidth = bounds.clientWidth;
          const sectionHeight = bounds.clientHeight;
          const floatSize = getResponsiveNumber('floatSizeDesktop', 'floatSizeMobile');
          const baseScale = Math.max(0.2, (Number(section.dataset.floatBaseScale) || 100) / 100);
          const floatSpacing = getResponsiveNumber('floatSpacingDesktop', 'floatSpacingMobile');
          const hillHeight = getResponsiveNumber('hillHeightDesktop', 'hillHeightMobile');
          const crestScaleBoost = Math.max(0, (Number(section.dataset.crestScale) || 110) / 100 - 1);
          const troughScaleFactor = Math.max(0.45, 1 - crestScaleBoost * 0.45);
          const floatDirection = section.dataset.floatDirection === 'rtl' ? 'rtl' : 'ltr';
          const entryBuffer = Math.max(16, Math.round(floatSize * 0.18));
          const startX = -floatSize - entryBuffer;
          const endX = sectionWidth + entryBuffer;
          const pathRange = Math.max(1, endX - startX);
          const lastItemIndex = Math.max(floatItems.length - 1, 0);
          const exitBuffer = Math.max(0, Math.round(floatSize));
          const totalTravelDistance = endX + lastItemIndex * floatSpacing + exitBuffer;
          const travelDistance = Math.max(0, Math.min(1, progress)) * totalTravelDistance;

          floatItems.forEach((item) => {
            const itemIndex = Number(item.dataset.index) || 0;
            const baseYPercent = window.matchMedia('(max-width: 749px)').matches
              ? Number(item.dataset.verticalMobile) || 68
              : Number(item.dataset.verticalDesktop) || 68;
            const laneMultiplier = getLaneMultiplier(itemIndex);
            const x =
              floatDirection === 'rtl'
                ? endX + itemIndex * floatSpacing - travelDistance
                : startX - itemIndex * floatSpacing + travelDistance;
            const pathProgress =
              floatDirection === 'rtl'
                ? Math.min(Math.max((endX - x) / pathRange, 0), 1)
                : Math.min(Math.max((x - startX) / pathRange, 0), 1);
            const arcProgress = Math.sin(pathProgress * Math.PI);
            const scaleProgress = Math.pow(arcProgress, 2.2);
            const y =
              (sectionHeight * baseYPercent) / 100 -
              floatSize / 2 +
              laneMultiplier * hillHeight * arcProgress;
            const scale = baseScale * (troughScaleFactor + (1 + crestScaleBoost - troughScaleFactor) * scaleProgress);

            item.style.setProperty('--dream-float-size', `${floatSize}px`);
            item.style.transform = `translate3d(${x}px, ${y}px, 0) scale(${scale})`;
          });
        };

        const animateFloats = (now) => {
          if (floatAnimationStartTime === null) {
            floatAnimationStartTime = now;
          }

          renderAnimatedFloats((now - floatAnimationStartTime) / 1000);

          floatFrameId = window.requestAnimationFrame(animateFloats);
        };

        const startFloatAnimation = () => {
          if (floatItems.length === 0 || floatFrameId || isScrollMode) return;

          if (reducedMotion) {
            section.classList.remove('is-pending');
            section.classList.add('is-floats-active');
            applyStaticFloatLayout();
            return;
          }

          const initialLeadSeconds = 0.55;
          floatAnimationStartTime = performance.now() - initialLeadSeconds * 1000;
          renderAnimatedFloats(initialLeadSeconds);
          section.classList.add('is-floats-active');
          floatFrameId = window.requestAnimationFrame(animateFloats);
        };

        const stopFloatAnimation = () => {
          if (!floatFrameId) return;
          window.cancelAnimationFrame(floatFrameId);
          floatFrameId = null;
          floatAnimationStartTime = null;
        };

        const handleResize = () => {
          if (resizeFrameId) window.cancelAnimationFrame(resizeFrameId);
          resizeFrameId = window.requestAnimationFrame(() => {
            if (reducedMotion) {
              applyStaticFloatLayout();
            } else if (isScrollMode) {
              renderScrollFloats(scrubProgress);
            } else if (useMobileAutoplayFallback && runtimeColorScrollHandler) {
              runtimeColorScrollHandler();
            }
          });
        };

        const handleViewportResize = () => {
          if (shouldIgnoreViewportChromeResize()) return;
          handleResize();
        };

        const handleMotionChange = (event) => {
          reducedMotion = event.matches;
          stopFloatAnimation();
          if (intersectionObserver) {
            intersectionObserver.disconnect();
            intersectionObserver = null;
          }
          if (activationTrigger) {
            activationTrigger.kill();
            activationTrigger = null;
          }
          if (scrollProxyTween) {
            scrollProxyTween.kill();
            scrollProxyTween = null;
          }
          if (reducedMotion) {
            section.classList.remove('is-pending');
            section.classList.add('is-active');
            applyStaticFloatLayout();
            section.classList.add('is-floats-active');
            return;
          }

          hasActivated = false;
          section.classList.remove('is-active');
          section.classList.remove('is-floats-active');
          if (isScrollMode) {
            section.classList.remove('is-pending');
          } else {
            section.classList.add('is-pending');
          }
          setupActivation();
        };

        const activateSection = () => {
          if (hasActivated) return;
          hasActivated = true;
          section.classList.add('is-active');
          section.classList.add('is-floats-active');
          if (isScrollMode && contentInner && window.gsap) {
            window.gsap.set(contentInner, { autoAlpha: 1, clearProps: 'opacity,visibility' });
            if (revealWords.length > 0) {
              window.gsap.set(revealWords, {
                autoAlpha: 1,
                yPercent: 0,
                rotationX: 0,
                clearProps: 'opacity,visibility,transform',
              });
            }
          } else if (contentInner && window.gsap) {
            if (revealWords.length > 0) {
              const timeline = window.gsap.timeline();
              timeline.set(contentInner, { autoAlpha: 1, clearProps: 'transform' });
              timeline.fromTo(
                revealWords,
                {
                  autoAlpha: 0,
                  yPercent: 130,
                  rotationX: -18,
                  transformOrigin: '50% 100%',
                },
                {
                  duration: 1.2,
                  autoAlpha: 1,
                  yPercent: 0,
                  rotationX: 0,
                  ease: 'power4.out',
                  stagger: 0.15,
                  clearProps: 'opacity,visibility,transform',
                }
              );
            } else {
              window.gsap.to(contentInner, {
                duration: 1,
                autoAlpha: 1,
                y: 0,
                ease: 'power4.out',
                clearProps: 'opacity,visibility,transform',
              });
            }
          }
          section.classList.remove('is-pending');
          startFloatAnimation();
        };

        const setupGsapScrollMode = () => {
          if (!window.gsap || !window.ScrollTrigger || activationTrigger) return false;

          if (typeof window.gsap.registerPlugin === 'function') {
            window.gsap.registerPlugin(window.ScrollTrigger);
          }

          section.classList.remove('is-pending');
          activateSection();
          scrubProgress = 0;
          renderScrollFloats(0);

          const scrollProxy = { progress: 0 };

          scrollProxyTween = window.gsap.to(scrollProxy, {
            progress: 1,
            ease: 'none',
            paused: true,
            onUpdate: () => {
              scrubProgress = scrollProxy.progress;
              section.classList.add('is-floats-active');
              renderScrollFloats(scrollProxy.progress);
            },
          });

          activationTrigger = window.ScrollTrigger.create({
            trigger: section,
            start: () => `top top+=${getHeaderOffset()}px`,
            end: () => `+=${getScrollDistance()}`,
            pin: true,
            animation: scrollProxyTween,
            scrub: getScrollScrubValue(),
            anticipatePin: 1,
            invalidateOnRefresh: true,
            onToggle: (self) => {
              setRuntimeColorActive(self.isActive);
            },
            onRefresh: (self) => {
              if (scrollProxyTween) {
                scrollProxyTween.progress(self.progress || 0).pause();
              }
              scrubProgress = self.progress || 0;
              renderScrollFloats(scrubProgress);
            },
          });

          return true;
        };

        const setupRuntimeColorObservation = () => {
          if (!enableRuntimeColorTransition || isScrollMode || runtimeColorObserver || !window.IntersectionObserver) return;

          if (useMobileAutoplayFallback) {
            const updateMobileRuntimeColor = () => {
              runtimeColorFrameId = null;
              const rect = section.getBoundingClientRect();
              const scrollableDistance = Math.max(rect.height - window.innerHeight, 1);
              const progress = Math.min(Math.max(-rect.top / scrollableDistance, 0), 1);
              const isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
              const catchProgress = 0.5;
              const isCaught = isVisible && progress >= catchProgress;

              setRuntimeColorActive(isCaught);
            };

            runtimeColorScrollHandler = () => {
              if (runtimeColorFrameId) return;
              runtimeColorFrameId = window.requestAnimationFrame(updateMobileRuntimeColor);
            };

            window.addEventListener('scroll', runtimeColorScrollHandler, { passive: true });
            window.addEventListener('orientationchange', runtimeColorScrollHandler);
            runtimeColorScrollHandler();
            return;
          }

          runtimeColorObserver = new window.IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                setRuntimeColorActive(entry.isIntersecting);
              });
            },
            {
              threshold: 0,
              rootMargin: '-32% 0px -32% 0px'
            }
          );

          runtimeColorObserver.observe(section);
        };

        const setupGsapActivation = () => {
          if (!window.gsap || !window.ScrollTrigger || activationTrigger) return false;

          if (typeof window.gsap.registerPlugin === 'function') {
            window.gsap.registerPlugin(window.ScrollTrigger);
          }

          if (contentInner) {
            window.gsap.set(contentInner, { autoAlpha: 0, y: 24 });
          }

          if (revealWords.length > 0) {
            window.gsap.set(revealWords, { autoAlpha: 0, yPercent: 130, rotationX: -18, transformOrigin: '50% 100%' });
          }

          activationTrigger = window.ScrollTrigger.create({
            trigger: getActivationTriggerElement(),
            start: 'bottom+=300 bottom',
            once: true,
            onEnter: () => {
              activateSection();
            },
          });

          return true;
        };

        const setupIntersectionFallback = () => {
          if (intersectionObserver || activationTrigger || reducedMotion) return;

          intersectionObserver = new window.IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                activateSection();
                if (intersectionObserver) intersectionObserver.disconnect();
                intersectionObserver = null;
              });
            },
            {
              threshold: 0,
              rootMargin: '0px 0px -300px 0px'
            }
          );
          intersectionObserver.observe(getActivationTriggerElement());
        };

        const setupActivation = () => {
          if (reducedMotion) {
            section.classList.remove('is-pending');
            section.classList.add('is-active');
            applyStaticFloatLayout();
            section.classList.add('is-floats-active');
            setupRuntimeColorObservation();
            return;
          }

          if (isScrollMode) {
            if (setupGsapScrollMode()) return;
            section.classList.remove('is-pending');
            section.classList.add('is-active');
            renderScrollFloats(0);
            section.classList.add('is-floats-active');
            return;
          }

          setupRuntimeColorObservation();
          if (setupGsapActivation()) return;
          setupIntersectionFallback();
        };

        buildRevealWords();

        if (!reducedMotion && !window.gsap && document.readyState !== 'complete') {
          loadHandler = () => {
            loadHandler = null;
            setupActivation();
          };
          window.addEventListener('load', loadHandler, { once: true });
        } else {
          setupActivation();
        }

        window.addEventListener('resize', handleViewportResize);
        window.addEventListener('orientationchange', handleResize);
        prefersReducedMotion.addEventListener('change', handleMotionChange);

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(handleResize).catch(() => {});
        }

        if (window.ResizeObserver) {
          resizeObserver = new window.ResizeObserver(handleResize);
          resizeObserver.observe(section);
        }

        cleanups.set(section, () => {
          setRuntimeColorActive(false);
          stopFloatAnimation();
          if (resizeFrameId) window.cancelAnimationFrame(resizeFrameId);
          window.removeEventListener('resize', handleViewportResize);
          window.removeEventListener('orientationchange', handleResize);
          prefersReducedMotion.removeEventListener('change', handleMotionChange);
          if (runtimeColorScrollHandler) {
            window.removeEventListener('scroll', runtimeColorScrollHandler);
            window.removeEventListener('orientationchange', runtimeColorScrollHandler);
          }
          if (runtimeColorFrameId) window.cancelAnimationFrame(runtimeColorFrameId);
          if (loadHandler) window.removeEventListener('load', loadHandler);
          if (intersectionObserver) intersectionObserver.disconnect();
          if (runtimeColorObserver) runtimeColorObserver.disconnect();
          if (activationTrigger) activationTrigger.kill();
          if (scrollProxyTween) scrollProxyTween.kill();
          if (resizeObserver) resizeObserver.disconnect();
        });

        section.dataset.dreamInitialized = 'true';
      });
    };

    initializeDreamSections(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeDreamSections(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-dream-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-archive-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__featuredArchiveHeadingFitInitialized) {
      return;
    }
    window.__featuredArchiveHeadingFitInitialized = true;

    const fitHeading = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const fitEnabled = isMobile
        ? heading.dataset.fitEnabledMobile === 'true'
        : heading.dataset.fitEnabledDesktop === 'true';
      const min = Number(heading.dataset.fitMin) || 40;
      const max = Number(heading.dataset.fitMax) || 2400;
      const nowrap = heading.dataset.fitNowrap === 'true';
      const availableWidth = heading.clientWidth;

      if (!availableWidth) return;

      if (!fitEnabled) {
        heading.style.removeProperty('font-size');
        heading.style.removeProperty('letter-spacing');
        return;
      }

      const getLineMetrics = () => {
        const range = document.createRange();
        range.selectNodeContents(heading);

        const rawRects = Array.from(range.getClientRects()).filter((rect) => rect.width > 1 && rect.height > 1);
        const lines = [];

        rawRects.forEach((rect) => {
          const existingLine = lines.find((line) => Math.abs(line.top - rect.top) < 2);

          if (existingLine) {
            existingLine.left = Math.min(existingLine.left, rect.left);
            existingLine.right = Math.max(existingLine.right, rect.right);
            existingLine.top = Math.min(existingLine.top, rect.top);
            existingLine.bottom = Math.max(existingLine.bottom, rect.bottom);
            return;
          }

          lines.push({
            top: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            right: rect.right,
          });
        });

        if (typeof range.detach === 'function') {
          range.detach();
        }

        if (!lines.length) {
          return {
            lineCount: 1,
            widestLine: Math.ceil(heading.getBoundingClientRect().width),
          };
        }

        return {
          lineCount: lines.length,
          widestLine: Math.ceil(
            lines.reduce((widest, line) => Math.max(widest, line.right - line.left), 0)
          ),
        };
      };

      const setWrappedLetterSpacing = (lineCount) => {
        if (!isMobile) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount <= 1) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount === 2) {
          heading.style.letterSpacing = '0.22rem';
          return;
        }

        if (lineCount === 3) {
          heading.style.letterSpacing = '0.12rem';
          return;
        }

        heading.style.letterSpacing = '0.06rem';
      };

      const setNoWrapLetterSpacing = (fontSize) => {
        const safeMax = Math.max(max, 1);
        const minSpacing = 0.12;
        const scaledSpacing = Math.max(minSpacing, Math.min(1, fontSize / safeMax));
        heading.style.letterSpacing = `${scaledSpacing.toFixed(3)}rem`;
      };

      if (!nowrap) {
        heading.style.fontSize = `${max}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);

        if (!isMobile) {
          heading.style.fontSize = `clamp(${min}px, 10vw, ${max}px)`;
          return;
        }

        const wordCount = (heading.textContent || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean).length;
        const preferredLineCount = wordCount > 1 ? 2 : 1;
        heading.style.fontSize = `${min}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        const minimumLineCount = getLineMetrics().lineCount;
        const targetLineCount = Math.max(preferredLineCount, minimumLineCount);

        let low = min;
        let high = max;
        let best = min;

        while (high - low > 0.5) {
          const mid = (low + high) / 2;
          heading.style.fontSize = `${mid}px`;
          setWrappedLetterSpacing(getLineMetrics().lineCount);

          const { lineCount, widestLine } = getLineMetrics();

          if (lineCount <= targetLineCount && widestLine <= availableWidth) {
            best = mid;
            low = mid;
          } else {
            high = mid;
          }
        }

        heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        return;
      }

      let low = min;
      let high = max;
      let best = min;

      heading.style.fontSize = `${max}px`;
      setNoWrapLetterSpacing(max);

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        heading.style.fontSize = `${mid}px`;
        setNoWrapLetterSpacing(mid);

        if (heading.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
      setNoWrapLetterSpacing(Math.max(min, Math.min(max, best)));
    };

    const fitAll = (scope = document) => {
      scope.querySelectorAll('[data-featured-archive-fit-text]').forEach((heading) => fitHeading(heading));
    };

    let resizeRaf = null;
    const onResize = () => {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => fitAll(document));
    };

    fitAll(document);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => fitAll(document)).catch(() => {});
    }

    document.addEventListener('shopify:section:load', (event) => {
      fitAll(event.target);
    });
  })();

  (() => {
    const initFeaturedArchiveSlider = (scope = document) => {
      scope.querySelectorAll('.featured-archive--bronze[data-featured-archive-root]').forEach((root) => {
        if (root.dataset.featuredArchiveSliderBound === 'true') return;

        const viewport = root.querySelector('[data-featured-archive-viewport]');
        const prevButtons = Array.from(root.querySelectorAll('[data-featured-archive-prev]'));
        const nextButtons = Array.from(root.querySelectorAll('[data-featured-archive-next]'));
        const track = viewport ? viewport.querySelector('.featured-archive__grid') : null;

        if (!viewport || !track || !prevButtons.length || !nextButtons.length) {
          root.dataset.featuredArchiveSliderBound = 'true';
          return;
        }

        root.dataset.featuredArchiveSliderBound = 'true';

        const desktopMedia = window.matchMedia('(min-width: 750px)');

        const syncDesktopCardWidth = () => {
          if (!desktopMedia.matches || !track.classList.contains('featured-archive__grid--desktop-slider')) {
            track.style.removeProperty('--featured-archive-desktop-card-width');
            viewport.classList.remove('is-draggable');
            return;
          }

          const rootStyles = window.getComputedStyle(root);
          const columns = parseFloat(rootStyles.getPropertyValue('--featured-archive-columns-desktop')) || 4;
          const peek = parseFloat(rootStyles.getPropertyValue('--featured-archive-desktop-peek')) || 0;
          const viewportWidth = viewport.clientWidth;
          const cardWidth = (viewportWidth - peek) / columns;

          track.style.setProperty('--featured-archive-desktop-card-width', `${Math.max(cardWidth, 1)}px`);
          viewport.classList.add('is-draggable');
        };

        const getStep = () => {
          const item = viewport.querySelector('.featured-archive__item');
          if (!item) return viewport.clientWidth * 0.85;

          return item.getBoundingClientRect().width;
        };

        const syncButtons = () => {
          const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 1);
          prevButtons.forEach((button) => {
            button.disabled = viewport.scrollLeft <= 1;
          });
          nextButtons.forEach((button) => {
            button.disabled = viewport.scrollLeft >= maxScroll;
          });
        };

        prevButtons.forEach((button) => {
          button.addEventListener('click', () => {
            viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
          });
        });

        nextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
          });
        });

        let isDragging = false;
        let didDrag = false;
        let dragStartX = 0;
        let dragStartScrollLeft = 0;
        let suppressClickUntil = 0;

        const startDrag = (clientX) => {
          if (!desktopMedia.matches) return;
          isDragging = true;
          didDrag = false;
          dragStartX = clientX;
          dragStartScrollLeft = viewport.scrollLeft;
          viewport.classList.add('is-dragging');
        };

        const moveDrag = (clientX) => {
          if (!isDragging) return;
          if (Math.abs(clientX - dragStartX) > 4) {
            didDrag = true;
          }
          viewport.scrollLeft = dragStartScrollLeft - (clientX - dragStartX);
        };

        const endDrag = () => {
          if (!isDragging) return;
          if (didDrag) {
            suppressClickUntil = Date.now() + 250;
          }
          isDragging = false;
          viewport.classList.remove('is-dragging');
        };

        viewport.addEventListener('mousedown', (event) => {
          if (!desktopMedia.matches) return;
          if (event.target.closest('button, input, select, textarea')) return;
          event.preventDefault();
          startDrag(event.clientX);
        });

        viewport.addEventListener(
          'click',
          (event) => {
            if (Date.now() >= suppressClickUntil) return;
            if (!event.target.closest('a')) return;
            event.preventDefault();
            event.stopPropagation();
          },
          true
        );

        viewport.addEventListener('dragstart', (event) => {
          if (!desktopMedia.matches) return;
          event.preventDefault();
        });

        window.addEventListener('mousemove', (event) => {
          moveDrag(event.clientX);
        });

        window.addEventListener('mouseup', endDrag);
        viewport.addEventListener('mouseleave', endDrag);

        viewport.addEventListener('scroll', syncButtons, { passive: true });
        window.addEventListener('resize', () => {
          syncDesktopCardWidth();
          syncButtons();
        });

        if (desktopMedia.addEventListener) {
          desktopMedia.addEventListener('change', () => {
            syncDesktopCardWidth();
            syncButtons();
          });
        } else if (desktopMedia.addListener) {
          desktopMedia.addListener(() => {
            syncDesktopCardWidth();
            syncButtons();
          });
        }

        syncDesktopCardWidth();
        syncButtons();
      });
    };

    initFeaturedArchiveSlider(document);

    document.addEventListener('shopify:section:load', (event) => {
      initFeaturedArchiveSlider(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-archive"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__featuredArchiveHeadingFitInitialized) {
      return;
    }
    window.__featuredArchiveHeadingFitInitialized = true;

    const fitHeading = (heading) => {
      if (!heading) return;

      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const fitEnabled = isMobile
        ? heading.dataset.fitEnabledMobile === 'true'
        : heading.dataset.fitEnabledDesktop === 'true';
      const min = Number(heading.dataset.fitMin) || 40;
      const max = Number(heading.dataset.fitMax) || 2400;
      const nowrap = heading.dataset.fitNowrap === 'true';
      const availableWidth = heading.clientWidth;

      if (!availableWidth) return;

      if (!fitEnabled) {
        heading.style.removeProperty('font-size');
        heading.style.removeProperty('letter-spacing');
        return;
      }

      const getLineMetrics = () => {
        const range = document.createRange();
        range.selectNodeContents(heading);

        const rawRects = Array.from(range.getClientRects()).filter((rect) => rect.width > 1 && rect.height > 1);
        const lines = [];

        rawRects.forEach((rect) => {
          const existingLine = lines.find((line) => Math.abs(line.top - rect.top) < 2);

          if (existingLine) {
            existingLine.left = Math.min(existingLine.left, rect.left);
            existingLine.right = Math.max(existingLine.right, rect.right);
            existingLine.top = Math.min(existingLine.top, rect.top);
            existingLine.bottom = Math.max(existingLine.bottom, rect.bottom);
            return;
          }

          lines.push({
            top: rect.top,
            bottom: rect.bottom,
            left: rect.left,
            right: rect.right,
          });
        });

        if (typeof range.detach === 'function') {
          range.detach();
        }

        if (!lines.length) {
          return {
            lineCount: 1,
            widestLine: Math.ceil(heading.getBoundingClientRect().width),
          };
        }

        return {
          lineCount: lines.length,
          widestLine: Math.ceil(
            lines.reduce((widest, line) => Math.max(widest, line.right - line.left), 0)
          ),
        };
      };

      const setWrappedLetterSpacing = (lineCount) => {
        if (!isMobile) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount <= 1) {
          heading.style.letterSpacing = '1rem';
          return;
        }

        if (lineCount === 2) {
          heading.style.letterSpacing = '0.22rem';
          return;
        }

        if (lineCount === 3) {
          heading.style.letterSpacing = '0.12rem';
          return;
        }

        heading.style.letterSpacing = '0.06rem';
      };

      const setNoWrapLetterSpacing = (fontSize) => {
        const safeMax = Math.max(max, 1);
        const minSpacing = 0.12;
        const scaledSpacing = Math.max(minSpacing, Math.min(1, fontSize / safeMax));
        heading.style.letterSpacing = `${scaledSpacing.toFixed(3)}rem`;
      };

      if (!nowrap) {
        heading.style.fontSize = `${max}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);

        if (!isMobile) {
          heading.style.fontSize = `clamp(${min}px, 10vw, ${max}px)`;
          return;
        }

        const wordCount = (heading.textContent || '')
          .trim()
          .split(/\s+/)
          .filter(Boolean).length;
        const preferredLineCount = wordCount > 1 ? 2 : 1;
        heading.style.fontSize = `${min}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        const minimumLineCount = getLineMetrics().lineCount;
        const targetLineCount = Math.max(preferredLineCount, minimumLineCount);

        let low = min;
        let high = max;
        let best = min;

        while (high - low > 0.5) {
          const mid = (low + high) / 2;
          heading.style.fontSize = `${mid}px`;
          setWrappedLetterSpacing(getLineMetrics().lineCount);

          const { lineCount, widestLine } = getLineMetrics();

          if (lineCount <= targetLineCount && widestLine <= availableWidth) {
            best = mid;
            low = mid;
          } else {
            high = mid;
          }
        }

        heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
        setWrappedLetterSpacing(getLineMetrics().lineCount);
        return;
      }

      let low = min;
      let high = max;
      let best = min;

      heading.style.fontSize = `${max}px`;
      setNoWrapLetterSpacing(max);

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        heading.style.fontSize = `${mid}px`;
        setNoWrapLetterSpacing(mid);

        if (heading.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
      setNoWrapLetterSpacing(Math.max(min, Math.min(max, best)));
    };

    const fitAll = (scope = document) => {
      scope.querySelectorAll('[data-featured-archive-fit-text]').forEach((heading) => fitHeading(heading));
    };

    let resizeRaf = null;
    const onResize = () => {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(() => fitAll(document));
    };

    fitAll(document);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => fitAll(document)).catch(() => {});
    }

    document.addEventListener('shopify:section:load', (event) => {
      fitAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const cleanups = window.__footerEasterEggCleanups || new Map();
    window.__footerEasterEggCleanups = cleanups;

    const initialize = (target = document) => {
      const sections = target.matches && target.matches('[data-footer-section]')
        ? [target]
        : Array.from(target.querySelectorAll('[data-footer-section]'));

      sections.forEach((section) => {
        if (section.dataset.footerEasterEggInitialized === 'true') return;

        const easterEggBlocks = Array.from(section.querySelectorAll('[data-footer-easter-egg-block]'));
        const removers = [];

        easterEggBlocks.forEach((easterEggBlock) => {
          const trigger = easterEggBlock.querySelector('[data-footer-easter-egg-trigger]');
          const dialog = easterEggBlock.querySelector('[data-footer-easter-egg-dialog]');
          const closeButton = easterEggBlock.querySelector('[data-footer-easter-egg-close]');
          const dialogIframe = easterEggBlock.querySelector('[data-footer-easter-egg-iframe]');
          const dialogVideo = easterEggBlock.querySelector('video.footer-block__easter-egg-dialog-media--video');

          if (!trigger || !dialog) return;

          let lastFocusedElement = null;

          const restoreFocus = () => {
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
              lastFocusedElement.focus();
            }
            lastFocusedElement = null;
          };

          const stopPlayback = () => {
            if (dialogIframe) {
              dialogIframe.removeAttribute('src');
            }

            if (dialogVideo) {
              dialogVideo.pause();
              dialogVideo.currentTime = 0;
            }
          };

          const openDialog = () => {
            lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

            if (typeof dialog.showModal === 'function') {
              if (!dialog.open) dialog.showModal();
            } else {
              dialog.setAttribute('open', 'open');
            }

            if (dialogIframe && dialogIframe.dataset.src) {
              dialogIframe.src = dialogIframe.dataset.src;
            }

            if (dialogVideo) {
              dialogVideo.currentTime = 0;
              const playPromise = dialogVideo.play();
              if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
              }
            }

            window.requestAnimationFrame(() => {
              if (closeButton) closeButton.focus();
            });
          };

          const closeDialog = () => {
            if (dialog.open && typeof dialog.close === 'function') {
              dialog.close();
              return;
            }

            dialog.removeAttribute('open');
            stopPlayback();
            restoreFocus();
          };

          const triggerHandler = () => openDialog();
          const closeHandler = () => closeDialog();
          const backdropHandler = (event) => {
            if (event.target === dialog) closeDialog();
          };
          const dialogCloseHandler = () => {
            stopPlayback();
            restoreFocus();
          };

          trigger.addEventListener('click', triggerHandler);
          dialog.addEventListener('click', backdropHandler);
          dialog.addEventListener('close', dialogCloseHandler);

          if (closeButton) {
            closeButton.addEventListener('click', closeHandler);
          }

          removers.push(() => {
            trigger.removeEventListener('click', triggerHandler);
            dialog.removeEventListener('click', backdropHandler);
            dialog.removeEventListener('close', dialogCloseHandler);
            if (closeButton) {
              closeButton.removeEventListener('click', closeHandler);
            }
            stopPlayback();
          });
        });

        cleanups.set(section, () => {
          removers.forEach((remove) => remove());
        });

        section.dataset.footerEasterEggInitialized = 'true';
      });
    };

    initialize(document);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-footer-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const initializeHeaderDrawer = (target = document) => {
      const headers = target.querySelectorAll('header[data-section-id]');

      headers.forEach((header) => {
        if (header.dataset.drawerInitialized === 'true') return;

        const sectionWrapper = header.closest('.shopify-section');
        const groupWrapper = sectionWrapper ? sectionWrapper.closest('.shopify-section-group-header-group') : null;
        if (sectionWrapper) {
          sectionWrapper.classList.add('header-section');
          sectionWrapper.classList.toggle('header-section--sticky', header.classList.contains('header--sticky'));
        }
        if (groupWrapper) {
          groupWrapper.classList.add('header-group-surface');
        }

        const sectionId = header.dataset.sectionId;
        const drawer = document.getElementById(`HeaderDrawer-${sectionId}`);
        const openButton = header.querySelector('[data-drawer-open]');
        const headerShell = document.getElementById('site-header-shell');

        if (!drawer || !openButton) return;

        const panel = drawer.querySelector('.header-drawer__panel');
        const nav = drawer.querySelector('.header-drawer__nav');
        const previewElement = drawer.querySelector(`#HeaderDrawerPreview-${sectionId}`);
        const previewPrimary = previewElement ? previewElement.querySelector('[data-preview-layer="primary"]') : null;
        const previewSecondary = previewElement ? previewElement.querySelector('[data-preview-layer="secondary"]') : null;
        const closeButtons = drawer.querySelectorAll('[data-drawer-close]');
        const menuItems = drawer.querySelectorAll('[data-drawer-menu-item]');
        const desktopMenuLinks = drawer.querySelectorAll('.header-drawer__menu-link[data-drawer-menu-item]');
        const closeAnimationDuration = 240;
        let closeTimeoutId = null;
        let isOpen = false;
        let isClosing = false;
        let menuTimeline = null;
        let hasBuiltMenuTimeline = false;
        let activePreviewLayer = previewPrimary;
        let inactivePreviewLayer = previewSecondary;
        let previewSwapToken = 0;
        let preloadStarted = false;
        let headerResizeObserver = null;
        const preloadedPreviewSources = new Set();
        const previewIsImage = Boolean(previewPrimary && previewSecondary);
        const defaultPreviewSrc = previewIsImage
          ? previewElement.dataset.defaultPreview || previewPrimary.getAttribute('src') || ''
          : '';
        const defaultPreviewAlt = previewIsImage ? previewElement.dataset.defaultAlt || '' : '';
        const closedBackground = header.dataset.closedBackground || '';
        const closedBackgroundGradient = header.dataset.closedBackgroundGradient || '';

        const applyHeaderGroupState = ({ hidden = false, transparent = false } = {}) => {
          if (groupWrapper) {
            const computedHeader = window.getComputedStyle(header);
            const runtimeBackground = computedHeader.getPropertyValue('--color-background').trim();
            const runtimeGradient = computedHeader.getPropertyValue('--color-background-gradient').trim();

            if (runtimeBackground) {
              groupWrapper.style.setProperty('--header-group-bg', runtimeBackground);
            } else if (closedBackground) {
              groupWrapper.style.setProperty('--header-group-bg', closedBackground);
            }
            if (runtimeGradient && runtimeGradient !== 'none') {
              groupWrapper.style.setProperty('--header-group-gradient', runtimeGradient);
            } else if (closedBackgroundGradient && closedBackgroundGradient !== 'none') {
              groupWrapper.style.setProperty('--header-group-gradient', closedBackgroundGradient);
            } else {
              groupWrapper.style.setProperty('--header-group-gradient', 'none');
            }

            groupWrapper.classList.toggle('is-hidden', hidden);
            groupWrapper.classList.toggle('is-transparent', transparent);
          }
          if (headerShell) {
            if (hidden) {
              headerShell.setAttribute('hidden', '');
              headerShell.style.display = 'none';
              headerShell.style.opacity = '0';
              headerShell.style.visibility = 'hidden';
              headerShell.style.pointerEvents = 'none';
            } else {
              const wasHidden = headerShell.hasAttribute('hidden') || headerShell.style.display === 'none';
              headerShell.removeAttribute('hidden');
              headerShell.style.display = '';
              if (wasHidden) {
                headerShell.style.opacity = '0';
                headerShell.style.visibility = 'visible';
                headerShell.style.pointerEvents = '';
                window.requestAnimationFrame(() => {
                  headerShell.style.opacity = '1';
                });
              }
            }
            if (!hidden) {
              headerShell.style.visibility = 'visible';
              headerShell.style.pointerEvents = '';
              if (headerShell.style.opacity !== '1') {
                headerShell.style.opacity = '1';
              }
            }
          }
          header.style.opacity = hidden ? '0' : '';
          header.style.visibility = hidden ? 'hidden' : '';
        };

        const clearCloseTimeout = () => {
          if (!closeTimeoutId) return;
          window.clearTimeout(closeTimeoutId);
          closeTimeoutId = null;
        };

        const preventBackgroundKeyboardScroll = (event) => {
          if (!isOpen) return;

          const scrollKeys = ['Space', 'PageDown', 'PageUp', 'End', 'Home', 'ArrowDown', 'ArrowUp'];
          if (!scrollKeys.includes(event.code)) return;
          if (drawer.contains(event.target) || header.contains(event.target)) return;

          event.preventDefault();
        };

        const preloadPreviewSource = (src) => {
          if (!src || preloadedPreviewSources.has(src)) return;

          const preloadImage = new Image();
          preloadedPreviewSources.add(src);
          preloadImage.decoding = 'async';
          preloadImage.fetchPriority = 'low';
          preloadImage.src = src;
        };

        const startPreviewPreload = () => {
          if (preloadStarted || !previewIsImage) return;
          preloadStarted = true;

          const uniqueSources = new Set();
          if (defaultPreviewSrc) uniqueSources.add(defaultPreviewSrc);
          desktopMenuLinks.forEach((menuLink) => {
            if (menuLink.dataset.previewImage) uniqueSources.add(menuLink.dataset.previewImage);
          });

          const run = () => {
            uniqueSources.forEach((src) => preloadPreviewSource(src));
          };

          if ('requestIdleCallback' in window) {
            window.requestIdleCallback(run, { timeout: 1200 });
          } else {
            window.setTimeout(run, 120);
          }
        };

        const setPreviewFromLink = (link) => {
          if (!previewIsImage || !link || !activePreviewLayer || !inactivePreviewLayer) return;

          const nextSrc = link.dataset.previewImage || defaultPreviewSrc;
          const nextAlt = link.dataset.previewAlt || defaultPreviewAlt;

          if (!nextSrc) return;
          if (activePreviewLayer.getAttribute('src') === nextSrc) return;

          previewSwapToken += 1;
          const swapToken = previewSwapToken;

          inactivePreviewLayer.setAttribute('alt', nextAlt);

          const activateIncomingLayer = () => {
            if (swapToken !== previewSwapToken) return;

            inactivePreviewLayer.classList.add('is-active');
            activePreviewLayer.classList.remove('is-active');

            const previousActiveLayer = activePreviewLayer;
            activePreviewLayer = inactivePreviewLayer;
            inactivePreviewLayer = previousActiveLayer;
          };

          const prepareAndActivate = () => {
            if (typeof inactivePreviewLayer.decode === 'function') {
              inactivePreviewLayer.decode().then(activateIncomingLayer).catch(activateIncomingLayer);
            } else {
              activateIncomingLayer();
            }
          };

          if (inactivePreviewLayer.getAttribute('src') !== nextSrc) {
            inactivePreviewLayer.setAttribute('src', nextSrc);
          }

          if (inactivePreviewLayer.complete) {
            prepareAndActivate();
          } else {
            inactivePreviewLayer.addEventListener('load', prepareAndActivate, { once: true });
            inactivePreviewLayer.addEventListener('error', activateIncomingLayer, { once: true });
          }
        };

        const setActiveMenuLink = (link) => {
          desktopMenuLinks.forEach((menuLink) => menuLink.classList.toggle('is-active', menuLink === link));
        };

        const getMenuTimeline = () => {
          if (hasBuiltMenuTimeline) return menuTimeline;
          if (!window.gsap || typeof window.gsap.timeline !== 'function' || menuItems.length === 0) return null;

          hasBuiltMenuTimeline = true;
          menuTimeline = window.gsap.timeline({ paused: true });
          menuTimeline.fromTo(
            menuItems,
            { autoAlpha: 0, y: 20 },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.44,
              ease: 'power3.out',
              stagger: 0.07,
              overwrite: 'auto',
            },
          );

          return menuTimeline;
        };

        let lastViewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        let lastViewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

        const shouldIgnoreViewportChromeResize = () => {
          const nextWidth = window.innerWidth || document.documentElement.clientWidth || lastViewportWidth;
          const nextHeight = window.innerHeight || document.documentElement.clientHeight || lastViewportHeight;
          const widthChanged = Math.abs(nextWidth - lastViewportWidth) > 2;
          const heightChanged = Math.abs(nextHeight - lastViewportHeight) > 2;

          lastViewportWidth = nextWidth;
          lastViewportHeight = nextHeight;

          return window.matchMedia('(hover: none), (pointer: coarse)').matches && !widthChanged && heightChanged;
        };

        const syncHeaderHeight = () => {
          const headerHeight = Math.max(1, Math.round(header.getBoundingClientRect().height || 0));
          const runtimeHeight = groupWrapper
            ? Math.max(
                1,
                Math.round(groupWrapper.offsetHeight || 0),
                Math.round(groupWrapper.getBoundingClientRect().height || 0),
                headerHeight,
              )
            : headerHeight;

          drawer.style.setProperty('--header-runtime-height', `${runtimeHeight}px`);
          document.documentElement.style.setProperty('--header-runtime-height', `${runtimeHeight}px`);
          if (groupWrapper) {
            groupWrapper.style.setProperty('--header-runtime-height', `${runtimeHeight}px`);
          }

          const smoothWrapper = document.getElementById('smooth-wrapper');
          const smoothContent = document.getElementById('smooth-content');
          const overlayActive = document.documentElement.classList.contains('theme-home-hero-overlay');
          if (smoothWrapper) {
            const wrapperTop = Math.max(0, smoothWrapper.offsetTop || 0);
            const compensation = overlayActive ? 0 : Math.max(0, runtimeHeight - wrapperTop);
            smoothWrapper.style.paddingTop = '';
            if (smoothContent) {
              smoothContent.style.paddingTop = compensation > 0 ? `${compensation}px` : '';
            }
          }

          document.dispatchEvent(
            new CustomEvent('theme:layout:changed', {
              detail: { source: 'header', headerHeight: runtimeHeight },
            }),
          );
        };

        if ('ResizeObserver' in window) {
          headerResizeObserver = new ResizeObserver(() => {
            syncHeaderHeight();
            if (isOpen) syncOpenSchemeRuntimeVars();
          });
          headerResizeObserver.observe(header);
          if (groupWrapper) {
            headerResizeObserver.observe(groupWrapper);
          }
        }

        const handleViewportResize = () => {
          if (shouldIgnoreViewportChromeResize()) return;
          syncHeaderHeight();
          if (isOpen) syncOpenSchemeRuntimeVars();
        };

        const syncOpenSchemeRuntimeVars = () => {
          const computed = window.getComputedStyle(drawer);
          const openForeground = computed.getPropertyValue('--color-foreground').trim();
          const openLinkHover = computed.getPropertyValue('--color-link-hover').trim();
          const openBackground = computed.getPropertyValue('--color-background').trim();
          const openGradient = computed.getPropertyValue('--color-background-gradient').trim();

          if (openForeground) {
            header.style.setProperty('--header-open-color-foreground-runtime', openForeground);
          }
          if (openLinkHover) {
            header.style.setProperty('--header-open-color-link-hover-runtime', openLinkHover);
          }
          if (openBackground) {
            header.style.setProperty('--header-open-color-background-runtime', openBackground);
          }
          if (openGradient) {
            header.style.setProperty('--header-open-color-gradient-runtime', openGradient);
          } else {
            header.style.removeProperty('--header-open-color-gradient-runtime');
          }
        };

        const syncClosedSchemeRuntimeVars = () => {
          if (!groupWrapper) return;
          const computed = window.getComputedStyle(header);
          const closedRuntimeBackground = computed.getPropertyValue('--color-background').trim();
          const closedRuntimeGradient = computed.getPropertyValue('--color-background-gradient').trim();

          if (closedRuntimeBackground) {
            groupWrapper.style.setProperty('--header-group-bg', closedRuntimeBackground);
          }
          if (closedRuntimeGradient && closedRuntimeGradient !== 'none') {
            groupWrapper.style.setProperty('--header-group-gradient', closedRuntimeGradient);
          } else {
            groupWrapper.style.setProperty('--header-group-gradient', 'none');
          }
        };

        const handleHeroHeaderState = (event) => {
          const detail = event.detail || {};
          const overlayEnabled = detail.overlayEnabled === true;
          const ready = detail.ready === true;
          const atTop = detail.atTop !== false;

          if (!overlayEnabled) {
            applyHeaderGroupState({ hidden: false, transparent: false });
            return;
          }

          applyHeaderGroupState({
            hidden: !ready,
            transparent: !ready || atTop,
          });
        };

        syncClosedSchemeRuntimeVars();

        const setDrawerState = (isOpen) => {
          openButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
          openButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
          header.classList.toggle('is-drawer-open', isOpen);
          if (sectionWrapper) {
            sectionWrapper.classList.toggle('is-drawer-open', isOpen);
          }
          drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
          document.documentElement.classList.toggle('theme-drawer-open', isOpen);
          document.body.classList.toggle('theme-drawer-open', isOpen);

          if (isOpen) {
            document.addEventListener('keydown', preventBackgroundKeyboardScroll, true);
          } else {
            document.removeEventListener('keydown', preventBackgroundKeyboardScroll, true);
          }
        };

        const openDrawer = () => {
          if (isOpen && !isClosing) return;

          clearCloseTimeout();
          isClosing = false;
          isOpen = true;
          startPreviewPreload();
          syncHeaderHeight();
          drawer.hidden = false;
          syncOpenSchemeRuntimeVars();
          setDrawerState(true);

          window.requestAnimationFrame(() => {
            syncOpenSchemeRuntimeVars();
            drawer.classList.add('is-visible');
            const timeline = getMenuTimeline();
            if (timeline) {
              timeline.timeScale(1);
              timeline.play(0);
            }
            const activeOrFirst = drawer.querySelector('.header-drawer__menu-link.is-active') || desktopMenuLinks[0];
            if (activeOrFirst) {
              setActiveMenuLink(activeOrFirst);
              setPreviewFromLink(activeOrFirst);
            }
            if (nav && typeof nav.focus === 'function') {
              nav.focus({ preventScroll: true });
            }
          });
        };

        const closeDrawer = () => {
          if (!isOpen || isClosing) return;

          isClosing = true;
          setDrawerState(false);
          const timeline = getMenuTimeline();
          let closeDuration = closeAnimationDuration;
          if (timeline) {
            timeline.timeScale(1.1);
            timeline.reverse();
            closeDuration = Math.max(closeAnimationDuration, Math.round((timeline.duration() * 1000) / 1.1));
          }

          drawer.classList.remove('is-visible');
          clearCloseTimeout();
          closeTimeoutId = window.setTimeout(() => {
            drawer.hidden = true;
            isOpen = false;
            isClosing = false;
            if (timeline) timeline.pause(0);
            clearCloseTimeout();
          }, closeDuration);
        };

        openButton.addEventListener('click', () => {
          if (isOpen && !isClosing) {
            closeDrawer();
            return;
          }

          openDrawer();
        });

        openButton.addEventListener('mouseenter', startPreviewPreload, { passive: true });
        openButton.addEventListener('focus', startPreviewPreload, { passive: true });
        openButton.addEventListener('touchstart', startPreviewPreload, { passive: true, once: true });

        closeButtons.forEach((closeButton) => {
          closeButton.addEventListener('click', closeDrawer);
        });

        const onEscapeClose = (event) => {
          if (event.key !== 'Escape' || !isOpen) return;
          event.preventDefault();
          closeDrawer();
        };

        document.addEventListener('keydown', onEscapeClose);
        document.addEventListener('theme:hero-header-state', handleHeroHeaderState);

        window.addEventListener('resize', handleViewportResize);

        window.addEventListener('orientationchange', syncHeaderHeight);

        drawer.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', closeDrawer);
        });

        desktopMenuLinks.forEach((menuLink) => {
          menuLink.addEventListener('mouseenter', () => {
            if (window.matchMedia('(max-width: 749px)').matches) return;
            setActiveMenuLink(menuLink);
            setPreviewFromLink(menuLink);
          });

          menuLink.addEventListener('focus', () => {
            setActiveMenuLink(menuLink);
            setPreviewFromLink(menuLink);
          });
        });

        const menuList = drawer.querySelector('.header-drawer__menu');
        if (menuList) {
          menuList.addEventListener('mouseleave', () => {
            const activeOrFirst = drawer.querySelector('.header-drawer__menu-link.is-active') || desktopMenuLinks[0];
            if (activeOrFirst) setPreviewFromLink(activeOrFirst);
          });
        }

        if (panel) {
          panel.addEventListener('click', (event) => {
            event.stopPropagation();
          });
        }

        const logoImage = header.querySelector('.header__logo-image');
        if (logoImage && !logoImage.complete) {
          logoImage.addEventListener('load', syncHeaderHeight, { once: true });
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(syncHeaderHeight).catch(() => {});
        }

        if (document.readyState === 'complete') {
          startPreviewPreload();
        } else {
          window.addEventListener('load', startPreviewPreload, { once: true });
        }

        setDrawerState(false);
        syncOpenSchemeRuntimeVars();
        applyHeaderGroupState({
          hidden: document.documentElement.classList.contains('theme-home-hero-overlay'),
          transparent: document.documentElement.classList.contains('theme-home-hero-overlay'),
        });
        syncHeaderHeight();
        window.requestAnimationFrame(() => {
          syncHeaderHeight();
          window.setTimeout(syncHeaderHeight, 120);
        });
        header.dataset.drawerInitialized = 'true';
      });
    };

    initializeHeaderDrawer(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHeaderDrawer(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animation-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const overlayClass = 'theme-home-hero-overlay';
    const overlayTopClass = 'theme-home-hero-at-top';
    const headerReadyClass = 'theme-home-hero-header-ready';

    const getFinalLogoTop = (section) => {
      const styles = window.getComputedStyle(section);
      return window.matchMedia('(max-width: 989px)').matches
        ? styles.getPropertyValue('--hero-2-logo-final-top-mobile').trim() || 'calc(70svh - 0.5rem)'
        : styles.getPropertyValue('--hero-2-logo-final-top-desktop').trim() || 'calc(70svh - 1rem)';
    };

    const getSectionWrapper = (section) => section.closest('.shopify-section');

    const isFirstContentSection = (section) => {
      const sectionWrapper = getSectionWrapper(section);
      const smoothContent = document.getElementById('smooth-content');

      if (!sectionWrapper || !smoothContent) return false;

      const contentRoot = document.getElementById('MainContent') || smoothContent;
      const firstContentSection = contentRoot.querySelector('.shopify-section');

      return firstContentSection === sectionWrapper;
    };

    const syncHeaderOverlayMode = (section, shouldEnable) => {
      const enableOverlay = shouldEnable && section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.documentElement.classList.toggle(overlayClass, enableOverlay);
      document.body.classList.toggle(overlayClass, enableOverlay);
      if (!enableOverlay) {
        document.documentElement.classList.remove(overlayTopClass);
        document.body.classList.remove(overlayTopClass);
        emitHeroHeaderState(section, { ready: false, atTop: true });
      }
      document.dispatchEvent(
        new CustomEvent('theme:layout:changed', {
          detail: { source: 'hero-animation-2', headerOverlay: enableOverlay },
        }),
      );
    };

    const setHeroTopState = (isAtTop) => {
      document.documentElement.classList.toggle(overlayTopClass, isAtTop);
      document.body.classList.toggle(overlayTopClass, isAtTop);
    };

    const setHeaderReadyState = (isReady) => {
      document.documentElement.classList.toggle(headerReadyClass, isReady);
      document.body.classList.toggle(headerReadyClass, isReady);
    };

    const emitHeroHeaderState = (section, { ready = false, atTop = true } = {}) => {
      const overlayEnabled = section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.dispatchEvent(
        new CustomEvent('theme:hero-header-state', {
          detail: {
            overlayEnabled,
            ready,
            atTop,
          },
        }),
      );
    };

    const applyHeroScrollProgress = ({ section, logoContainer, imageAsset, progress }) => {
      if (section.dataset.enableHomepageHeaderOverlay !== 'true' || !isFirstContentSection(section)) return;

      const clampedProgress = Math.min(Math.max(progress || 0, 0), 1);
      const logoOpacity = Math.max(0, 1 - clampedProgress);
      const imageScale = 1 + clampedProgress * 0.08;

      logoContainer.style.opacity = `${logoOpacity}`;
      if (imageAsset) {
        imageAsset.style.transform = `scale(${imageScale})`;
      }

      const isAtTop = clampedProgress < 0.08;
      setHeroTopState(isAtTop);
      emitHeroHeaderState(section, {
        ready: document.documentElement.classList.contains(headerReadyClass),
        atTop: isAtTop,
      });
    };

    const getTargetLogoFontSize = (logoText, container) => {
      if (!logoText || !container) return null;

      const min = 48;
      const max = Math.max(140, window.innerWidth * 0.34);
      const computed = window.getComputedStyle(container);
      const paddingLeft = Number.parseFloat(computed.paddingLeft || '0') || 0;
      const paddingRight = Number.parseFloat(computed.paddingRight || '0') || 0;
      const availableWidth = container.clientWidth - paddingLeft - paddingRight;

      if (!availableWidth) return null;

      let low = min;
      let high = max;
      let best = min;

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        logoText.style.fontSize = `${mid}px`;

        if (logoText.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      return Math.max(min, Math.min(max, best));
    };

    const getMaskGeometry = (section) => {
      const stage = section.querySelector('.hero-2-bg-image') || section;
      const rect = stage.getBoundingClientRect();
      const width = Math.max(1, Math.round(rect.width || stage.clientWidth || window.innerWidth || 1));
      const height = Math.max(1, Math.round(rect.height || stage.clientHeight || window.innerHeight || 1));
      const initialWidth = 0;
      const initialHeight = 0;

      return {
        width,
        height,
        initialWidth,
        initialHeight,
        initialX: (width - initialWidth) / 2,
        initialY: (height - initialHeight) / 2,
      };
    };

    const applyMaskGeometry = ({ svg, imageAsset, maskBase, maskRect, geometry, expanded = false }) => {
      if (!geometry) return;

      const { width, height, initialWidth, initialHeight, initialX, initialY } = geometry;

      if (svg) {
        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      }

      if (imageAsset) {
        imageAsset.setAttribute('width', `${width}`);
        imageAsset.setAttribute('height', `${height}`);
      }

      if (maskBase) {
        maskBase.setAttribute('width', `${width}`);
        maskBase.setAttribute('height', `${height}`);
      }

      if (maskRect) {
        if (expanded) {
          maskRect.setAttribute('x', '0');
          maskRect.setAttribute('y', '0');
          maskRect.setAttribute('width', `${width}`);
          maskRect.setAttribute('height', `${height}`);
        } else {
          maskRect.setAttribute('x', `${initialX}`);
          maskRect.setAttribute('y', `${initialY}`);
          maskRect.setAttribute('width', `${initialWidth}`);
          maskRect.setAttribute('height', `${initialHeight}`);
        }
      }
    };

    const buildTimeline = ({
      maskRect,
      maskGeometry,
      videoAsset,
      logoContainer,
      logoText,
      contentBlock,
      startFontSize,
      targetFontSize,
      onHeaderReady,
    }) => {
      const timeline = window.gsap.timeline({ paused: true });

      timeline.to({}, { duration: 1 });
      timeline.addLabel('mask');

      if (videoAsset) {
        timeline.fromTo(
          videoAsset,
          {
            clipPath: 'inset(50% 50% 50% 50%)',
          },
          {
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: 1.6,
            ease: 'power2.inOut',
          },
          'mask'
        );
      } else if (maskRect && maskGeometry) {
        timeline.to(
          maskRect,
          {
            attr: {
              x: 0,
              y: 0,
              width: maskGeometry.width,
              height: maskGeometry.height,
            },
            duration: 1.6,
            ease: 'power2.inOut',
          },
          'mask'
        );
      }

      timeline.addLabel('headline', 'mask+=1.6');

      timeline.to(
        logoContainer,
        {
          top: getFinalLogoTop(logoContainer.closest('[data-hero-animation-2-section]')),
          duration: 1.15,
          ease: 'power2.inOut',
        },
        'headline'
      );

      timeline.to(
        logoText,
        {
          fontSize: `${targetFontSize || startFontSize}px`,
          duration: 1.15,
          ease: 'power2.inOut',
        },
        'headline'
      );

      timeline.addLabel('content', 'headline+=1.15');

      if (typeof onHeaderReady === 'function') {
        timeline.call(() => {
          onHeaderReady();
        }, [], 'content');
      }

      timeline.to(
        contentBlock,
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          clearProps: 'transform',
        },
        'content'
      );

      return timeline;
    };

    const setFinalState = (section, targetFontSize, maskGeometry) => {
      const svg = section.querySelector('.hero-2-bg-image-svg');
      const imageWrapper = section.querySelector('.hero-2-bg-image');
      const imageAsset = section.querySelector('.hero-2-bg-image-asset');
      const videoAsset = section.querySelector('.hero-2-bg-video');
      const maskBase = section.querySelector('.hero-2-bg-mask-base');
      const maskRect = section.querySelector('.hero-2-bg-mask-rect');
      const logoContainer = section.querySelector('.hero-2-logo-container');
      const logoText = section.querySelector('.hero-2-logo-text');
      const contentBlock = section.querySelector('.hero-2-content-block');

      applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: true });
      if (videoAsset) videoAsset.style.clipPath = 'inset(0% 0% 0% 0%)';
      if (logoContainer) logoContainer.style.top = getFinalLogoTop(section);
      if (logoText && targetFontSize) {
        logoText.style.fontSize = `${targetFontSize}px`;
      }
      if (contentBlock) {
        contentBlock.style.opacity = '1';
        contentBlock.style.transform = 'translate3d(0, 0, 0)';
      }

      section.dataset.heroAnimationPlayed = 'true';
      setHeaderReadyState(true);
      emitHeroHeaderState(section, { ready: true, atTop: true });
    };

    const initializeHeroAnimationSection = (scope = document) => {
      scope.querySelectorAll('[data-hero-animation-2-section]').forEach((section) => {
        if (section.dataset.heroAnimationInitialized === 'true') return;

        const svg = section.querySelector('.hero-2-bg-image-svg');
        const imageAsset = section.querySelector('.hero-2-bg-image-asset');
        const videoAsset = section.querySelector('.hero-2-bg-video');
        const maskBase = section.querySelector('.hero-2-bg-mask-base');
        const maskRect = section.querySelector('.hero-2-bg-mask-rect');
        const logoContainer = section.querySelector('.hero-2-logo-container');
        const logoText = section.querySelector('.hero-2-logo-text');
        const contentBlock = section.querySelector('.hero-2-content-block');

        if (!logoContainer || !logoText || !contentBlock) return;

        syncHeaderOverlayMode(section, true);
        setHeaderReadyState(false);
        emitHeroHeaderState(section, { ready: false, atTop: true });

        let maskGeometry = getMaskGeometry(section);
        applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });

        const startFontSize = Number.parseFloat(window.getComputedStyle(logoText).fontSize || '0') || 64;
        const targetFontSize = getTargetLogoFontSize(logoText, logoContainer);
        logoText.style.fontSize = `${startFontSize}px`;

        const getScrollFadeDistance = () => Math.max(180, Math.min(window.innerHeight * 0.32, 320));

        const syncHeroScrollState = () => {
          const rect = section.getBoundingClientRect();
          const fadeDistance = getScrollFadeDistance();
          const progress = Math.min(Math.max((-rect.top || 0) / fadeDistance, 0), 1);
          applyHeroScrollProgress({ section, logoContainer, imageAsset: videoAsset || imageAsset, progress });
        };

        const syncPlayedLogoSize = () => {
          maskGeometry = getMaskGeometry(section);

          if (section.dataset.heroAnimationPlayed !== 'true') return;

          const resizedTargetFontSize = getTargetLogoFontSize(logoText, logoContainer) || startFontSize;
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: true });
          if (videoAsset) videoAsset.style.clipPath = 'inset(0% 0% 0% 0%)';
          logoContainer.style.top = getFinalLogoTop(section);
          logoText.style.fontSize = `${resizedTargetFontSize}px`;
        };

        const syncInitialMaskSize = () => {
          if (section.dataset.heroAnimationPlayed === 'true') return;
          maskGeometry = getMaskGeometry(section);
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });
          if (videoAsset) videoAsset.style.clipPath = 'inset(50% 50% 50% 50%)';
        };

        let resizeFrame = null;
        let scrollFrame = null;
        let heroScrollTrigger = null;
        let heroScrollProxyTween = null;
        const requestPlayedLogoSync = () => {
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(() => {
            syncInitialMaskSize();
            syncPlayedLogoSize();
          });
        };
        const requestScrollSync = () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            syncHeroScrollState();
          });
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.gsap) {
          setFinalState(section, targetFontSize, maskGeometry);
          section.dataset.heroAnimationInitialized = 'true';
          window.addEventListener('resize', requestPlayedLogoSync);
          window.addEventListener('scroll', requestScrollSync, { passive: true });
          document.addEventListener('theme:layout:changed', requestScrollSync);
          requestScrollSync();

          let reducedMotionResizeObserver = null;
          if (window.ResizeObserver) {
            reducedMotionResizeObserver = new window.ResizeObserver(() => {
              requestPlayedLogoSync();
              requestScrollSync();
            });
            reducedMotionResizeObserver.observe(section);
          }

          cleanups.set(section, () => {
            window.removeEventListener('resize', requestPlayedLogoSync);
            window.removeEventListener('scroll', requestScrollSync);
            document.removeEventListener('theme:layout:changed', requestScrollSync);
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
            if (reducedMotionResizeObserver) reducedMotionResizeObserver.disconnect();
            logoContainer.style.opacity = '';
            if (imageAsset) imageAsset.style.transform = '';
            if (videoAsset) {
              videoAsset.style.transform = '';
              videoAsset.style.clipPath = '';
            }
            setHeroTopState(false);
            setHeaderReadyState(false);
            emitHeroHeaderState(section, { ready: false, atTop: true });
            syncHeaderOverlayMode(section, false);
          });
          return;
        }

        if (window.ScrollTrigger && typeof window.gsap.registerPlugin === 'function') {
          window.gsap.registerPlugin(window.ScrollTrigger);
        }

        let timeline = buildTimeline({
          maskRect,
          maskGeometry,
          videoAsset,
          logoContainer,
          logoText,
          contentBlock,
          startFontSize,
          targetFontSize,
          onHeaderReady: () => {
            setHeaderReadyState(true);
            emitHeroHeaderState(section, { ready: true, atTop: true });
          },
        });

        let hasPlayed = false;
        const playTimeline = () => {
          if (hasPlayed) return;
          hasPlayed = true;

          maskGeometry = getMaskGeometry(section);
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });
          if (videoAsset) videoAsset.style.clipPath = 'inset(50% 50% 50% 50%)';
          const refreshedTargetFontSize = getTargetLogoFontSize(logoText, logoContainer) || targetFontSize || startFontSize;
          logoText.style.fontSize = `${startFontSize}px`;

          timeline.kill();
          timeline = buildTimeline({
            maskRect,
            maskGeometry,
            videoAsset,
            logoContainer,
            logoText,
            contentBlock,
            startFontSize,
            targetFontSize: refreshedTargetFontSize,
            onHeaderReady: () => {
              setHeaderReadyState(true);
              emitHeroHeaderState(section, { ready: true, atTop: true });
            },
          });

          timeline.eventCallback('onComplete', () => {
            section.dataset.heroAnimationPlayed = 'true';
            requestPlayedLogoSync();
          });
          timeline.play(0);
        };

        let resizeObserver = null;
        window.addEventListener('resize', requestPlayedLogoSync);
        document.addEventListener('theme:layout:changed', requestScrollSync);
        if (window.ResizeObserver) {
          resizeObserver = new window.ResizeObserver(() => {
            requestPlayedLogoSync();
            requestScrollSync();
          });
          resizeObserver.observe(section);
        }
        if (window.ScrollTrigger) {
          const heroScrollProxy = { progress: 0 };
          heroScrollProxyTween = window.gsap.to(heroScrollProxy, {
            progress: 1,
            ease: 'none',
            paused: true,
            onUpdate: () => {
              applyHeroScrollProgress({
                section,
                logoContainer,
                imageAsset: videoAsset || imageAsset,
                progress: heroScrollProxy.progress,
              });
            },
          });

          heroScrollTrigger = window.ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: () => `+=${getScrollFadeDistance()}`,
            animation: heroScrollProxyTween,
            scrub: 1,
            invalidateOnRefresh: true,
            onRefresh: (self) => {
              if (heroScrollProxyTween) {
                heroScrollProxyTween.progress(self.progress || 0).pause();
              }
              applyHeroScrollProgress({
                section,
                logoContainer,
                imageAsset: videoAsset || imageAsset,
                progress: self.progress || 0,
              });
            },
          });
        } else {
          window.addEventListener('scroll', requestScrollSync, { passive: true });
          requestScrollSync();
        }

        let trigger = null;
        if (window.ScrollTrigger) {
          trigger = window.ScrollTrigger.create({
            trigger: section,
            start: 'top 80%',
            once: true,
            onEnter: () => {
              playTimeline();
            },
          });
        } else {
          window.requestAnimationFrame(() => {
            playTimeline();
          });
        }

        cleanups.set(section, () => {
          if (trigger) trigger.kill();
          if (timeline) timeline.kill();
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          window.removeEventListener('resize', requestPlayedLogoSync);
          window.removeEventListener('scroll', requestScrollSync);
          document.removeEventListener('theme:layout:changed', requestScrollSync);
          if (resizeObserver) resizeObserver.disconnect();
          if (heroScrollTrigger) heroScrollTrigger.kill();
          if (heroScrollProxyTween) heroScrollProxyTween.kill();
          logoContainer.style.opacity = '';
          if (imageAsset) imageAsset.style.transform = '';
          if (videoAsset) {
            videoAsset.style.transform = '';
            videoAsset.style.clipPath = '';
          }
          setHeroTopState(false);
          setHeaderReadyState(false);
          emitHeroHeaderState(section, { ready: false, atTop: true });
          syncHeaderOverlayMode(section, false);
        });

        section.dataset.heroAnimationInitialized = 'true';
      });
    };

    initializeHeroAnimationSection(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHeroAnimationSection(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-hero-animation-2-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animation-3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const overlayClass = 'theme-home-hero-overlay';
    const overlayTopClass = 'theme-home-hero-at-top';
    const headerReadyClass = 'theme-home-hero-header-ready';
    const logoHiddenClass = 'theme-home-hero-3-hide-logo';
    const logoWhiteClass = 'theme-home-hero-3-white-logo';
    const heroSeenStateNamespace = 'themeHeroAnimation3Seen';

    const getSectionWrapper = (section) => section.closest('.shopify-section');
    const getHeroSeenStateKey = (section) => `${window.location.pathname}::${section.id || 'hero-animation-3'}`;

    const readHeroSeenState = (section) => {
      const stateKey = getHeroSeenStateKey(section);

      try {
        const historyState = window.history.state;
        if (historyState && historyState[heroSeenStateNamespace] && historyState[heroSeenStateNamespace][stateKey]) {
          return true;
        }
      } catch (_) {}

      try {
        return window.sessionStorage.getItem(stateKey) === 'true';
      } catch (_) {
        return false;
      }
    };

    const writeHeroSeenState = (section) => {
      const stateKey = getHeroSeenStateKey(section);

      try {
        window.sessionStorage.setItem(stateKey, 'true');
      } catch (_) {}

      try {
        const currentState =
          window.history.state && typeof window.history.state === 'object' ? window.history.state : {};
        const nextHeroSeenState = {
          ...(currentState[heroSeenStateNamespace] || {}),
          [stateKey]: true,
        };

        window.history.replaceState(
          {
            ...currentState,
            [heroSeenStateNamespace]: nextHeroSeenState,
          },
          document.title,
        );
      } catch (_) {}
    };

    const isFirstContentSection = (section) => {
      const sectionWrapper = getSectionWrapper(section);
      const smoothContent = document.getElementById('smooth-content');

      if (!sectionWrapper || !smoothContent) return false;

      const contentRoot = document.getElementById('MainContent') || smoothContent;
      const firstContentSection = contentRoot.querySelector('.shopify-section');

      return firstContentSection === sectionWrapper;
    };

    const syncHeaderOverlayMode = (section, shouldEnable) => {
      const enableOverlay = shouldEnable && section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.documentElement.classList.toggle(overlayClass, enableOverlay);
      document.body.classList.toggle(overlayClass, enableOverlay);

      if (!enableOverlay) {
        document.documentElement.classList.remove(overlayTopClass);
        document.body.classList.remove(overlayTopClass);
        emitHeroHeaderState(section, { ready: false, atTop: true });
      }

      document.dispatchEvent(
        new CustomEvent('theme:layout:changed', {
          detail: { source: 'hero-animation-3', headerOverlay: enableOverlay },
        }),
      );
    };

    const setHeroTopState = (isAtTop) => {
      document.documentElement.classList.toggle(overlayTopClass, isAtTop);
      document.body.classList.toggle(overlayTopClass, isAtTop);
    };

    const setHeaderReadyState = (isReady) => {
      document.documentElement.classList.toggle(headerReadyClass, isReady);
      document.body.classList.toggle(headerReadyClass, isReady);
    };

    const setHeroLogoHiddenState = (isHidden) => {
      document.documentElement.classList.toggle(logoHiddenClass, isHidden);
      document.body.classList.toggle(logoHiddenClass, isHidden);
    };

    const setHeroLogoWhiteState = (isWhite) => {
      document.documentElement.classList.toggle(logoWhiteClass, isWhite);
      document.body.classList.toggle(logoWhiteClass, isWhite);
    };

    const syncHeroLogoTreatment = (section, isActive) => {
      const treatment = section.dataset.headerLogoTreatment || 'hide';
      const shouldHide = isActive && treatment === 'hide';
      const shouldWhite = isActive && treatment === 'white';

      setHeroLogoHiddenState(shouldHide);
      setHeroLogoWhiteState(shouldWhite);
    };

    const ensureHeaderVisible = () => {
      const headerShell = document.getElementById('site-header-shell');
      if (!headerShell) return;

      headerShell.hidden = false;
      headerShell.style.opacity = '1';
      headerShell.style.visibility = 'visible';
      headerShell.style.pointerEvents = 'auto';
    };

    const resetHeaderVisibility = () => {
      const headerShell = document.getElementById('site-header-shell');
      if (!headerShell) return;

      headerShell.style.opacity = '';
      headerShell.style.visibility = '';
      headerShell.style.pointerEvents = '';
    };

    const emitHeroHeaderState = (section, { ready = false, atTop = true } = {}) => {
      const overlayEnabled = section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.dispatchEvent(
        new CustomEvent('theme:hero-header-state', {
          detail: {
            overlayEnabled,
            ready,
            atTop,
          },
        }),
      );
    };

    const playVideo = (videos) => {
      if (!videos || !videos.length) return;

      videos.forEach((video) => {
        if (!video) return;

        const isHidden = window.getComputedStyle(video).display === 'none';
        if (isHidden) {
          video.pause();
          return;
        }

        video.muted = true;
        video.playsInline = true;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    };

    const syncStackAspectRatio = (section) => {
      const isMobile = window.matchMedia('(max-width: 989px)').matches;
      section.style.setProperty('--hero-3-stack-padding-top', isMobile ? '150%' : '75%');
    };

    const setNoWrapHeadingLetterSpacing = (heading, fontSize, max) => {
      const safeMax = Math.max(max, 1);
      const minSpacing = 0.08;
      const spacing = Math.max(minSpacing, Math.min(0.34, fontSize / safeMax));
      heading.style.setProperty('letter-spacing', `${spacing.toFixed(3)}rem`, 'important');
    };

    const fitHeading = (section) => {
      if (section?.dataset?.heroVideoDialogOpen === 'true') return;

      const heading = section.querySelector('.hero-3-heading');
      const layer = section.querySelector('.hero-3-heading-layer');
      const inner = section.querySelector('.hero-3-heading-inner');

      if (!heading || !layer) return;

      const target = inner || layer;
      const computed = window.getComputedStyle(target);
      const paddingLeft = Number.parseFloat(computed.paddingLeft || '0') || 0;
      const paddingRight = Number.parseFloat(computed.paddingRight || '0') || 0;
      const availableWidth = target.clientWidth - paddingLeft - paddingRight;

      if (!availableWidth) return;

      const min = window.matchMedia('(max-width: 749px)').matches ? 28 : 48;
      const max = Math.max(140, Math.min(availableWidth, 520));
      heading.style.wordBreak = 'normal';
      heading.style.overflowWrap = 'normal';
      heading.style.hyphens = 'none';
      heading.style.whiteSpace = 'nowrap';
      heading.style.textWrap = 'nowrap';
      heading.style.maxWidth = 'none';
      heading.style.width = 'auto';

      let low = min;
      let high = max;
      let best = min;

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        heading.style.fontSize = `${mid}px`;
        setNoWrapHeadingLetterSpacing(heading, mid, max);

        if (heading.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      heading.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
      setNoWrapHeadingLetterSpacing(heading, Math.max(min, Math.min(max, best)), max);
    };

    const setAnimatedState = (element, { opacity = 0, translateY = '0px' } = {}) => {
      if (!element) return;
      element.style.opacity = `${opacity}`;
      element.style.transform = `translate3d(0, ${translateY}, 0)`;
    };

    const animateElement = (element, { delay = 0, duration = 720, translateY = '18px' } = {}) => {
      if (!element) return null;
      setAnimatedState(element, { opacity: 0, translateY });
      element.style.transition = 'none';

      return window.requestAnimationFrame(() => {
        element.style.transition = `transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, opacity ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`;
        element.style.opacity = '1';
        element.style.transform = 'translate3d(0, 0, 0)';
      });
    };

    const animateBackground = (element, { delay = 0, duration = 1600, translateY = '100%' } = {}) => {
      if (!element) return null;
      element.style.transform = `translate3d(0, ${translateY}, 0)`;
      element.style.transition = 'none';

      return window.requestAnimationFrame(() => {
        element.style.transition = `transform ${duration}ms cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`;
        element.style.transform = 'translate3d(0, 0, 0)';
      });
    };

    const initializeHeroAnimation3Section = (scope = document) => {
      scope.querySelectorAll('[data-hero-animation-3-section]').forEach((section) => {
        if (section.dataset.heroAnimationInitialized === 'true') return;

        const background = section.querySelector('.hero-3-background');
        const cards = Array.from(section.querySelectorAll('[data-hero-3-card]'));
        const fades = Array.from(section.querySelectorAll('[data-hero-3-fade]'));
        const videos = Array.from(section.querySelectorAll('.hero-3-card-video'));
        const finalCard = section.querySelector('[data-hero-3-final-card]');
        const bottomRow = section.querySelector('.hero-3-bottom-row');
        const videoTrigger = section.querySelector('[data-hero-3-video-trigger]');
        const videoDialog = section.querySelector('[data-hero-3-video-dialog]');
        const videoCloseButton = videoDialog ? videoDialog.querySelector('[data-hero-3-video-close]') : null;
        const dialogIframe = videoDialog ? videoDialog.querySelector('[data-hero-3-dialog-iframe]') : null;
        const dialogVideo = videoDialog ? videoDialog.querySelector('video.hero-3-video-dialog__media') : null;
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const shouldTrackHeroScroll = () =>
          section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

        syncHeaderOverlayMode(section, true);
        if (shouldTrackHeroScroll()) {
          ensureHeaderVisible();
          setHeaderReadyState(true);
          syncHeroLogoTreatment(section, true);
          emitHeroHeaderState(section, { ready: true, atTop: true });
        }

        let videoTimer = null;
        let finalCardTransitionHandler = null;
        let finalCardVideoTriggered = false;
        let resizeFrame = null;
        let scrollFrame = null;
        let resizeObserver = null;
        let animationFrames = [];
        let lastHeroTopState = null;
        let lastFocusedElement = null;
        let isVideoDialogOpen = false;
        let pendingBackgroundVideoPlayback = false;
        let animationCompletionTimer = null;
        let dialogOpenHandler = null;
        let dialogCloseHandler = null;
        let dialogBackdropHandler = null;
        let closeButtonHandler = null;
        let lastViewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;
        let lastViewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const shouldUseSeenState = readHeroSeenState(section);
        const animatedFades =
          shouldUseSeenState && bottomRow ? fades.filter((item) => item !== bottomRow) : fades;
        const isVideoWatchStateActive = () => section.dataset.heroVideoDialogOpen === 'true';
        const shouldIgnoreViewportChromeResize = () => {
          const nextWidth = window.innerWidth || document.documentElement.clientWidth || lastViewportWidth;
          const nextHeight = window.innerHeight || document.documentElement.clientHeight || lastViewportHeight;
          const widthChanged = Math.abs(nextWidth - lastViewportWidth) > 2;
          const heightChanged = Math.abs(nextHeight - lastViewportHeight) > 2;

          lastViewportWidth = nextWidth;
          lastViewportHeight = nextHeight;

          return window.matchMedia('(hover: none), (pointer: coarse)').matches && !widthChanged && heightChanged;
        };
        const setVideoWatchState = (isActive) => {
          if (isActive) {
            section.dataset.heroVideoDialogOpen = 'true';
            return;
          }

          delete section.dataset.heroVideoDialogOpen;
        };

        const stopDialogPlayback = () => {
          if (dialogIframe) {
            dialogIframe.removeAttribute('src');
          }

          if (dialogVideo) {
            dialogVideo.pause();
            dialogVideo.currentTime = 0;
          }
        };

        const resumeBackgroundVideos = () => {
          if (pendingBackgroundVideoPlayback) {
            pendingBackgroundVideoPlayback = false;
            finalCardVideoTriggered = true;
            playVideo(videos);
            return;
          }

          if (finalCardVideoTriggered || prefersReducedMotion) {
            playVideo(videos);
          }
        };

        const openVideoDialog = () => {
          if (!videoDialog) return;

          lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          setVideoWatchState(true);
          isVideoDialogOpen = true;
          if (resizeFrame) {
            window.cancelAnimationFrame(resizeFrame);
            resizeFrame = null;
          }
          videos.forEach((video) => video.pause());

          if (typeof videoDialog.showModal === 'function') {
            if (!videoDialog.open) videoDialog.showModal();
          } else {
            videoDialog.setAttribute('open', 'open');
          }

          if (dialogIframe && dialogIframe.dataset.src) {
            dialogIframe.src = dialogIframe.dataset.src;
          }

          if (dialogVideo) {
            dialogVideo.currentTime = 0;
            const playPromise = dialogVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }

          if (videoCloseButton) {
            window.requestAnimationFrame(() => videoCloseButton.focus());
          }
        };

        const closeVideoDialog = () => {
          if (!videoDialog) return;

          if (videoDialog.open && typeof videoDialog.close === 'function') {
            videoDialog.close();
            return;
          }

          videoDialog.removeAttribute('open');
          stopDialogPlayback();
          setVideoWatchState(false);
          isVideoDialogOpen = false;
          resumeBackgroundVideos();
          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
          }
        };

        const requestScrollSync = () => {
          if (!shouldTrackHeroScroll()) return;
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = null;
            const rect = section.getBoundingClientRect();
            const headerHeight =
              Number.parseFloat(
                window.getComputedStyle(document.documentElement).getPropertyValue('--header-runtime-height') || '0'
              ) || 0;
            const isWithinHero = rect.bottom > headerHeight;

            lastHeroTopState = isWithinHero;
            ensureHeaderVisible();
            setHeroTopState(isWithinHero);
            syncHeroLogoTreatment(section, isWithinHero);
            emitHeroHeaderState(section, {
              ready: true,
              atTop: isWithinHero,
            });
          });
        };

        const requestLayoutSync = () => {
          if (isVideoWatchStateActive()) return;
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(() => {
            if (isVideoWatchStateActive()) return;
            syncStackAspectRatio(section);
            fitHeading(section);
            requestScrollSync();
          });
        };

        const handleViewportResize = () => {
          if (shouldIgnoreViewportChromeResize()) return;
          requestLayoutSync();
        };

        if (shouldTrackHeroScroll()) {
          window.addEventListener('scroll', requestScrollSync, { passive: true });
        }
        window.addEventListener('resize', handleViewportResize);
        document.addEventListener('theme:layout:changed', requestLayoutSync);

        if (window.ResizeObserver) {
          resizeObserver = new window.ResizeObserver(() => {
            requestLayoutSync();
          });
          resizeObserver.observe(section);
        }

        section.querySelectorAll('.hero-3-card--image img').forEach((image) => {
          if (image.complete) {
            requestLayoutSync();
          } else {
            image.addEventListener('load', requestLayoutSync, { once: true });
          }
        });

        videos.forEach((video) => {
          video.addEventListener('loadedmetadata', requestLayoutSync, { once: true });
          video.pause();
        });

        if (videoTrigger && videoDialog) {
          dialogOpenHandler = () => openVideoDialog();
          dialogCloseHandler = () => {
            stopDialogPlayback();
            setVideoWatchState(false);
            isVideoDialogOpen = false;
            resumeBackgroundVideos();
            if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
              lastFocusedElement.focus();
            }
          };
          dialogBackdropHandler = (event) => {
            if (event.target === videoDialog) closeVideoDialog();
          };
          closeButtonHandler = () => closeVideoDialog();

          videoTrigger.addEventListener('click', dialogOpenHandler);
          videoDialog.addEventListener('close', dialogCloseHandler);
          videoDialog.addEventListener('click', dialogBackdropHandler);

          if (videoCloseButton) {
            videoCloseButton.addEventListener('click', closeButtonHandler);
          }
        }

        const markReady = () => {
          if (!shouldTrackHeroScroll()) return;
          ensureHeaderVisible();
          setHeaderReadyState(true);
          syncHeroLogoTreatment(section, true);
          emitHeroHeaderState(section, { ready: true, atTop: true });
        };

        const primeSeenStateCta = () => {
          if (!shouldUseSeenState || !bottomRow) return;

          setAnimatedState(bottomRow, { opacity: 1, translateY: '0px' });
          bottomRow.style.transition = 'none';
        };

        const showCompletedHeroState = () => {
          syncStackAspectRatio(section);
          fitHeading(section);
          if (background) background.style.transform = 'translate3d(0, 0, 0)';
          cards.forEach((card) => setAnimatedState(card, { opacity: 1, translateY: '0px' }));
          fades.forEach((item) => setAnimatedState(item, { opacity: 1, translateY: '0px' }));
          finalCardVideoTriggered = true;
          markReady();
          playVideo(videos);
        };

        if (prefersReducedMotion || !cards.length) {
          showCompletedHeroState();
          writeHeroSeenState(section);
        } else {
          const cardCount = cards.length;
          const backgroundDuration = 950;
          const cardInitialDelay = backgroundDuration + 500;
          const cardStagger = 680;
          const cardDuration = 1100;
          const lastCardDelay = Math.max(cardCount - 1, 0) * cardStagger;
          const finalCardStart = cardInitialDelay + lastCardDelay;
          const fadeDelay = cardInitialDelay + lastCardDelay + cardDuration + 80;

          markReady();
          fitHeading(section);
          primeSeenStateCta();

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              const backgroundFrame = animateBackground(background, {
                delay: 0,
                duration: backgroundDuration,
                translateY: '100%',
              });
              if (backgroundFrame) animationFrames.push(backgroundFrame);

              animationFrames = cards
                .map((card, index) =>
                  animateElement(card, {
                    delay: cardInitialDelay + index * cardStagger,
                    duration: cardDuration,
                    translateY: '18svh',
                  })
                )
                .filter(Boolean)
                .concat(animationFrames);

              animatedFades.forEach((item) => {
                const animationFrame = animateElement(item, {
                  delay: fadeDelay,
                  duration: 1800,
                  translateY: '12px',
                });

                if (animationFrame) animationFrames.push(animationFrame);
              });
            });
          });

          animationCompletionTimer = window.setTimeout(() => {
            writeHeroSeenState(section);
          }, fadeDelay + 1800);

          if (finalCard) {
            finalCardTransitionHandler = (event) => {
              if (finalCardVideoTriggered) return;
              if (event && event.target !== finalCard) return;
              if (event && event.propertyName && event.propertyName !== 'opacity') return;
              if (isVideoDialogOpen) {
                pendingBackgroundVideoPlayback = true;
                return;
              }
              finalCardVideoTriggered = true;
              playVideo(videos);
            };

            finalCard.addEventListener('transitionstart', finalCardTransitionHandler);
          }

          videoTimer = window.setTimeout(() => {
            if (!finalCardVideoTriggered && (finalCard || videos.length)) {
              if (isVideoDialogOpen) {
                pendingBackgroundVideoPlayback = true;
                return;
              }
              finalCardVideoTriggered = true;
              playVideo(videos);
            }
          }, finalCardStart + 80);
        }

        requestLayoutSync();

        cleanups.set(section, () => {
          if (videoTimer) window.clearTimeout(videoTimer);
          if (animationCompletionTimer) window.clearTimeout(animationCompletionTimer);
          if (finalCard && finalCardTransitionHandler) {
            finalCard.removeEventListener('transitionstart', finalCardTransitionHandler);
          }
          if (videoTrigger && dialogOpenHandler) {
            videoTrigger.removeEventListener('click', dialogOpenHandler);
          }
          if (videoDialog && dialogCloseHandler) {
            videoDialog.removeEventListener('close', dialogCloseHandler);
          }
          if (videoDialog && dialogBackdropHandler) {
            videoDialog.removeEventListener('click', dialogBackdropHandler);
          }
          if (videoCloseButton && closeButtonHandler) {
            videoCloseButton.removeEventListener('click', closeButtonHandler);
          }
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          window.removeEventListener('scroll', requestScrollSync);
          window.removeEventListener('resize', handleViewportResize);
          document.removeEventListener('theme:layout:changed', requestLayoutSync);
          if (resizeObserver) resizeObserver.disconnect();
          if (videoDialog) {
            stopDialogPlayback();
            setVideoWatchState(false);
            if (videoDialog.open && typeof videoDialog.close === 'function') {
              videoDialog.close();
            } else {
              videoDialog.removeAttribute('open');
            }
          }
          animationFrames.forEach((frame) => {
            if (frame) window.cancelAnimationFrame(frame);
          });
          cards.forEach((card) => {
            card.style.opacity = '';
            card.style.transform = '';
            card.style.transition = '';
          });
          videos.forEach((video) => {
            video.pause();
          });
          if (background) {
            background.style.transform = '';
            background.style.transition = '';
          }
          fades.forEach((item) => {
            item.style.opacity = '';
            item.style.transform = '';
            item.style.transition = '';
          });
          resetHeaderVisibility();
          syncHeroLogoTreatment(section, false);
          setHeroTopState(false);
          setHeaderReadyState(false);
          emitHeroHeaderState(section, { ready: false, atTop: true });
          syncHeaderOverlayMode(section, false);
        });

        section.dataset.heroAnimationInitialized = 'true';
      });
    };

    initializeHeroAnimation3Section(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHeroAnimation3Section(event.target);
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        initializeHeroAnimation3Section(document);
        document.querySelectorAll('[data-hero-animation-3-section]').forEach((section) => fitHeading(section));
      }).catch(() => {});
    }

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-hero-animation-3-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-animation"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = new WeakMap();
    const overlayClass = 'theme-home-hero-overlay';
    const overlayTopClass = 'theme-home-hero-at-top';
    const headerReadyClass = 'theme-home-hero-header-ready';

    const getFinalLogoTop = (section) => {
      const styles = window.getComputedStyle(section);
      return window.matchMedia('(max-width: 989px)').matches
        ? styles.getPropertyValue('--hero-logo-final-top-mobile').trim() || '22%'
        : styles.getPropertyValue('--hero-logo-final-top-desktop').trim() || '18%';
    };

    const getSectionWrapper = (section) => section.closest('.shopify-section');

    const isFirstContentSection = (section) => {
      const sectionWrapper = getSectionWrapper(section);
      const smoothContent = document.getElementById('smooth-content');

      if (!sectionWrapper || !smoothContent) return false;

      const contentRoot = document.getElementById('MainContent') || smoothContent;
      const firstContentSection = contentRoot.querySelector('.shopify-section');

      return firstContentSection === sectionWrapper;
    };

    const syncHeaderOverlayMode = (section, shouldEnable) => {
      const enableOverlay = shouldEnable && section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.documentElement.classList.toggle(overlayClass, enableOverlay);
      document.body.classList.toggle(overlayClass, enableOverlay);
      if (!enableOverlay) {
        document.documentElement.classList.remove(overlayTopClass);
        document.body.classList.remove(overlayTopClass);
        emitHeroHeaderState(section, { ready: false, atTop: true });
      }
      document.dispatchEvent(
        new CustomEvent('theme:layout:changed', {
          detail: { source: 'hero-animation', headerOverlay: enableOverlay },
        }),
      );
    };

    const setHeroTopState = (isAtTop) => {
      document.documentElement.classList.toggle(overlayTopClass, isAtTop);
      document.body.classList.toggle(overlayTopClass, isAtTop);
    };

    const setHeaderReadyState = (isReady) => {
      document.documentElement.classList.toggle(headerReadyClass, isReady);
      document.body.classList.toggle(headerReadyClass, isReady);
    };

    const emitHeroHeaderState = (section, { ready = false, atTop = true } = {}) => {
      const overlayEnabled = section.dataset.enableHomepageHeaderOverlay === 'true' && isFirstContentSection(section);

      document.dispatchEvent(
        new CustomEvent('theme:hero-header-state', {
          detail: {
            overlayEnabled,
            ready,
            atTop,
          },
        }),
      );
    };

    const applyHeroScrollProgress = ({ section, logoContainer, imageAsset, progress }) => {
      if (section.dataset.enableHomepageHeaderOverlay !== 'true' || !isFirstContentSection(section)) return;

      const clampedProgress = Math.min(Math.max(progress || 0, 0), 1);
      const logoOpacity = Math.max(0, 1 - clampedProgress);
      const imageScale = 1 + clampedProgress * 0.08;

      logoContainer.style.opacity = `${logoOpacity}`;
      if (imageAsset) {
        imageAsset.style.transform = `scale(${imageScale})`;
      }

      const isAtTop = clampedProgress < 0.08;
      setHeroTopState(isAtTop);
      emitHeroHeaderState(section, {
        ready: document.documentElement.classList.contains(headerReadyClass),
        atTop: isAtTop,
      });
    };

    const getTargetLogoFontSize = (logoText, container) => {
      if (!logoText || !container) return null;

      const min = 48;
      const max = Math.max(140, window.innerWidth * 0.34);
      const computed = window.getComputedStyle(container);
      const paddingLeft = Number.parseFloat(computed.paddingLeft || '0') || 0;
      const paddingRight = Number.parseFloat(computed.paddingRight || '0') || 0;
      const availableWidth = container.clientWidth - paddingLeft - paddingRight;

      if (!availableWidth) return null;

      let low = min;
      let high = max;
      let best = min;

      while (high - low > 0.5) {
        const mid = (low + high) / 2;
        logoText.style.fontSize = `${mid}px`;

        if (logoText.scrollWidth <= availableWidth) {
          best = mid;
          low = mid;
        } else {
          high = mid;
        }
      }

      return Math.max(min, Math.min(max, best));
    };

    const getMaskGeometry = (section) => {
      const rect = section.getBoundingClientRect();
      const width = Math.max(1, Math.round(rect.width || section.clientWidth || window.innerWidth || 1));
      const height = Math.max(1, Math.round(rect.height || section.clientHeight || window.innerHeight || 1));
      const initialWidth = 0;
      const initialHeight = 0;

      return {
        width,
        height,
        initialWidth,
        initialHeight,
        initialX: (width - initialWidth) / 2,
        initialY: (height - initialHeight) / 2,
      };
    };

    const applyMaskGeometry = ({ svg, imageAsset, maskBase, maskRect, geometry, expanded = false }) => {
      if (!geometry) return;

      const { width, height, initialWidth, initialHeight, initialX, initialY } = geometry;

      if (svg) {
        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      }

      if (imageAsset) {
        imageAsset.setAttribute('width', `${width}`);
        imageAsset.setAttribute('height', `${height}`);
      }

      if (maskBase) {
        maskBase.setAttribute('width', `${width}`);
        maskBase.setAttribute('height', `${height}`);
      }

      if (maskRect) {
        if (expanded) {
          maskRect.setAttribute('x', '0');
          maskRect.setAttribute('y', '0');
          maskRect.setAttribute('width', `${width}`);
          maskRect.setAttribute('height', `${height}`);
        } else {
          maskRect.setAttribute('x', `${initialX}`);
          maskRect.setAttribute('y', `${initialY}`);
          maskRect.setAttribute('width', `${initialWidth}`);
          maskRect.setAttribute('height', `${initialHeight}`);
        }
      }
    };

    const buildTimeline = ({
      maskRect,
      maskGeometry,
      videoAsset,
      logoContainer,
      logoText,
      contentBlock,
      startFontSize,
      targetFontSize,
      onHeaderReady,
    }) => {
      const timeline = window.gsap.timeline({ paused: true });

      timeline.to({}, { duration: 1 });
      timeline.addLabel('mask');

      if (videoAsset) {
        timeline.fromTo(
          videoAsset,
          {
            clipPath: 'inset(50% 50% 50% 50%)',
          },
          {
            clipPath: 'inset(0% 0% 0% 0%)',
            duration: 1.6,
            ease: 'power2.inOut',
          },
          'mask'
        );
      } else if (maskRect && maskGeometry) {
        timeline.to(
          maskRect,
          {
            attr: {
              x: 0,
              y: 0,
              width: maskGeometry.width,
              height: maskGeometry.height,
            },
            duration: 1.6,
            ease: 'power2.inOut',
          },
          'mask'
        );
      }

      timeline.addLabel('headline', 'mask+=1.6');

      timeline.to(
        logoContainer,
        {
          top: getFinalLogoTop(logoContainer.closest('[data-hero-animation-section]')),
          duration: 1.15,
          ease: 'power2.inOut',
        },
        'headline'
      );

      timeline.to(
        logoText,
        {
          fontSize: `${targetFontSize || startFontSize}px`,
          duration: 1.15,
          ease: 'power2.inOut',
        },
        'headline'
      );

      timeline.addLabel('content', 'headline+=1.15');

      if (typeof onHeaderReady === 'function') {
        timeline.call(() => {
          onHeaderReady();
        }, [], 'content');
      }

      timeline.to(
        contentBlock,
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          clearProps: 'transform',
        },
        'content'
      );

      return timeline;
    };

    const setFinalState = (section, targetFontSize, maskGeometry) => {
      const svg = section.querySelector('.hero-bg-image-svg');
      const imageWrapper = section.querySelector('.hero-bg-image');
      const imageAsset = section.querySelector('.hero-bg-image-asset');
      const videoAsset = section.querySelector('.hero-bg-video');
      const maskBase = section.querySelector('.hero-bg-mask-base');
      const maskRect = section.querySelector('.hero-bg-mask-rect');
      const logoContainer = section.querySelector('.hero-logo-container');
      const logoText = section.querySelector('.hero-logo-text');
      const contentBlock = section.querySelector('.hero-content-block');

      applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: true });
      if (videoAsset) videoAsset.style.clipPath = 'inset(0% 0% 0% 0%)';
      if (logoContainer) logoContainer.style.top = getFinalLogoTop(section);
      if (logoText && targetFontSize) {
        logoText.style.fontSize = `${targetFontSize}px`;
      }
      if (contentBlock) {
        contentBlock.style.opacity = '1';
        contentBlock.style.transform = 'translate3d(0, 0, 0)';
      }

      section.dataset.heroAnimationPlayed = 'true';
      setHeaderReadyState(true);
      emitHeroHeaderState(section, { ready: true, atTop: true });
    };

    const initializeHeroAnimationSection = (scope = document) => {
      scope.querySelectorAll('[data-hero-animation-section]').forEach((section) => {
        if (section.dataset.heroAnimationInitialized === 'true') return;

        const svg = section.querySelector('.hero-bg-image-svg');
        const imageAsset = section.querySelector('.hero-bg-image-asset');
        const videoAsset = section.querySelector('.hero-bg-video');
        const maskBase = section.querySelector('.hero-bg-mask-base');
        const maskRect = section.querySelector('.hero-bg-mask-rect');
        const logoContainer = section.querySelector('.hero-logo-container');
        const logoText = section.querySelector('.hero-logo-text');
        const contentBlock = section.querySelector('.hero-content-block');

        if (!logoContainer || !logoText || !contentBlock) return;

        syncHeaderOverlayMode(section, true);
        setHeaderReadyState(false);
        emitHeroHeaderState(section, { ready: false, atTop: true });

        let maskGeometry = getMaskGeometry(section);
        applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });

        const startFontSize = Number.parseFloat(window.getComputedStyle(logoText).fontSize || '0') || 64;
        const targetFontSize = getTargetLogoFontSize(logoText, logoContainer);
        logoText.style.fontSize = `${startFontSize}px`;

        const getScrollFadeDistance = () => Math.max(180, Math.min(window.innerHeight * 0.32, 320));

        const syncHeroScrollState = () => {
          const rect = section.getBoundingClientRect();
          const fadeDistance = getScrollFadeDistance();
          const progress = Math.min(Math.max((-rect.top || 0) / fadeDistance, 0), 1);
          applyHeroScrollProgress({ section, logoContainer, imageAsset: videoAsset || imageAsset, progress });
        };

        const syncPlayedLogoSize = () => {
          maskGeometry = getMaskGeometry(section);

          if (section.dataset.heroAnimationPlayed !== 'true') return;

          const resizedTargetFontSize = getTargetLogoFontSize(logoText, logoContainer) || startFontSize;
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: true });
          if (videoAsset) videoAsset.style.clipPath = 'inset(0% 0% 0% 0%)';
          logoContainer.style.top = getFinalLogoTop(section);
          logoText.style.fontSize = `${resizedTargetFontSize}px`;
        };

        const syncInitialMaskSize = () => {
          if (section.dataset.heroAnimationPlayed === 'true') return;
          maskGeometry = getMaskGeometry(section);
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });
          if (videoAsset) videoAsset.style.clipPath = 'inset(50% 50% 50% 50%)';
        };

        let resizeFrame = null;
        let scrollFrame = null;
        let heroScrollTrigger = null;
        let heroScrollProxyTween = null;
        const requestPlayedLogoSync = () => {
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(() => {
            syncInitialMaskSize();
            syncPlayedLogoSize();
          });
        };
        const requestScrollSync = () => {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(() => {
            syncHeroScrollState();
          });
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.gsap) {
          setFinalState(section, targetFontSize, maskGeometry);
          section.dataset.heroAnimationInitialized = 'true';
          window.addEventListener('resize', requestPlayedLogoSync);
          window.addEventListener('scroll', requestScrollSync, { passive: true });
          document.addEventListener('theme:layout:changed', requestScrollSync);
          requestScrollSync();

          let reducedMotionResizeObserver = null;
          if (window.ResizeObserver) {
            reducedMotionResizeObserver = new window.ResizeObserver(() => {
              requestPlayedLogoSync();
              requestScrollSync();
            });
            reducedMotionResizeObserver.observe(section);
          }

          cleanups.set(section, () => {
            window.removeEventListener('resize', requestPlayedLogoSync);
            window.removeEventListener('scroll', requestScrollSync);
            document.removeEventListener('theme:layout:changed', requestScrollSync);
            if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
            if (reducedMotionResizeObserver) reducedMotionResizeObserver.disconnect();
            logoContainer.style.opacity = '';
            if (imageAsset) imageAsset.style.transform = '';
            if (videoAsset) {
              videoAsset.style.transform = '';
              videoAsset.style.clipPath = '';
            }
            setHeroTopState(false);
            setHeaderReadyState(false);
            emitHeroHeaderState(section, { ready: false, atTop: true });
            syncHeaderOverlayMode(section, false);
          });
          return;
        }

        if (window.ScrollTrigger && typeof window.gsap.registerPlugin === 'function') {
          window.gsap.registerPlugin(window.ScrollTrigger);
        }

        let timeline = buildTimeline({
          maskRect,
          maskGeometry,
          videoAsset,
          logoContainer,
          logoText,
          contentBlock,
          startFontSize,
          targetFontSize,
          onHeaderReady: () => {
            setHeaderReadyState(true);
            emitHeroHeaderState(section, { ready: true, atTop: true });
          },
        });

        let hasPlayed = false;
        const playTimeline = () => {
          if (hasPlayed) return;
          hasPlayed = true;

          maskGeometry = getMaskGeometry(section);
          applyMaskGeometry({ svg, imageAsset, maskBase, maskRect, geometry: maskGeometry, expanded: false });
          if (videoAsset) videoAsset.style.clipPath = 'inset(50% 50% 50% 50%)';
          const refreshedTargetFontSize = getTargetLogoFontSize(logoText, logoContainer) || targetFontSize || startFontSize;
          logoText.style.fontSize = `${startFontSize}px`;

          timeline.kill();
          timeline = buildTimeline({
            maskRect,
            maskGeometry,
            videoAsset,
            logoContainer,
            logoText,
            contentBlock,
            startFontSize,
            targetFontSize: refreshedTargetFontSize,
            onHeaderReady: () => {
              setHeaderReadyState(true);
              emitHeroHeaderState(section, { ready: true, atTop: true });
            },
          });

          timeline.eventCallback('onComplete', () => {
            section.dataset.heroAnimationPlayed = 'true';
            requestPlayedLogoSync();
          });
          timeline.play(0);
        };

        let resizeObserver = null;
        window.addEventListener('resize', requestPlayedLogoSync);
        document.addEventListener('theme:layout:changed', requestScrollSync);
        if (window.ResizeObserver) {
          resizeObserver = new window.ResizeObserver(() => {
            requestPlayedLogoSync();
            requestScrollSync();
          });
          resizeObserver.observe(section);
        }
        if (window.ScrollTrigger) {
          const heroScrollProxy = { progress: 0 };
          heroScrollProxyTween = window.gsap.to(heroScrollProxy, {
            progress: 1,
            ease: 'none',
            paused: true,
            onUpdate: () => {
              applyHeroScrollProgress({
                section,
                logoContainer,
                imageAsset: videoAsset || imageAsset,
                progress: heroScrollProxy.progress,
              });
            },
          });

          heroScrollTrigger = window.ScrollTrigger.create({
            trigger: section,
            start: 'top top',
            end: () => `+=${getScrollFadeDistance()}`,
            animation: heroScrollProxyTween,
            scrub: 1,
            invalidateOnRefresh: true,
            onRefresh: (self) => {
              if (heroScrollProxyTween) {
                heroScrollProxyTween.progress(self.progress || 0).pause();
              }
              applyHeroScrollProgress({
                section,
                logoContainer,
                imageAsset: videoAsset || imageAsset,
                progress: self.progress || 0,
              });
            },
          });
        } else {
          window.addEventListener('scroll', requestScrollSync, { passive: true });
          requestScrollSync();
        }

        let trigger = null;
        if (window.ScrollTrigger) {
          trigger = window.ScrollTrigger.create({
            trigger: section,
            start: 'top 80%',
            once: true,
            onEnter: () => {
              playTimeline();
            },
          });
        } else {
          window.requestAnimationFrame(() => {
            playTimeline();
          });
        }

        cleanups.set(section, () => {
          if (trigger) trigger.kill();
          if (timeline) timeline.kill();
          if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          window.removeEventListener('resize', requestPlayedLogoSync);
          window.removeEventListener('scroll', requestScrollSync);
          document.removeEventListener('theme:layout:changed', requestScrollSync);
          if (resizeObserver) resizeObserver.disconnect();
          if (heroScrollTrigger) heroScrollTrigger.kill();
          if (heroScrollProxyTween) heroScrollProxyTween.kill();
          logoContainer.style.opacity = '';
          if (imageAsset) imageAsset.style.transform = '';
          if (videoAsset) {
            videoAsset.style.transform = '';
            videoAsset.style.clipPath = '';
          }
          setHeroTopState(false);
          setHeaderReadyState(false);
          emitHeroHeaderState(section, { ready: false, atTop: true });
          syncHeaderOverlayMode(section, false);
        });

        section.dataset.heroAnimationInitialized = 'true';
      });
    };

    initializeHeroAnimationSection(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeHeroAnimationSection(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-hero-animation-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProductSections = (scope = document) => {
      scope.querySelectorAll('[data-product-section]').forEach((section) => {
        if (section.dataset.productInitialized === 'true') return;

        const form = section.querySelector('[data-product-form]');
        const variantInput = form ? form.querySelector('[data-variant-id-input]') : null;
        const variantsJson = section.querySelector('[data-variants-json]');
        const priceNode = section.querySelector('[data-product-price]');
        const compareNode = section.querySelector('[data-product-compare]');
        const skuNodes = Array.from(section.querySelectorAll('[data-product-sku]'));
        const availabilityNodes = Array.from(section.querySelectorAll('[data-product-availability]'));
        const inventoryNodes = Array.from(section.querySelectorAll('[data-product-inventory-status]'));
        const addButton = section.querySelector('[data-add-to-cart]');
        const addButtonLabel = addButton ? addButton.querySelector('[data-add-to-cart-text]') : null;
        const buyButtonsBlock = section.querySelector('.product-page__block--buy-buttons');
        const formMessage = section.querySelector('[data-product-form-message]');
        const optionGroups = form ? Array.from(form.querySelectorAll('[data-product-option]')) : [];
        const featuredItems = Array.from(section.querySelectorAll('[data-media-id].product-page__featured-item'));
        const mediaThumbs = Array.from(section.querySelectorAll('[data-media-thumb]'));
        const mediaIndicators = Array.from(section.querySelectorAll('[data-media-indicator]'));
        const featuredPreviousButtons = Array.from(section.querySelectorAll('[data-featured-prev]'));
        const featuredNextButtons = Array.from(section.querySelectorAll('[data-featured-next]'));
        const featuredTrack = section.querySelector('[data-featured-track]');
        const mediaModal = section.querySelector('[data-media-modal]');
        const mediaModalViewport = mediaModal ? mediaModal.querySelector('[data-media-modal-viewport]') : null;
        const mediaModalTrack = mediaModal ? mediaModal.querySelector('[data-media-modal-track]') : null;
        const mediaModalSlides = mediaModal ? Array.from(mediaModal.querySelectorAll('[data-media-modal-slide]')) : [];
        const mediaModalCloseButton = mediaModal ? mediaModal.querySelector('.product-page__media-modal-close') : null;
        const mediaModalCloseButtons = mediaModal ? Array.from(mediaModal.querySelectorAll('[data-media-modal-close]')) : [];
        const mediaModalPreviousButton = mediaModal ? mediaModal.querySelector('[data-media-modal-prev]') : null;
        const mediaModalNextButton = mediaModal ? mediaModal.querySelector('[data-media-modal-next]') : null;
        const mediaModalCount = mediaModal ? mediaModal.querySelector('[data-media-modal-count]') : null;
        const modalTriggerItems = featuredItems.filter((item) => item.dataset.mediaModalTrigger === 'true');
        const contactFieldsBlocks = Array.from(section.querySelectorAll('[data-contact-fields-block]'));
        const contactStatusNodes = Array.from(section.querySelectorAll('[data-contact-form-status]'));
        const archiveHero = section.querySelector('[data-product-archive-hero]');
        const archiveHeroTitle = section.querySelector('[data-product-archive-fit]');
        const archiveHeroShell = section.querySelector('[data-product-archive-hero-shell]');
        const infoColumn = section.querySelector('[data-product-info-column]');

        if (!form || !variantInput || !variantsJson) return;

        if (!form.getAttribute('action')) {
          form.setAttribute('action', section.dataset.cartAddUrl || '/cart/add');
        }
        form.setAttribute('method', 'post');

        let variants = [];
        try {
          variants = JSON.parse(variantsJson.textContent || '[]');
        } catch {
          variants = [];
        }

        let lastFeaturedTrackScrollAt = 0;
        let lastFeaturedSwipeAt = 0;
        let activeModalIndex = 0;
        let lastModalFocusedElement = null;
        let modalSwipe = null;
        let activeModalPointerId = null;
        let featuredSwipe = null;
        let activeFeaturedPointerId = null;
        let archiveHeroFitRaf = 0;
        let archiveHeroResizeObserver = null;

        const getLookupText = (lookupAttr, variantId) => {
          if (!variantId) return '';
          const lookup = section.querySelector(`[${lookupAttr}="${variantId}"]`);
          return lookup ? lookup.textContent.trim() : '';
        };

        const setFormMessage = (message, tone = 'success') => {
          if (!formMessage) return;
          formMessage.textContent = message || '';
          formMessage.classList.remove('is-error', 'is-success');
          formMessage.classList.add(tone === 'error' ? 'is-error' : 'is-success');
          formMessage.hidden = !message;
        };

        const clearFormMessage = () => {
          if (!formMessage) return;
          formMessage.hidden = true;
          formMessage.textContent = '';
          formMessage.classList.remove('is-error', 'is-success');
        };

        const setContactBlockMessage = (block, message, tone = 'success') => {
          if (!(block instanceof HTMLElement)) return;
          const messageNode = block.querySelector('[data-product-contact-message]');
          if (!messageNode) return;
          messageNode.textContent = message || '';
          messageNode.classList.remove('is-error', 'is-success');
          if (message) {
            messageNode.classList.add(tone === 'error' ? 'is-error' : 'is-success');
          }
          messageNode.hidden = !message;
        };

        const syncContactBlockStatuses = () => {
          contactFieldsBlocks.forEach((block) => setContactBlockMessage(block, ''));

          contactStatusNodes.forEach((statusNode) => {
            if (!(statusNode instanceof HTMLElement)) return;
            const formId = statusNode.dataset.contactFormStatus;
            if (!formId) return;
            const block = section.querySelector(`[data-contact-form-id="${formId}"]`);
            if (!(block instanceof HTMLElement)) return;
            const tone = statusNode.dataset.contactFormTone === 'error' ? 'error' : 'success';
            const messageNode = block.querySelector('[data-product-contact-message]');
            if (!messageNode) return;
            messageNode.innerHTML = statusNode.innerHTML;
            messageNode.classList.remove('is-error', 'is-success');
            messageNode.classList.add(tone === 'error' ? 'is-error' : 'is-success');
            messageNode.hidden = false;
          });
        };

        const fitArchiveHeroTitle = () => {
          if (!archiveHeroTitle) return;

          const min = Number(archiveHeroTitle.dataset.fitMin) || 40;
          const max = Number(archiveHeroTitle.dataset.fitMax) || 2400;
          const nowrap = archiveHeroTitle.dataset.fitNowrap === 'true';
          const targetCharacters = Number(archiveHeroTitle.dataset.fitTargetCharacters) || 0;
          const availableWidth = archiveHeroTitle.clientWidth;
          const isMobile = window.matchMedia('(max-width: 749px)').matches;

          if (!availableWidth) return;

          const getLineMetrics = () => {
            const range = document.createRange();
            range.selectNodeContents(archiveHeroTitle);

            const rawRects = Array.from(range.getClientRects()).filter((rect) => rect.width > 1 && rect.height > 1);
            const lines = [];

            rawRects.forEach((rect) => {
              const existingLine = lines.find((line) => Math.abs(line.top - rect.top) < 2);

              if (existingLine) {
                existingLine.left = Math.min(existingLine.left, rect.left);
                existingLine.right = Math.max(existingLine.right, rect.right);
                existingLine.top = Math.min(existingLine.top, rect.top);
                existingLine.bottom = Math.max(existingLine.bottom, rect.bottom);
                return;
              }

              lines.push({
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right,
              });
            });

            if (typeof range.detach === 'function') {
              range.detach();
            }

            if (!lines.length) {
              return {
                lineCount: 1,
                widestLine: Math.ceil(archiveHeroTitle.getBoundingClientRect().width),
              };
            }

            return {
              lineCount: lines.length,
              widestLine: Math.ceil(
                lines.reduce((widest, line) => Math.max(widest, line.right - line.left), 0)
              ),
            };
          };

          const setWrappedLetterSpacing = (lineCount) => {
            if (!isMobile) {
              archiveHeroTitle.style.setProperty('letter-spacing', '1rem', 'important');
              return;
            }

            if (lineCount <= 1) {
              archiveHeroTitle.style.setProperty('letter-spacing', '1rem', 'important');
              return;
            }

            if (lineCount === 2) {
              archiveHeroTitle.style.setProperty('letter-spacing', '0.22rem', 'important');
              return;
            }

            if (lineCount === 3) {
              archiveHeroTitle.style.setProperty('letter-spacing', '0.12rem', 'important');
              return;
            }

            archiveHeroTitle.style.setProperty('letter-spacing', '0.06rem', 'important');
          };

          const setNoWrapLetterSpacing = (fontSize) => {
            const safeMax = Math.max(max, 1);
            const minSpacing = 0.12;
            const scaledSpacing = Math.max(minSpacing, Math.min(1, fontSize / safeMax));
            archiveHeroTitle.style.setProperty('letter-spacing', `${scaledSpacing.toFixed(3)}rem`, 'important');
          };

          if (!nowrap) {
            archiveHeroTitle.style.fontSize = `${max}px`;
            setWrappedLetterSpacing(getLineMetrics().lineCount);

            if (!isMobile) {
              archiveHeroTitle.style.fontSize = `clamp(${min}px, 10vw, ${max}px)`;
              return;
            }

            const normalizedText = (archiveHeroTitle.textContent || '')
              .trim()
              .replace(/\s+/g, ' ');
            const wordCount = normalizedText
              .split(/\s+/)
              .filter(Boolean).length;
            const preferredLineCount = targetCharacters > 0
              ? Math.max(1, Math.ceil(normalizedText.length / targetCharacters))
              : wordCount > 1
                ? 2
                : 1;
            archiveHeroTitle.style.fontSize = `${min}px`;
            setWrappedLetterSpacing(getLineMetrics().lineCount);
            const minimumLineCount = getLineMetrics().lineCount;
            const targetLineCount = Math.max(preferredLineCount, minimumLineCount);

            let low = min;
            let high = max;
            let best = min;

            while (high - low > 0.5) {
              const mid = (low + high) / 2;
              archiveHeroTitle.style.fontSize = `${mid}px`;
              setWrappedLetterSpacing(getLineMetrics().lineCount);

              const { lineCount, widestLine } = getLineMetrics();

              if (lineCount <= targetLineCount && widestLine <= availableWidth) {
                best = mid;
                low = mid;
              } else {
                high = mid;
              }
            }

            archiveHeroTitle.style.fontSize = `${Math.max(min, Math.min(max, best))}px`;
            setWrappedLetterSpacing(getLineMetrics().lineCount);
            return;
          }

          let low = min;
          let high = max;
          let best = min;

          archiveHeroTitle.style.fontSize = `${max}px`;
          setNoWrapLetterSpacing(max);

          while (high - low > 0.5) {
            const mid = (low + high) / 2;
            archiveHeroTitle.style.fontSize = `${mid}px`;
            setNoWrapLetterSpacing(mid);

            if (archiveHeroTitle.scrollWidth <= availableWidth) {
              best = mid;
              low = mid;
            } else {
              high = mid;
            }
          }

          const finalSize = Math.max(min, Math.min(max, best));
          archiveHeroTitle.style.fontSize = `${finalSize}px`;
          setNoWrapLetterSpacing(finalSize);
        };

        const scheduleArchiveHeroFitPasses = (frames = 6) => {
          if (!archiveHeroTitle) return;

          let remaining = frames;
          const tick = () => {
            fitArchiveHeroTitle();
            remaining -= 1;
            if (remaining > 0) {
              requestAnimationFrame(tick);
            }
          };

          requestAnimationFrame(tick);
        };

        const scheduleArchiveHeroFit = (frames = 6) => {
          if (!archiveHero) return;
          if (archiveHeroFitRaf) cancelAnimationFrame(archiveHeroFitRaf);
          archiveHeroFitRaf = requestAnimationFrame(() => {
            archiveHeroFitRaf = 0;
            scheduleArchiveHeroFitPasses(frames);
          });
        };

        const runArchiveHeroIntro = () => {
          if (!archiveHero) return;

          if (!window.gsap || !archiveHeroTitle || !archiveHeroShell || !infoColumn) {
            section.classList.remove('product-page--archive-hero-pending');
            return;
          }

          window.gsap.set(archiveHeroTitle, { autoAlpha: 0, y: 64 });
          window.gsap.set(archiveHeroShell, { autoAlpha: 0, y: 40, scale: 0.9, transformOrigin: '50% 50%' });
          window.gsap.set(infoColumn, { autoAlpha: 0, y: 24 });
          section.classList.remove('product-page--archive-hero-pending');

          window.gsap
            .timeline({ defaults: { overwrite: 'auto' } })
            .to(archiveHeroTitle, {
              autoAlpha: 1,
              y: 0,
              duration: 1.75,
              ease: 'power4.out',
            })
            .to(
              archiveHeroShell,
              {
                autoAlpha: 1,
                y: 0,
                scale: 1,
                duration: 1.2,
                ease: 'power3.out',
              },
              1.25
            )
            .to(
              infoColumn,
              {
                autoAlpha: 1,
                y: 0,
                duration: 0.9,
                ease: 'power2.out',
              },
              1.35
            );
        };

        const getSelectedOptions = () => {
          return optionGroups.map((group) => {
            const select = group.querySelector('select');
            if (select) {
              if (!select.value && select.options.length > 0) {
                const firstEnabledIndex = Array.from(select.options).findIndex((option) => !option.disabled);
                select.selectedIndex = firstEnabledIndex >= 0 ? firstEnabledIndex : 0;
              }
              return select.value;
            }
            const checked = group.querySelector('input[type="radio"]:checked:not(:disabled)');
            if (checked) return checked.value;
            const firstEnabledRadio = group.querySelector('input[type="radio"]:not(:disabled)');
            if (firstEnabledRadio) {
              firstEnabledRadio.checked = true;
              return firstEnabledRadio.value;
            }
            const firstRadio = group.querySelector('input[type="radio"]');
            if (firstRadio) {
              firstRadio.checked = true;
              return firstRadio.value;
            }
            return '';
          });
        };

        const setSelectedOptionLabels = () => {
          optionGroups.forEach((group) => {
            const selectedLabelNode = group.querySelector('[data-option-selected]');
            if (!selectedLabelNode) return;
            const select = group.querySelector('select');
            if (select) {
              selectedLabelNode.textContent = select.value;
              return;
            }
            const checked = group.querySelector('input[type="radio"]:checked');
            selectedLabelNode.textContent = checked ? checked.value : '';
          });
        };

        const findVariantFromSelections = () => {
          if (optionGroups.length === 0) {
            const currentId = variantInput ? String(variantInput.value || '') : '';
            return variants.find((variant) => String(variant.id) === currentId) || variants[0] || null;
          }

          const selections = getSelectedOptions();
          if (selections.some((value) => value === '')) return null;
          return (
            variants.find((variant) => {
              return variant.options.every((optionValue, index) => optionValue === selections[index]);
            }) || null
          );
        };

        const getMediaIndex = (mediaId) => {
          if (!mediaId) return -1;
          return featuredItems.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
        };

        const getModalSlideIndex = (mediaId) => {
          if (!mediaId) return -1;
          return mediaModalSlides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        };

        const isMediaModalOpen = () => {
          return Boolean(mediaModal && mediaModal.hidden === false);
        };

        const getModalViewportWidth = () => {
          if (!mediaModalViewport) return 1;
          return Math.max(mediaModalViewport.clientWidth, 1);
        };

        const pauseInactiveModalMedia = () => {
          mediaModalSlides.forEach((slide, index) => {
            if (index === activeModalIndex) return;
            slide.querySelectorAll('video').forEach((video) => {
              try {
                video.pause();
              } catch {
                // Ignore media pause failures for non-standard embeds.
              }
            });
          });
        };

        const updateModalCounter = () => {
          if (!mediaModalCount) return;
          mediaModalCount.textContent = `${activeModalIndex + 1} / ${mediaModalSlides.length}`;
        };

        const updateModalNavigationState = () => {
          if (mediaModalPreviousButton) {
            mediaModalPreviousButton.disabled = mediaModalSlides.length < 2 || activeModalIndex === 0;
          }

          if (mediaModalNextButton) {
            mediaModalNextButton.disabled = mediaModalSlides.length < 2 || activeModalIndex === mediaModalSlides.length - 1;
          }
        };

        const renderModalTrack = (offset = 0) => {
          if (!mediaModalTrack) return;
          mediaModalTrack.style.transition = 'none';
          const translateX = activeModalIndex * getModalViewportWidth() * -1 + offset;
          mediaModalTrack.style.transform = `translate3d(${translateX}px, 0, 0)`;
        };

        const setModalSlide = (index) => {
          if (!mediaModalSlides.length) return;
          activeModalIndex = Math.max(0, Math.min(index, mediaModalSlides.length - 1));

          mediaModalSlides.forEach((slide, slideIndex) => {
            slide.setAttribute('aria-hidden', slideIndex === activeModalIndex ? 'false' : 'true');
          });

          updateModalCounter();
          updateModalNavigationState();
          renderModalTrack(0);
          pauseInactiveModalMedia();
        };

        const openMediaModal = (mediaId) => {
          if (!mediaModal || !mediaModalSlides.length) return;

          const activeFeaturedItem = featuredItems.find((item) => item.classList.contains('is-active'));
          const fallbackIndex = getModalSlideIndex(activeFeaturedItem ? activeFeaturedItem.dataset.mediaId : '');
          const requestedIndex = getModalSlideIndex(mediaId);
          activeModalIndex = requestedIndex >= 0 ? requestedIndex : Math.max(fallbackIndex, 0);
          lastModalFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

          mediaModal.hidden = false;
          mediaModal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('theme-product-media-modal-open');
          document.body.classList.add('theme-product-media-modal-open');
          mediaModal.classList.add('is-visible');
          setModalSlide(activeModalIndex);
          if (mediaModalCloseButton) {
            mediaModalCloseButton.focus({ preventScroll: true });
          }
        };

        const closeMediaModal = () => {
          if (!mediaModal || mediaModal.hidden) return;

          activeModalPointerId = null;
          modalSwipe = null;
          mediaModal.classList.remove('is-visible');
          mediaModal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('theme-product-media-modal-open');
          document.body.classList.remove('theme-product-media-modal-open');
          mediaModal.hidden = true;
          mediaModalSlides.forEach((slide) => {
            slide.querySelectorAll('video').forEach((video) => {
              try {
                video.pause();
              } catch {
                // Ignore media pause failures for non-standard embeds.
              }
            });
          });

          if (lastModalFocusedElement) {
            lastModalFocusedElement.focus({ preventScroll: true });
          }
        };

        const shouldIgnoreModalGestureTarget = (target) => {
          if (!(target instanceof Element)) return false;
          return Boolean(target.closest('button, a, video, iframe, model-viewer'));
        };

        const startModalSwipe = (clientX, clientY) => {
          if (!isMediaModalOpen() || mediaModalSlides.length < 2) return;

          modalSwipe = {
            startX: clientX,
            currentX: clientX,
            startY: clientY,
            axis: null,
          };

          renderModalTrack(0);
        };

        const moveModalSwipe = (clientX, clientY, event) => {
          if (!modalSwipe) return;

          const deltaX = clientX - modalSwipe.startX;
          const deltaY = clientY - modalSwipe.startY;
          modalSwipe.currentX = clientX;

          if (!modalSwipe.axis) {
            if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
            modalSwipe.axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          }

          if (modalSwipe.axis !== 'x') return;

          if (event.cancelable) {
            event.preventDefault();
          }

          const atStart = activeModalIndex === 0 && deltaX > 0;
          const atEnd = activeModalIndex === mediaModalSlides.length - 1 && deltaX < 0;
          const resistance = atStart || atEnd ? 0.35 : 1;
          renderModalTrack(deltaX * resistance);
        };

        const endModalSwipe = () => {
          if (!modalSwipe) return;

          const deltaX = modalSwipe.currentX - modalSwipe.startX;
          const swipeThreshold = Math.min(120, getModalViewportWidth() * 0.16);
          const shouldAdvance = modalSwipe.axis === 'x' && Math.abs(deltaX) > swipeThreshold;

          if (shouldAdvance) {
            setModalSlide(activeModalIndex + (deltaX < 0 ? 1 : -1));
          } else {
            setModalSlide(activeModalIndex);
          }

          modalSwipe = null;
        };

        const usesSliderMode = () => {
          return (
            window.innerWidth < 750 ||
            section.classList.contains('product-page--desktop-media-slider') ||
            section.classList.contains('product-page--desktop-media-stack')
          );
        };

        const usesArchiveHeroFadeMode = () => {
          return section.classList.contains('product-page--desktop-media-archive-hero');
        };

        const shouldIgnoreFeaturedGestureTarget = (target) => {
          if (!(target instanceof Element)) return false;
          return Boolean(target.closest('button, a, video, iframe, model-viewer, input, select, textarea'));
        };

        const setActiveMediaState = (targetId) => {
          const behavesLikeSingleActiveMedia = usesSliderMode() || usesArchiveHeroFadeMode();
          const activeIndex = featuredItems.findIndex((item) => String(item.dataset.mediaId) === String(targetId));

          featuredItems.forEach((item) => {
            const active = String(item.dataset.mediaId) === String(targetId);
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-hidden', behavesLikeSingleActiveMedia ? (active ? 'false' : 'true') : 'false');
            if (item.dataset.mediaModalTrigger === 'true') {
              item.setAttribute('tabindex', behavesLikeSingleActiveMedia ? (active ? '0' : '-1') : '0');
            }
          });

          mediaThumbs.forEach((thumb) => {
            const active = String(thumb.dataset.mediaId) === String(targetId);
            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-selected', active ? 'true' : 'false');
            thumb.setAttribute('tabindex', active ? '0' : '-1');
          });

          mediaIndicators.forEach((indicator) => {
            const active = String(indicator.dataset.mediaId) === String(targetId);
            indicator.classList.toggle('is-active', active);
            indicator.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          featuredPreviousButtons.forEach((button) => {
            button.disabled = featuredItems.length < 2 || activeIndex <= 0;
          });

          featuredNextButtons.forEach((button) => {
            button.disabled = featuredItems.length < 2 || activeIndex === -1 || activeIndex >= featuredItems.length - 1;
          });
        };

        const setFeaturedMedia = (mediaId, behavior = 'auto') => {
          if (!mediaId || !featuredTrack) return;
          const targetId = String(mediaId);
          const targetItem = featuredItems.find((item) => String(item.dataset.mediaId) === targetId);
          if (!targetItem) return;

          setActiveMediaState(targetId);

          if (usesArchiveHeroFadeMode()) {
            return;
          }

          if (usesSliderMode()) {
            featuredTrack.scrollTo({
              left: targetItem.offsetLeft,
              behavior,
            });
          }
        };

        const getActiveFeaturedIndex = () => {
          const activeIndex = featuredItems.findIndex((item) => item.classList.contains('is-active'));
          return activeIndex >= 0 ? activeIndex : 0;
        };

        const setFeaturedMediaByIndex = (index, behavior = 'auto') => {
          if (!featuredItems.length) return;
          const nextIndex = Math.max(0, Math.min(index, featuredItems.length - 1));
          const nextItem = featuredItems[nextIndex];
          if (!nextItem) return;
          setFeaturedMedia(nextItem.dataset.mediaId, behavior);
        };

        const startFeaturedSwipe = (clientX, clientY) => {
          if (!usesArchiveHeroFadeMode() || window.innerWidth >= 750 || featuredItems.length < 2) return;

          featuredSwipe = {
            startX: clientX,
            currentX: clientX,
            startY: clientY,
            axis: null,
          };
        };

        const moveFeaturedSwipe = (clientX, clientY, event) => {
          if (!featuredSwipe) return;

          const deltaX = clientX - featuredSwipe.startX;
          const deltaY = clientY - featuredSwipe.startY;
          featuredSwipe.currentX = clientX;

          if (!featuredSwipe.axis) {
            if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;
            featuredSwipe.axis = Math.abs(deltaX) > Math.abs(deltaY) ? 'x' : 'y';
          }

          if (featuredSwipe.axis !== 'x') return;

          if (event.cancelable) {
            event.preventDefault();
          }
        };

        const endFeaturedSwipe = () => {
          if (!featuredSwipe) return;

          const deltaX = featuredSwipe.currentX - featuredSwipe.startX;
          const swipeThreshold = Math.min(
            120,
            Math.max(
              featuredTrack ? featuredTrack.clientWidth : 0,
              archiveHeroShell ? archiveHeroShell.clientWidth : 0,
              1
            ) * 0.16
          );
          const shouldAdvance = featuredSwipe.axis === 'x' && Math.abs(deltaX) > swipeThreshold;

          if (featuredSwipe.axis === 'x' && Math.abs(deltaX) > 10) {
            lastFeaturedSwipeAt = Date.now();
          }

          if (shouldAdvance) {
            setFeaturedMediaByIndex(getActiveFeaturedIndex() + (deltaX < 0 ? 1 : -1), 'auto');
          }

          featuredSwipe = null;
        };

        const syncActiveMediaFromScroll = () => {
          if (!featuredTrack || featuredItems.length < 2) return;
          if (usesArchiveHeroFadeMode()) {
            return;
          }
          if (!usesSliderMode()) {
            featuredItems.forEach((item) => {
              item.setAttribute('aria-hidden', 'false');
              if (item.dataset.mediaModalTrigger === 'true') {
                item.setAttribute('tabindex', '0');
              }
            });
            return;
          }
          let nextItem = featuredItems[0];
          let minDistance = Number.POSITIVE_INFINITY;

          featuredItems.forEach((item) => {
            const distance = Math.abs(item.offsetLeft - featuredTrack.scrollLeft);
            if (distance < minDistance) {
              minDistance = distance;
              nextItem = item;
            }
          });

          if (!nextItem) return;
          setActiveMediaState(nextItem.dataset.mediaId);
        };

        const updateAddButtonState = (variant) => {
          if (!addButton || !addButtonLabel || !buyButtonsBlock) return;

          const addText = buyButtonsBlock.dataset.addToCartText || 'Add to cart';
          const soldOutText = buyButtonsBlock.dataset.soldOutText || 'Sold out';
          const unavailableText = buyButtonsBlock.dataset.unavailableText || 'Unavailable';

          if (!variant) {
            addButton.disabled = true;
            addButtonLabel.textContent = unavailableText;
            return;
          }

          if (!variant.available) {
            addButton.disabled = true;
            addButtonLabel.textContent = soldOutText;
            return;
          }

          addButton.disabled = false;
          addButtonLabel.textContent = addText;
        };

        const updateContactFieldsVisibility = (variant) => {
          contactFieldsBlocks.forEach((block) => {
            const shouldHideWhenSoldOut = block.dataset.hideWhenSoldOut === 'true';
            if (!shouldHideWhenSoldOut) return;

            const shouldHide = !variant || !variant.available;
            block.hidden = shouldHide;
          });
        };

        const updateAvailabilityState = (variant) => {
          availabilityNodes.forEach((node) => {
            const inStockText = node.dataset.inStockText || 'In stock';
            const outOfStockText = node.dataset.outOfStockText || 'Out of stock';
            node.textContent = variant && variant.available ? inStockText : outOfStockText;
          });
        };

        const updateInventoryState = (variant) => {
          inventoryNodes.forEach((node) => {
            const labelNode = node.querySelector('[data-product-inventory-label]');
            if (!labelNode) return;

            const inStockText = node.dataset.inStockText || 'In stock';
            const lowStockText = node.dataset.lowStockText || 'Only {count} left';
            const outOfStockText = node.dataset.outOfStockText || 'Out of stock';
            const backorderText = node.dataset.backorderText || 'Available on backorder';
            const lowStockThreshold = Number.parseInt(node.dataset.lowStockThreshold || '5', 10);

            if (!variant) {
              node.dataset.inventoryState = 'out-of-stock';
              labelNode.textContent = outOfStockText;
              return;
            }

            const inventoryQuantity =
              typeof variant.inventory_quantity === 'number'
                ? variant.inventory_quantity
                : Number.parseInt(variant.inventory_quantity || '0', 10);
            const inventoryManaged =
              typeof variant.inventory_management === 'string' && variant.inventory_management.trim() !== '';
            const inventoryPolicy = typeof variant.inventory_policy === 'string' ? variant.inventory_policy : '';

            if (!variant.available) {
              node.dataset.inventoryState = 'out-of-stock';
              labelNode.textContent = outOfStockText;
              return;
            }

            if (inventoryManaged && Number.isFinite(inventoryQuantity) && inventoryQuantity > 0 && inventoryQuantity <= lowStockThreshold) {
              node.dataset.inventoryState = 'low-stock';
              labelNode.textContent = lowStockText.replace('{count}', String(inventoryQuantity));
              return;
            }

            if (!inventoryManaged && inventoryPolicy === 'continue') {
              node.dataset.inventoryState = 'backorder';
              labelNode.textContent = backorderText;
              return;
            }

            node.dataset.inventoryState = 'in-stock';
            labelNode.textContent = inStockText;
          });
        };

        const updateVariantState = ({ syncHistory = true } = {}) => {
          setSelectedOptionLabels();

          const variant = findVariantFromSelections();
          if (!variant) {
            variantInput.value = '';
            if (compareNode) {
              compareNode.textContent = '';
              compareNode.hidden = true;
            }
            skuNodes.forEach((node) => {
              node.textContent = 'N/A';
            });
            updateAvailabilityState(null);
            updateAddButtonState(null);
            updateContactFieldsVisibility(null);
            updateInventoryState(null);
            return;
          }

          variantInput.value = variant.id;
          updateAddButtonState(variant);

          if (priceNode) {
            const nextPrice = getLookupText('data-variant-price', variant.id);
            if (nextPrice) priceNode.textContent = nextPrice;
          }

          if (compareNode) {
            const nextCompare = getLookupText('data-variant-compare', variant.id);
            compareNode.textContent = nextCompare;
            compareNode.hidden = nextCompare === '';
          }

          skuNodes.forEach((node) => {
            node.textContent = variant.sku || 'N/A';
          });
          updateAvailabilityState(variant);
          updateContactFieldsVisibility(variant);
          updateInventoryState(variant);

          if (syncHistory && section.dataset.enableHistory === 'true') {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());
          }
        };

        const syncHeaderCartCount = async () => {
          const rootPath =
            window.Shopify && window.Shopify.routes && typeof window.Shopify.routes.root === 'string'
              ? window.Shopify.routes.root
              : '/';

          try {
            const response = await fetch(`${rootPath}cart.js`, {
              method: 'GET',
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
            });
            if (!response.ok) return;

            const cartData = await response.json();
            const count = Number.parseInt(cartData.item_count || 0, 10);
            const cartLink = document.querySelector('.header__cart-link');
            if (!cartLink) return;

            cartLink.querySelectorAll('[data-header-cart-count]').forEach((countTarget) => {
              countTarget.textContent = String(count);
            });

            const badge = cartLink.querySelector('[data-header-cart-badge]');
            if (badge) {
              badge.hidden = count <= 0;
            }

            cartLink.setAttribute('aria-label', `Cart (${count})`);
          } catch {
            // Keep cart UX resilient even when cart count refresh fails.
          }
        };

        const submitAddToCart = async (event) => {
          if (section.dataset.ajaxAtc !== 'true') return;
          if (!addButton || !buyButtonsBlock) return;
          const submitter = event.submitter instanceof HTMLElement ? event.submitter : null;
          const isAddToCartSubmit =
            submitter && (submitter.matches('[data-add-to-cart]') || submitter.getAttribute('name') === 'add');
          if (!isAddToCartSubmit) return;
          if (typeof window.fetch !== 'function' || typeof window.FormData !== 'function') return;

          event.preventDefault();
          updateVariantState();

          if (!variantInput.value) {
            const unavailableText = buyButtonsBlock.dataset.unavailableText || 'Unavailable';
            setFormMessage(unavailableText, 'error');
            return;
          }

          if (addButton.disabled || addButton.getAttribute('aria-busy') === 'true') return;

          const addText = buyButtonsBlock.dataset.addToCartText || 'Add to cart';
          const addedText = buyButtonsBlock.dataset.addedToCartText || 'Added to cart';

          addButton.setAttribute('aria-busy', 'true');
          addButton.disabled = true;
          clearFormMessage();
          let addedSuccessfully = false;

          try {
            const addEndpoint = (section.dataset.cartAddUrl || '/cart/add').replace(/\/$/, '') + '.js';
            const formData = new FormData(form);
            formData.set('id', variantInput.value);

            if (!formData.get('quantity')) {
              formData.set('quantity', '1');
            }

            const response = await fetch(addEndpoint, {
              method: 'POST',
              headers: { Accept: 'application/json' },
              body: formData,
              credentials: 'same-origin',
            });

            if (!response.ok) {
              let errorText = 'Unable to add this product right now.';
              try {
                const errorData = await response.json();
                errorText = errorData.description || errorData.message || errorData.error || errorText;
              } catch {
                // Ignore JSON parsing errors for non-JSON responses.
              }
              setFormMessage(errorText, 'error');
              return;
            }

            if (addButtonLabel) addButtonLabel.textContent = addedText;
            setFormMessage('Added to cart.', 'success');
            document.dispatchEvent(new CustomEvent('theme:cart-updated', { detail: { source: 'product-page' } }));
            await syncHeaderCartCount();
            addedSuccessfully = true;

            window.setTimeout(() => {
              updateVariantState();
              if (addButtonLabel) addButtonLabel.textContent = addText;
              clearFormMessage();
            }, 900);
          } catch {
            setFormMessage('Unable to add this product right now.', 'error');
          } finally {
            addButton.removeAttribute('aria-busy');
            if (!addedSuccessfully) {
              updateVariantState();
            }
          }
        };

        if (featuredTrack) {
          let ticking = false;
          featuredTrack.addEventListener(
            'scroll',
            () => {
              lastFeaturedTrackScrollAt = Date.now();
              if (ticking) return;
              ticking = true;
              window.requestAnimationFrame(() => {
                syncActiveMediaFromScroll();
                ticking = false;
              });
            },
            { passive: true }
          );

          featuredTrack.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse') return;
            if (shouldIgnoreFeaturedGestureTarget(event.target)) return;

            activeFeaturedPointerId = event.pointerId;
            if (typeof featuredTrack.setPointerCapture === 'function') {
              featuredTrack.setPointerCapture(event.pointerId);
            }
            startFeaturedSwipe(event.clientX, event.clientY);
          });

          featuredTrack.addEventListener('pointermove', (event) => {
            if (activeFeaturedPointerId !== event.pointerId || !featuredSwipe) return;
            moveFeaturedSwipe(event.clientX, event.clientY, event);
          });

          const completeFeaturedPointerSwipe = (event) => {
            if (activeFeaturedPointerId !== event.pointerId) return;
            if (typeof featuredTrack.releasePointerCapture === 'function') {
              featuredTrack.releasePointerCapture(event.pointerId);
            }
            activeFeaturedPointerId = null;
            endFeaturedSwipe();
          };

          featuredTrack.addEventListener('pointerup', completeFeaturedPointerSwipe);
          featuredTrack.addEventListener('pointercancel', completeFeaturedPointerSwipe);
        }

        mediaThumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            setFeaturedMedia(thumb.dataset.mediaId);
          });

          thumb.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            setFeaturedMedia(thumb.dataset.mediaId);
          });
        });

        mediaIndicators.forEach((indicator) => {
          indicator.addEventListener('click', () => {
            setFeaturedMedia(indicator.dataset.mediaId, 'smooth');
          });
        });

        featuredPreviousButtons.forEach((button) => {
          button.addEventListener('click', () => {
            setFeaturedMediaByIndex(getActiveFeaturedIndex() - 1, 'smooth');
          });
        });

        featuredNextButtons.forEach((button) => {
          button.addEventListener('click', () => {
            setFeaturedMediaByIndex(getActiveFeaturedIndex() + 1, 'smooth');
          });
        });

        const shouldSuppressModalOpen = () => {
          return (
            (usesSliderMode() && Date.now() - lastFeaturedTrackScrollAt < 180) ||
            (usesArchiveHeroFadeMode() && Date.now() - lastFeaturedSwipeAt < 280)
          );
        };

        modalTriggerItems.forEach((item) => {
          item.addEventListener('click', () => {
            if (shouldSuppressModalOpen()) return;
            openMediaModal(item.dataset.mediaId);
          });

          item.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            openMediaModal(item.dataset.mediaId);
          });
        });

        mediaModalCloseButtons.forEach((button) => {
          button.addEventListener('click', closeMediaModal);
        });

        if (mediaModalPreviousButton) {
          mediaModalPreviousButton.addEventListener('click', () => {
            setModalSlide(activeModalIndex - 1);
          });
        }

        if (mediaModalNextButton) {
          mediaModalNextButton.addEventListener('click', () => {
            setModalSlide(activeModalIndex + 1);
          });
        }

        if (mediaModal) {
          mediaModal.addEventListener('keydown', (event) => {
            if (!isMediaModalOpen()) return;

            if (event.key === 'Escape') {
              event.preventDefault();
              closeMediaModal();
              return;
            }

            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              setModalSlide(activeModalIndex - 1);
              return;
            }

            if (event.key === 'ArrowRight') {
              event.preventDefault();
              setModalSlide(activeModalIndex + 1);
            }
          });
        }

        if (mediaModalViewport) {
          mediaModalViewport.addEventListener('pointerdown', (event) => {
            if (!isMediaModalOpen()) return;
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            if (shouldIgnoreModalGestureTarget(event.target)) return;

            activeModalPointerId = event.pointerId;
            if (typeof mediaModalViewport.setPointerCapture === 'function') {
              mediaModalViewport.setPointerCapture(event.pointerId);
            }
            startModalSwipe(event.clientX, event.clientY);
          });

          mediaModalViewport.addEventListener('pointermove', (event) => {
            if (activeModalPointerId !== event.pointerId || !modalSwipe) return;
            moveModalSwipe(event.clientX, event.clientY, event);
          });

          const completePointerSwipe = (event) => {
            if (activeModalPointerId !== event.pointerId) return;
            if (typeof mediaModalViewport.releasePointerCapture === 'function') {
              mediaModalViewport.releasePointerCapture(event.pointerId);
            }
            activeModalPointerId = null;
            endModalSwipe();
          };

          mediaModalViewport.addEventListener('pointerup', completePointerSwipe);
          mediaModalViewport.addEventListener('pointercancel', completePointerSwipe);
        }

        form.addEventListener('change', (event) => {
          const target = event.target;
          if (!(target instanceof HTMLElement)) return;
          if (!target.matches('select[name^="options["], input[type="radio"][name^="options["]')) return;
          clearFormMessage();
          updateVariantState();
        });

        form.addEventListener('submit', submitAddToCart);

        if (addButton) {
          addButton.addEventListener('click', (event) => {
            if (addButton.disabled) return;
            if (!variantInput.value) {
              updateVariantState();
              if (!variantInput.value) {
                event.preventDefault();
                addButton.disabled = true;
                window.setTimeout(() => {
                  addButton.disabled = false;
                }, 600);
              }
            }
          });
        }

        syncContactBlockStatuses();
        updateVariantState({ syncHistory: false });
        syncActiveMediaFromScroll();
        if (archiveHero) {
          scheduleArchiveHeroFit(10);
          runArchiveHeroIntro();
          if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(() => scheduleArchiveHeroFit(10)).catch(() => {});
          }
          if ('ResizeObserver' in window) {
            archiveHeroResizeObserver = new ResizeObserver(() => {
              scheduleArchiveHeroFit(8);
            });

            [
              archiveHero,
              archiveHeroTitle.parentElement,
              archiveHeroShell,
              section,
            ].forEach((node) => {
              if (node instanceof Element) {
                archiveHeroResizeObserver.observe(node);
              }
            });
          }
        }
        window.addEventListener(
          'resize',
          () => {
            syncActiveMediaFromScroll();
            scheduleArchiveHeroFit(6);
            if (isMediaModalOpen()) {
              setModalSlide(activeModalIndex);
            }
          },
          { passive: true }
        );
        section.dataset.productInitialized = 'true';
      });
    };

    initializeProductSections(document);

    document.addEventListener('shopify:section:load', (event) => {
      initializeProductSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrubbed-bento-gallery"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const globalKey = '__scrubbedBentoGallery';
    const state = window[globalKey] || {
      instances: new Map(),
      flipLoader: null,
      resizeRaf: null,
      initialized: false,
    };

    window[globalKey] = state;

    const loadFlip = (src) => {
      if (window.Flip) return Promise.resolve();
      if (state.flipLoader) return state.flipLoader;

      state.flipLoader = new Promise((resolve) => {
        const existing = document.querySelector('script[data-gsap-flip]');
        if (existing) {
          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', () => resolve(), { once: true });
          return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.defer = true;
        script.setAttribute('data-gsap-flip', 'true');
        script.addEventListener('load', () => resolve(), { once: true });
        script.addEventListener('error', () => resolve(), { once: true });
        document.head.appendChild(script);
      });

      return state.flipLoader;
    };

    const setupSection = (section) => {
      if (!section || state.instances.has(section)) return;

      const gallery = section.querySelector('[data-bento-gallery]');
      const viewport = section.querySelector('[data-bento-viewport]');
      if (!gallery || !viewport) return;

      let timeline = null;
      let flipTween = null;

      const clear = () => {
        if (timeline) {
          timeline.kill();
          timeline = null;
        }

        if (flipTween) {
          flipTween.kill();
          flipTween = null;
        }

        gallery.classList.remove('is-final');
        if (window.gsap) {
          window.gsap.set(gallery.querySelectorAll('.scrubbed-bento__item'), { clearProps: 'all' });
        }
      };

      const create = async () => {
        if (!window.gsap || !window.ScrollTrigger) return;

        const flipSrc = section.dataset.flipSrc;
        if (!flipSrc) return;

        await loadFlip(flipSrc);
        if (!window.Flip) return;

        clear();

        const items = gallery.querySelectorAll('.scrubbed-bento__item');
        if (items.length < 2) return;

        const scrollLength = Number(section.dataset.scrollLength) || 120;
        const smoothScrollEnabled = document.documentElement.classList.contains('smooth-scroll-active');
        const isTouchLikeViewport = window.matchMedia('(hover: none), (pointer: coarse)').matches;
        const shouldPinViewport = !smoothScrollEnabled && !isTouchLikeViewport;

        window.gsap.registerPlugin(window.ScrollTrigger, window.Flip);

        gallery.classList.add('is-final');
        const flipState = window.Flip.getState(items);
        gallery.classList.remove('is-final');

        flipTween = window.Flip.to(flipState, {
          simple: true,
          ease: 'none',
          absolute: false,
          paused: true,
        });

        timeline = window.gsap.timeline({
          scrollTrigger: {
            trigger: viewport,
            start: 'center center',
            end: `+=${scrollLength}%`,
            scrub: true,
            pin: shouldPinViewport ? viewport : false,
            anticipatePin: 1,
            invalidateOnRefresh: true,
          },
        });

        timeline.to(
          flipTween,
          {
            progress: 1,
            duration: 1,
            ease: 'none',
          },
          0,
        );
      };

      state.instances.set(section, { create, clear });
      create();
    };

    const refreshAll = () => {
      state.instances.forEach((instance) => instance.create());
    };

    if (!state.initialized) {
      state.initialized = true;

      window.addEventListener('resize', () => {
        if (state.resizeRaf) cancelAnimationFrame(state.resizeRaf);
        state.resizeRaf = requestAnimationFrame(refreshAll);
      });

      window.addEventListener('orientationchange', refreshAll);

      document.addEventListener('shopify:section:load', (event) => {
        const sections = event.target.querySelectorAll('.scrubbed-bento');
        sections.forEach((section) => setupSection(section));
        if (event.target.matches && event.target.matches('.scrubbed-bento')) {
          setupSection(event.target);
        }
      });

      document.addEventListener('shopify:section:unload', (event) => {
        state.instances.forEach((instance, section) => {
          if (!event.target.contains(section)) return;
          instance.clear();
          state.instances.delete(section);
        });
      });
    }

    document.querySelectorAll('.scrubbed-bento').forEach((section) => setupSection(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cleanups = window.__videoPopupSectionCleanups || new Map();
    window.__videoPopupSectionCleanups = cleanups;

    const initialize = (target = document) => {
      const sections = target.querySelectorAll('[data-video-popup-section]');

      sections.forEach((section) => {
        if (section.dataset.videoPopupInitialized === 'true') return;

        const trigger = section.querySelector('[data-video-popup-trigger]');
        const dialog = section.querySelector('[data-video-popup-dialog]');
        const closeButton = dialog ? dialog.querySelector('[data-video-popup-close]') : null;
        const iframe = dialog ? dialog.querySelector('[data-video-popup-iframe]') : null;
        const dialogVideo = dialog ? dialog.querySelector('video.video-popup__dialog-media--video') : null;
        let lastFocusedElement = null;

        const stopDialogPlayback = () => {
          if (iframe) {
            iframe.removeAttribute('src');
          }

          if (dialogVideo) {
            dialogVideo.pause();
            dialogVideo.currentTime = 0;
          }
        };

        const openDialog = () => {
          if (!dialog) return;

          lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

          if (typeof dialog.showModal === 'function') {
            if (!dialog.open) dialog.showModal();
          } else {
            dialog.setAttribute('open', 'open');
          }

          if (iframe && iframe.dataset.src) {
            iframe.src = iframe.dataset.src;
          }

          if (dialogVideo) {
            dialogVideo.currentTime = 0;
            const playPromise = dialogVideo.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          }

          if (closeButton) {
            window.requestAnimationFrame(() => closeButton.focus());
          }
        };

        const closeDialog = () => {
          if (!dialog) return;

          if (dialog.open && typeof dialog.close === 'function') {
            dialog.close();
            return;
          }

          dialog.removeAttribute('open');
          stopDialogPlayback();
          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
          }
        };

        const handleTriggerClick = () => openDialog();
        const handleDialogClose = () => {
          stopDialogPlayback();
          if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
            lastFocusedElement.focus();
          }
        };
        const handleBackdropClick = (event) => {
          if (event.target === dialog) closeDialog();
        };
        const handleCloseClick = () => closeDialog();

        if (trigger && dialog && !trigger.disabled) {
          trigger.addEventListener('click', handleTriggerClick);
          dialog.addEventListener('close', handleDialogClose);
          dialog.addEventListener('click', handleBackdropClick);

          if (closeButton) {
            closeButton.addEventListener('click', handleCloseClick);
          }
        }

        cleanups.set(section, () => {
          if (trigger) trigger.removeEventListener('click', handleTriggerClick);
          if (dialog) dialog.removeEventListener('close', handleDialogClose);
          if (dialog) dialog.removeEventListener('click', handleBackdropClick);
          if (closeButton) closeButton.removeEventListener('click', handleCloseClick);
          stopDialogPlayback();
          if (dialog) {
            if (dialog.open && typeof dialog.close === 'function') {
              dialog.close();
            } else {
              dialog.removeAttribute('open');
            }
          }
        });

        section.dataset.videoPopupInitialized = 'true';
      });
    };

    initialize(document);

    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      const section = event.target.querySelector('[data-video-popup-section]') || event.target;
      const cleanup = cleanups.get(section);
      if (cleanup) cleanup();
      cleanups.delete(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
